import { CommonModule } from '@angular/common';
import { navigateWithFreshRoute } from 'src/app/shared/route-reuse.util';
import { Component, ElementRef, HostListener, Input, NO_ERRORS_SCHEMA, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatAutocompleteModule, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
// MatOptgroupModule is not exported from @angular/material/core - using MatOptionModule instead
import { MatMenuModule } from '@angular/material/menu';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from "@angular/router";
import { NgSelectModule } from '@ng-select/ng-select';
import * as CryptoJS from 'crypto-js';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { TypeaheadModule, TypeaheadOrder, TypeaheadConfig } from 'ngx-bootstrap/typeahead';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSummernoteDirective, NgxSummernoteModule } from 'ngx-summernote';
import { Observable, Subject, Subscription, timer } from "rxjs";
import { debounceTime, distinctUntilChanged, filter, take, takeUntil } from 'rxjs/operators';
import { ApiService } from "src/app/services/api.service";
import { AppSettings } from "src/app/services/AppSettings";
import { CommonValues } from "src/app/services/commonValues";
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants, USER_TYPE } from 'src/app/services/GigsumoConstants';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { HealthCareOrganization } from 'src/app/services/HealthCareOrganization';
import { JobService } from 'src/app/services/job.service';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { ProfilePhoto } from "src/app/services/profilePhoto";
import { ResumeDataMapperService } from 'src/app/services/resume-data-mapper.service';
import { ResumeParserService } from 'src/app/services/resume-parser.service';
import { SearchData } from "src/app/services/searchData";
import { WorkExperience } from 'src/app/services/userModel';
import { UserService } from 'src/app/services/UserService';
import { UtilService } from "src/app/services/util.service";
import { environment } from 'src/environments/environment';
import Swal from "sweetalert2";
import { FilterPipe } from '../../pipe/filter.pipe';
import { TruncatePipe } from '../../pipe/TruncatePipe.pipe';
import { CurrentOrganizationProviderService } from "../../services/current-organization-provider.service";
import { CustomValidator } from '../Helper/custom-validator';
import { PricePlanService } from '../Price-subscritions/priceplanService';
import { StreamService } from './../../services/stream.service';
import { CacheInvalidationService } from '../../services/cache-invalidation.service';
import { JobdescriptionparsingService } from 'src/app/services/jobdescriptionparsing.service';

// Standalone component imports
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { WorkexperienceModalComponent } from '../../page/model/workexperience-modal/workexperience-modal.component';
import { GlobalCommunity } from '../../services/globalCommunity.service';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { TimezoneDatePipe } from '../../timezone-date.pipe';
import { TimezonepopupComponent } from '../../timezonepopup/timezonepopup.component';
import { MessageWidgetComponent } from '../../widget/message-widget/message-widget.component';
import { ScrollToTopComponent } from '../../widget/scroll-to-top/scroll-to-top.component';
import { CarouselComponent } from '../carousel/carousel.component';
import { FlagComponent } from '../flag/flag.component';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';



declare var $: any;
type Location = {
  country: string,
  state: string,
  city: string;
  zipCode: string,

}
@Component({
  selector: "app-bussiness-post",
  standalone: true,
  imports: [BsDropdownModule, 
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatOptionModule,
    NgxPaginationModule,
    NgSelectModule,
    InfiniteScrollModule,
    TypeaheadModule,
    NgxSummernoteModule,
    FilterPipe,
    TruncatePipe,
    CommonSkeletonComponent,
    ScrollToTopComponent,
WorkexperienceModalComponent,
    FlagComponent,
    TimezonepopupComponent,
    MessageWidgetComponent,
    CarouselComponent,
    TimezoneDatePipe,
    ImageCropperModule,
    DndDirective
  ,
    NG_ICON_DIRECTIVES,
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: "./bussiness-post.component.html",
  styleUrls: ["./bussiness-post.component.scss"],
  providers: [TypeaheadConfig],
  animations: [

  ]
})
export class BussinessPostComponent extends FormValidation implements OnInit, OnDestroy {
  show = false;
  creditform: UntypedFormGroup;
  submited: boolean = false;
  public FORMERROR = super.Form;
  getclickStatus: boolean = true;
  selectedJobTitle: string;

  // sharecmd:any ={}
  public animState = 'right'
  public animState0 = 'middle'
  public animState1 = 'right'
  public animState2 = 'right'
  sharecmd;
  @ViewChild("myFileInputoo") myFileInputoo;
  @ViewChild("myFileInput1") myFileInput1;
  @ViewChild("myFileInput2") myFileInput2;
  @ViewChild("myFileInput3") myFileInput3;
  @ViewChild("myFileInput4") myFileInput4;
  @ViewChild("myFileInputcandidate") myFileInputcandidate;
  @ViewChild("postTemplate") postTemplate;
  imageChangedEvent: any = "";
  fileUploadName;
  fileshow = undefined;
  fileToUpload: File;
  photoId: any;
  infoData: any = {};
  photo: any = null;
  url = AppSettings.ServerUrl + "download/";
  nodata = "you have no post yet"
  noDatafound: Array<string> = ["No data Found"]
  datass: any;
  bannerdata;
  admindata;
  adminflag: Boolean;
  count = 0;
  fileSize = AppSettings.FILE_SIZE;
  clickEventsubscription: Subscription;
  streamSubcr: Subscription;
  subscription: Subscription;
  adminviewflag;
  values: any = {};
  loadApicall: boolean = false;
  menu;
  @Input() commonemit;
  @Input() ownerView;
  @Input() postView;
  registerForm: UntypedFormGroup;
  jobPostForm: UntypedFormGroup;
  candidatePostForm: UntypedFormGroup;
  submitted = false;
  postdatas: any = {};
  commanddata = null;
  urlLinkDetctForm: UntypedFormGroup
  commanddata1 = null;
  commanddataEdit = null;
  primarySkillsSelected = [];
  secondarySkillsSelected = [];
  otherSelectedStates = [];
  imagEditData: any = [];
  imagEditDatatemp: any = [];
  posteditId: any;
  typesofFile: any;
  userData;
  contentLoaded: boolean = false;
  tempdata;
  shareData;
  commentData;
  tempdataforscroll;
  userDatascroll;
  data = 10;
  showModal: boolean = false;
  counts: number = 0;
  Commomdatass;
  throttle = 50;
  scrollDistance = 1;
  cunt: number = 0;
  businessId: any
  networkId: any
  teamId: any
  communityid: any
  postId: any;
  postflags = false;
  disable_for_draft: boolean = false;
  FormData: any;
  uploadFiles: Array<any> = [];
  streamData: any = [];
  resumeupload;
  unit = { duration: '30' };
  wordlength: any = 0;
  attachment = false;
  modalRef: BsModalRef;
  modalRefedit: BsModalRef;
  modalRef_PostView: BsModalRef;
  shareModalTemplate: TemplateRef<any> | null = null;
  modelList: any = [];
  // Cursor pagination state for the Connections multi-select modal.
  // Mirrors `/connection` page's pattern: send `searchAfterKey` to the
  // server, append the next batch on each page advance, stop when the
  // server returns no further key (or repeats the previous one).
  connectionAfterKey: any = null;
  private connectionPrevAfterKey: any = null;
  connectionLoadingMore = false;
  connectionsHasMore = false;
  // Same cursor mechanism for the Network tab — `network/home` returns a
  // `searchAfterKey` we ship back on each scroll-to-bottom to pull the next
  // page (was previously a one-shot limit:10 fetch that clipped at 10 rows).
  networkAfterKey: any = null;
  private networkPrevAfterKey: any = null;
  networkLoadingMore = false;
  networkHasMore = false;
  // Server-side search for the post-privacy modal lists (Connections /
  // Network / Community). Each keystroke on the modal search input pushes
  // into `modalSearchSubject`; the debounced subscriber re-queries the
  // active tab so search spans all records, not just the loaded batch.
  // Regression context: commit 3b9d9a3df switched Connections to cursor
  // pagination but kept only the client-side `| filter:` pipe, so search
  // stopped seeing records past the first 12 rows.
  modalSearchTerm: string = '';
  private modalSearchSubject = new Subject<string>();
  private modalSearchSub?: Subscription;
  currentTimeDate: string | Date;
  checkedList: any = [];
  tempcheckedList: any = [];
  page: number = 1;
  postviewModelName: any;
  imgUrl = AppSettings.photoUrl;
  postPrivacy = "Everyone";
  PhotoPath = AppSettings.photoUrl;
  searchName: any;
  htmlStr: any;
  currentDate: any = [];
  maxDate: any = [];
  jobscoutss: any;
  sendMessageData = {};
  entername;
  singleimagedata;
  showmodel = false;
  jobStreamData: any = [];
  canidateStreamData: any = [];
  rxjsTimer = timer(AppSettings.timerSocket);
  destroy = new Subject();
  streamRes: any = null;
  config1 = {
    focus: true,
    height: 150,
    placeholder: "Start a conversation....",
    toolbar: [],
    link: [["link", ["linkDialogShow", "unlink"]]],
    insert: ["link", "picture", "video"],
    view: ["fullscreen", "codeview", "help"],
    style:
      "outline: none !important;background-color: rgb(241 243 246) !important;cursor: pointer !important;",
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    callbacks: {
      onFocus: function (contents) {
        if ($(this).summernote("isEmpty")) {
          $("#summessage").html(""); //either the class (.) or id (#) of your textarea or summernote element
        }
      },
      onPaste: function (e:any) {
        // Stop Summernote's Clipboard module from processing images
        e.stopImmediatePropagation();
        e.preventDefault();
        // Only allow plain text
        const bufferText = (e.originalEvent || e).clipboardData.getData('text');
        const cleanText = bufferText.trim();
        document.execCommand('insertText', false, cleanText);
      },
      onImageUpload: function (files) {
        // Block image upload completely
        return false;
      }
    },
  };
  closeResult: string;
  loginUser: any = {};

  startCount = 0;
  pageCount = 7;
  currentPageCount = 0;

  modalScrollDistance = 2;
  modalScrollThrottle = 300;

  selectedImage = false;
  selectedvideo = false;
  selectedMediaType: string = null;
  eventHorizon: Subscription;
  urlVariable: Subscription;
  scrollSubscri: Subscription
  afterKey: any = undefined;
  cmdOffsetafterkey: any = null;
  newcmdoffSetMap: any = null;
  postTypeForm: UntypedFormGroup;
  linkChecker: Subscription;
  communityUpdateSub: Subscription;
  postDeletedSub: Subscription;
  public envName: any = environment.name;



  @ViewChild("myFileInput") myFileInput: ElementRef;
  @ViewChild("chartDiscussion") chartDisc: ElementRef;
  @ViewChild(NgxSummernoteDirective)
  summernote: NgxSummernoteDirective;
  @ViewChild("myInput") myInputVariable: ElementRef;
  @ViewChild("takeInput") InputVar: ElementRef;
  @ViewChild("jobCandidateTemplate") jobCandidateTemplate: ElementRef;
  currentOrganizationDetail: WorkExperience;
  sharePost: any = {};
  shareSourceCard: any = null;
  userId: string = localStorage.getItem('userId');
  selectPost = "All";
  commonVariables: any = {};
  scrollValue: any = {};
  employeeFlag: boolean = false;
  postLoading: boolean = false;
  linkUrlText = new Subject<string>();
  workExperienceDetailsCheck: any = [];
  notificationDatasshow: any;
  jobId: any;
  gigCommunitySubscribed: boolean = false
  showLoadPost: boolean = false
  tempFile: any;

  freeLauchtimezoneFrom: UntypedFormGroup;
  timezonSubmited = false;
  @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement>;
  @ViewChild("videoPlayerpopup")
  videoPlayerpopup: ElementRef;
  supportModal: any;
  reloading = false;
  reloadSubscription: Subscription | undefined;

  // Resume Parsing Variables
  isParsing: boolean = false;
  parseSuccess: boolean = false;
  parseFailed: boolean = false;
  parsedResumeData: any = null;
  showParsedDetails: boolean = false;
  activeResumeTab: string = 'overview';
  parseRetryCount: number = 0;
  private readonly MAX_PARSE_RETRIES: number = 2;
  fileDragdrop: any;
  private resumeParseSubscription: Subscription;

  // Upload progress tracking
  uploadProgress: number = 0;
  isUploading: boolean = false;
  progressSimulationInterval: any = null;

  constructor(
    private api: ApiService,
    public globalCommunity: GlobalCommunity,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private modalService: BsModalService,
    private commonvalues: CommonValues,
    private util: UtilService,
    private searchData: SearchData,
    private profilePhoto: ProfilePhoto,
    private formBuilder: UntypedFormBuilder,
    protected _sanitizer: DomSanitizer,
    private stremService: StreamService,
    public gigsumoService: GigsumoService,
    private planService: PricePlanService,
    private JobServicecolor: JobService,
    private currentOrgProvider: CurrentOrganizationProviderService,
    private resumeParserService: ResumeParserService,
    private resumeDataMapper: ResumeDataMapperService,
    private cacheInvalidationService: CacheInvalidationService,
    public jdParsingService: JobdescriptionparsingService,
    private hostRef: ElementRef
  ) {
    super();

    this.clickEventsubscription = this.commonvalues
      .getbusinessid()
      .subscribe((res) => {
        this.values = res;
        if (res.basicDeatils) {
          res.basicDeatils.employees.forEach(element => {
            if (element.userId === localStorage.getItem('userId')) {
              this.employeeFlag = true
            }
          });
        }
        if (res.memberInGSComm) {
          // this.gigCommunitySubscribed = true;
          // this.globalCommunity.joined = true;
        }

        if (res.basicDeatils) {
          res.basicDeatils.followers.forEach(element => {
            if (element.userId === localStorage.getItem('userId')) {

            }
          });
        }

        this.adminflag = res.adminviewnavigation;
        if (this.values.menu) {
          this.menu = this.values.menu;
        }
      });

    this.clickEventsubscription = this.commonvalues.getpubliccommunity().subscribe((res) => {
      if (res) {
        // this.gigCommunitySubscribed = true;
        // this.globalCommunity.joined = true;
      }
    });

    this.clickEventsubscription = this.commonvalues.getLoadDate().subscribe((res) => {
      if (res > 0) {
        this.showLoadPost = true;

      } else {
        this.showLoadPost = false;
      }
    });

    // A community edit (logo, banner or name) broadcasts on this channel, the same
    // one community-banner already listens to. The feed cached the community's
    // avatar on each post card, so without this the old picture stayed on screen
    // until a full page refresh.
    this.communityUpdateSub = this.commonvalues.getCommuityBoolean().subscribe((res) => {
      if (res && res.boolean == true) {
        this.refreshCommunityPostAvatars();
      }
    });

    // Deleting an original post broadcasts its id (see removepost). Shares of
    // that post already rendered in this list kept showing the dead content
    // until a refresh rebuilt them through addUnavailableSharedPost; convert
    // them in place instead, in every live post list.
    this.postDeletedSub = this.commonvalues.getPostDeleted().subscribe((deletedPostId) => {
      if (deletedPostId) {
        this.handlePostDeletedElsewhere(deletedPostId);
      }
    });

    this.linkChecker = this.searchData.getWebLinkURL().subscribe(res => {
      if (res != null && res != undefined && res != '') {
        this.linkUrlText = res
      } else {
        this.linkUrlText = null
      }

      if (this.linkUrlText != null) {
        var data = { key: '5b54e80a65c77848ceaa4630331e8384950e09d392365', q: this.linkUrlText }

        fetch('https://api.linkpreview.net', {
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify(data),
        }).then(res => {
          if (res.status == 429) {

            this.linkDescription = null
            this.linkImage = null
            this.linkTitle = null

          } else if (res.status == 426) {

            this.linkDescription = null
            this.linkImage = null
            this.linkTitle = null
          } else if (res.status == 425) {

            this.linkDescription = null
            this.linkImage = null
            this.linkTitle = null
          } else if (res.status == 423) {

            this.linkDescription = null
            this.linkImage = null
            this.linkTitle = null
          } else if (res.status == 403) {

            this.linkDescription = null
            this.linkImage = null
            this.linkTitle = null
          } else if (res.status == 401) {

            this.linkDescription = null
            this.linkImage = null
            this.linkTitle = null
          } else if (res.status == 400) {

            this.linkDescription = null
            this.linkImage = null
            this.linkTitle = null
          }

          return res.json()
        }).then(response => {

          this.linkDescription = response.description
          this.linkImage = response.image
          this.linkTitle = response.title
          this.linkURL = response.url
        }).catch(error => {

        })

      }

    })

    this.scrollSubscri = this.searchData
      .getScroll()
      .subscribe((res) => {
        this.scrollValue.windowScroll = res.windowScroll;
      });


    $("#summernote").summernote({
      popover: {
        blockquoteBreakingLevel: 2,
        link: [["link", ["linkDialogShow", "unlink"]]],
      },
    });
    this.getLoginUserDetails();


    // console.log("this.wordlength", this.wordlength);

    this.streamSubcr = this.stremService.getstreamResponse().subscribe(streamData => {
      this.streamData = streamData;

      if (streamData.responseEntity == "JOB") {
        this.jobStreamData = streamData;
      }
      if (streamData.responseEntity == "CANDIDATE") {
        this.canidateStreamData = streamData;
      }
      if (streamData.responseEntity == "HOME") {
        this.streamData = streamData;
      }



      if (streamData && streamData.responseEntity == "HOME") {
        //console.log(streamData)
        let key = Object.keys(streamData.data);
        for (let index = 0; index < key.length; index++) {
          const element = key[index];

        }


      }

    });
  }


  startTour = false;
  shouldShowStep(stepId: string): boolean {
    // Show steps only if the tour is started
    return this.startTour;
  }

  markStepCompleted(stepId: string): void {
    console.log(`Step ${stepId} completed`);
  }

  callMethod() {
    this.gigsumoService.buttonClicked = true;
  }

  modalRef2: BsModalRef | null;
  fileChangeEvent(event, popupName): void {
    const checkSize = super.checkImageSize(event.target.files[0]);
    this.imageChangedEvent = event;
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (checkSize > 10) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      this.myFileInputcandidate.nativeElement.value = null;
    }
    if (event.target.files && event.target.files[0]) {
      this.fileUploadName = event.target.files[0].name;
      this.myFileInputcandidate.nativeElement.value;

      const numberOfFiles = event.target.files.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {

          this.fileshow = e.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
      }

    }

    if (!acceptedImageTypes.includes(event.target.files[0].type)) {
      Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
      this.myFileInputcandidate.nativeElement.value = "";
      this.modalRef.hide();
    } else {
      this.PopupServicevlaues(popupName);
    }

  }
  config2 = {
    focus: false,
    height: 150,
    placeholder: "",
    link: [["link", ["linkDialogShow", "unlink"]]],
    insert: ["link", "picture", "video"],
    view: ["fullscreen", "codeview", "help"],
    style:
      "outline: none !important;background-color: rgb(241 243 246) !important;cursor: pointer !important;",
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    callbacks: {
      onFocus: function (contents) {
        if ($(this).summernote("isEmpty")) {
          $("#summessage").html("");
        }
      },
      onKeydown: function (e) {
        var t: string = e.currentTarget.innerText;
        var words = t.split(" ");

      }
    },
    toolbar: [
      ["misc", ["codeview", "undo", "redo"]],
      [
        "font",
        [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "superscript",
          "subscript",
          "clear",
        ],
      ],
      ["fontsize", ["fontname", "fontsize", "color"]],
      ["para", ["style", "ul", "ol", "paragraph", "height"]],
    ],
    fontNames: [
      "Helvetica",
      "Arial",
      "Arial Black",
      "Comic Sans MS",
      "Courier New",
      "Roboto",
      "Times",
    ], onPaste(e) {
      const buffertext = (e.originalEvent || e).clipboardData.getData("text");
      e.preventDefault();
      const all = buffertext.trim();
      document.execCommand("insertText", false, all.substring(0, 1000));
    },
  };

  // Job Description config - blocks images/videos
  jobDescConfig: any = {
    placeholder: '',
    tabsize: 2,
    height: 150,
    focus: false,
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times'],
    callbacks: {
      onPaste: function(e) {
        // Stop Summernote's Clipboard module from processing images
        e.stopImmediatePropagation();
        e.preventDefault();
        // Only allow plain text
        const bufferText = (e.originalEvent || e).clipboardData.getData('text');
        const cleanText = bufferText.trim();
        document.execCommand('insertText', false, cleanText);
      },
      onImageUpload: function(files) {
        // Block image upload completely
        return false;
      }
    }
  };
  PopupServicevlaues(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
    });
  }
  uploadPhotoHere() {

    this.myFileInputcandidate.nativeElement.click();
  }


  cropperReady() {

  }
  loadImageFailed() {

  }

  croppedImage: any = "";

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;


    const byteString = window.atob(
      event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
    );
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });

    this.fileToUpload = new File([blob], this.fileUploadName, {
      type: "image/jpeg",
    });
  }


  showmore(i) {
    this.userData[i].visible = true;
  }


  get isJobOwner() {
    return (this.userType === "FREELANCE_RECRUITER" || this.userType === "MANAGEMENT_TALENT_ACQUISITION" ||
      this.userType === "RECRUITER");
  }

  get isCandidateOwner() {
    return (this.userType === "FREELANCE_RECRUITER" || this.userType === "MANAGEMENT_TALENT_ACQUISITION" ||
      this.userType === "BENCH_RECRUITER" || this.userType === "JOB_SEEKER");
  }
  toggleVideo(event?: any) {
    this.videoPlayer.nativeElement.play();
  }
  toggleVideopopup(event?: any) {
    this.videoPlayerpopup.nativeElement.play();
  }
  closePhoto2() {
    this.modalRef2.hide();
    this.photo = null;
    this.fileshow = undefined;
    this.myFileInputcandidate.nativeElement.value = null;
    this.photoId = null;

  }
  img: any = {};
  img4: any = {};

  imageLoaded2() {
    this.util.startLoader();
    const formData: FormData = new FormData();
    formData.append("file", this.fileToUpload, this.fileUploadName);
    // setTimeout(() => {
    this.api.create("upload/image", formData).subscribe((res) => {
      this.util.stopLoader();
      if (res) {
        this.photoId = res.fileId;
        this.modalRef2.hide();

      }
    }, err => {
      this.util.stopLoader();

    });
  }




  datagetvalue() {
    this.wordlength

  }
  results$: Observable<any>
  subject = new Subject()


  linkURL
  linkDescription
  linkTitle
  linkImage
  // asdf: any = {}
  isJoinedCommunity
  isCommunityAdmin
  isCommunitySuperAdmin
  userType: USER_TYPE = localStorage.getItem('userType') as USER_TYPE;
  communityType
  showWelcomePost: boolean = false
  // welcomePostData: any = []

  /** Static trending hashtags shown above the activity-feed post list (mock parity).
   *  Wire to a backend trending API later — kept inline for now to avoid blocking
   *  the visual rollout. */
  readonly trendingTags: string[] = ['JavaDeveloper', 'BenchSales', 'TechRecruiting', 'AWSJobs', 'C2C', 'RemoteWork'];

  /** Feed filter tabs (visual only for this PR — selecting a tab toggles
   *  `activeFeedFilter`; the post-list query is not yet wired to the value). */
  readonly feedFilters: { id: string; label: string }[] = [
    { id: 'for-you',   label: 'For You' },
    { id: 'all',       label: 'All' },
    { id: 'community', label: 'Community' },
    { id: 'jobs',      label: 'Jobs' },
    { id: 'trending',  label: 'Trending' },
  ];
  activeFeedFilter: string = 'for-you';

  setFeedFilter(id: string): void {
    if (this.activeFeedFilter === id) return;
    this.activeFeedFilter = id;
    // TODO: wire to feed-filter API when available.
  }

  emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z.-]+.[a-zA-Z]{2,4}$";
  isCommunityJoined
  clientTypeListprofile: Array<string> = ['Direct Client', 'Supplier', 'Systems Integrator', 'Prime Vendor', 'Vendor', 'Staffing Agency']
  businessPage: boolean = false;
  businessData: any;
  currentPath: string;

  ngOnInit() {
    this.gigsumoService.loadMyBusinessId();

    this.modalSearchSub = this.modalSearchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe((term: string) => {
      this.modalSearchTerm = (term || '').trim();
      if (['Connections', 'Network', 'Community'].includes(this.postviewModelName)) {
        this.queryPostview(this.postviewModelName);
      }
    });

    this.currentPath = this.router.url
    this.updateSupportModule();
    this.generateYearsprofile();
    this.getCountries();
    this.domainForm = this.formBuilder.group({
      priEmail: null,
      secEmail: null,
      swapEmail: [null, [Validators.required, Validators.email,
      Validators.pattern(this.emailPattern)]],
      domainValidationOtp: null,
    })



    $(".summernote").summernote({
      onChange: function () {

      }    // callback as option
    });

    this.postTypeForm = this.formBuilder.group({
      postType: "Everyone",
    });

    this.urlLinkDetctForm = this.formBuilder.group({
      snippedLinkText: [
        null,
        Validators.compose([
          this.companyMinMaxCharacters(this.PITCH.min, this.ABOUT_ME.max),
        ]),
      ],
    }, { validators: CustomValidator.linkDetector('snippedLinkText', this.searchData) })
    this.userId = localStorage.getItem("userId");
    this.userdetails();
    this.values = this.commonemit;
    this.route.queryParams.subscribe((res) => {

      if (res.businessId) {
        this.businessPage = true
        this.businessData = res;

      } else {
        this.businessPage = false;
      }
      //notication view on particular cmd or shared post
      if (res.postId !== undefined) {
        this.postId = res.postId;
      }
      if (res.showWelcomePost == 'true') {
        this.showWelcomePost = true
      }
      // Initial post loading based on the pages
      if (
        res.businessId === undefined &&
        res.communityId === undefined &&
        res.networkId === undefined &&
        res.teamId === undefined
      ) {
        this.Commomdatass = "USER";
        this.commonPost_getpostdatas(this.startCount, this.pageCount);
      }
      //community page redirection
      else if (res.communityId !== undefined) {
        this.Commomdatass = "COMMUNITY";


        this.communityid = res.communityId;
        this.communityType = res.communityType
        if (res.isJoined) {
          this.isCommunityJoined = res.isJoined
        } else if (res.join) {
          this.isCommunityJoined = res.join
        }

        if (res.admin) {
          this.isCommunityAdmin = res.admin
        } else if (res.isAdmin) {
          this.isCommunityAdmin = res.isAdmin
        }
        this.isCommunitySuperAdmin = res.isSuperAdmin
        this.commonPost_getpostdatas(this.startCount, this.pageCount);
      }
      //Team page redirection
      else if (res.teamId !== undefined) {
        this.Commomdatass = "TEAM";
        this.teamId = res.teamId;
        this.commonPost_getpostdatas(this.startCount, this.pageCount);

      }
      //business page redirection
      else if (res.businessId !== undefined) {
        this.Commomdatass = "BUSINESS";
        this.businessId = res.businessId;
        this.commonPost_getpostdatas(this.startCount, this.pageCount);

      } //network page redirection
      else if (res.networkId !== undefined) {
        this.Commomdatass = "NETWORK";
        this.networkId = res.networkId;
        this.commonPost_getpostdatas(this.startCount, this.pageCount);
      }

    });
    //post Component reload on when i click home menu
    this.reloadSubscription = this.JobServicecolor.getReloadSignal().subscribe(() => {

      this.reloading = true;
      if (this.Commomdatass == 'USER') {
        this.getpostdatas();
      }
      setTimeout(() => {
        this.reloading = false;
      }, 2000);
    });
    this.jobformfield()

    // Subscribe to resume parser progress updates for upload progress bar
    this.resumeParserService.progress$.subscribe(progress => {
      console.log('Progress update from service:', progress);

      // Only update if not simulating or if it's a major update
      if (!this.progressSimulationInterval || progress >= 70 || progress === 0) {
        this.uploadProgress = progress;
      }

      // Start simulated progress increments when API call starts (at 30%)
      if (progress === 30 && !this.progressSimulationInterval) {
        console.log('Starting progress simulation at 30%');
        this.progressSimulationInterval = setInterval(() => {
          if (this.uploadProgress < 68) {
            this.uploadProgress += 1; // Increment by 1% every 150ms
            console.log('Simulating progress:', this.uploadProgress);
          }
        }, 150); // Faster increments (every 150ms)
      }

      // Stop simulation when real progress updates arrive (70% or higher)
      if (progress >= 70 && this.progressSimulationInterval) {
        console.log('Stopping simulation, real progress:', progress);
        clearInterval(this.progressSimulationInterval);
        this.progressSimulationInterval = null;
        this.uploadProgress = progress;
      }

      // Hide progress bar when complete (100%)
      if (progress === 100) {
        if (this.progressSimulationInterval) {
          clearInterval(this.progressSimulationInterval);
          this.progressSimulationInterval = null;
        }
        setTimeout(() => {
          this.isUploading = false;
          this.uploadProgress = 0;
        }, 500);
      } else if (progress === 0 && this.isUploading && this.uploadProgress > 0) {
        // Error occurred during upload
        if (this.progressSimulationInterval) {
          clearInterval(this.progressSimulationInterval);
          this.progressSimulationInterval = null;
        }
        this.isUploading = false;
        this.uploadProgress = 0;
      }
    });
  }
  userdetails() {
    this.api.query("user/" + this.userId).subscribe((res) => {
      if (res && res.code === "00000") {
        this.userType = res.userType;
        this.firstName = res.firstName;
        this.lastName = res.lastName
        this.util.stopLoader();
      }
    }, err => {
      this.util.stopLoader();
    });
  }


  ngOnDestroy(): void {
    if (this.linkChecker) {
      this.linkChecker.unsubscribe();
    }
    if (this.scrollSubscri) {
      this.scrollSubscri.unsubscribe();
    }
    if (this.urlVariable) {
      this.urlVariable.unsubscribe();
    }
    if (this.eventHorizon) {
      this.eventHorizon.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.streamSubcr) {
      this.streamSubcr.unsubscribe();
    }
    if (this.clickEventsubscription) {
      this.clickEventsubscription.unsubscribe();
    }
    if (this.modalSearchSub) {
      this.modalSearchSub.unsubscribe();
    }
    if (this.reloadSubscription) {
      this.reloadSubscription.unsubscribe();
    }
    if (this.communityUpdateSub) {
      this.communityUpdateSub.unsubscribe();
    }
    if (this.postDeletedSub) {
      this.postDeletedSub.unsubscribe();
    }
    this.unbindKebabAutoClose();
  }

  // The post-card kebab dropdown uses `container="body"` so it doesn't ride
  // the post up/down on scroll, but that means it stays pinned to its open
  // position and eventually overlaps the navbar. Auto-close it as soon as
  // the user scrolls so the page reads cleanly. Stored as a bound handler
  // so we can detach the same reference on hide / destroy.
  private kebabScrollHandler: (() => void) | null = null;

  bindKebabAutoClose(dropdown: { hide: () => void }): void {
    this.unbindKebabAutoClose();
    this.kebabScrollHandler = () => dropdown.hide();
    window.addEventListener('scroll', this.kebabScrollHandler, true);
  }

  unbindKebabAutoClose(): void {
    if (this.kebabScrollHandler) {
      window.removeEventListener('scroll', this.kebabScrollHandler, true);
      this.kebabScrollHandler = null;
    }
  }

  closemodel() {
    this.gigsumoService.buttonClicked = true;
    this.beingEdited = false
    this.commonVariables.creditFlag = false
    this.commonVariables.educationFlag = false
    this.commonVariables.workExperienceFlag = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.candidatePostingFlag = false
    this.commonVariables.postPrivacyFlag = false
    this.commonVariables.emailDomainValidation = false
    this.modalRef.hide();
  }


  qwer
  organizationList: any = []
  previousSearchAfterKey: any = null
  primarySkillsList: any = []
  secondarySkillsList: any = []
  skillsList: any = []
  payTypeList: any = []
  clientTypeList: any = []
  jobPostedBehalfOflist: Array<{ country: string, orgName: string, state: string, city: string, zipCode: string, id?: string, source?: 'INTERNAL' | 'EXTERNAL' }> = []
  clientNameList: any = []
  clientNameList1: any = []
  durationTypeList: any = []
  jobClassificationList: any = []
  recruiterTitleList: any = []
  workAuthorizationList: any = []


  autoComplete1: MatAutocompleteTrigger;
  searchBarShow1: boolean = false
  uniqueOrgList1: Array<Partial<HealthCareOrganization>> = [];
  // Client-Name partitions — uniqueOrgList1 above is the legacy flat list; the
  // template now renders these two arrays as separate <mat-optgroup> sections.
  platformOrgList1: Array<Partial<HealthCareOrganization>> = [];
  externalOrgList1: Array<any> = [];
  // Tracks whether at least one of the two parallel API calls has returned, so
  // the template can show a "No matching businesses" hint instead of a blank
  // empty dropdown when nothing matches the typed text.
  clientNameSearched1: boolean = false;

  // Snapshot of the External-Business option last picked from the Client Name
  // dropdown. Captured in onChngOrg when source='EXTERNAL'. Used at submit time
  // to populate JobDetails.behalfOfBusinessId. Cleared (or marked non-EXTERNAL)
  // when the user picks a Platform option or retypes manually.
  selectedClientBusinessId: string = '';
  selectedClientBusinessName: string = '';
  selectedClientSource: 'EXTERNAL' | 'INTERNAL' | '' = '';



  getOrganization1(value) {
    const trimmed = (value ?? '').toString().trim();
    // Free-text edit invalidates any prior autocomplete selection — the
    // form value no longer corresponds to selectedClientBusinessId.
    if (trimmed !== this.selectedClientBusinessName) {
      this.selectedClientBusinessId = '';
      this.selectedClientBusinessName = '';
      this.selectedClientSource = '';
    }
    if (trimmed === '') {
      // Empty input — hide the dropdown and clear stale results.
      this.searchBarShow1 = false;
      this.clientNameSearched1 = false;
      this.platformOrgList1 = [];
      this.externalOrgList1 = [];
      this.uniqueOrgList1 = [];
      return;
    }

    // Open the dropdown immediately so the user sees a panel while results load.
    this.searchBarShow1 = true;
    this.clientNameSearched1 = false;

    // Platform Business partition - HealthCareOrganization lookup.
    this.api.query("care/organizations?organizationName=" + encodeURIComponent(trimmed))
      .pipe(debounceTime(500))
      .subscribe({
        next: (res: any) => {
          const orgList1: Array<Partial<HealthCareOrganization>> = [];
          if (Array.isArray(res)) {
            res.forEach(ele => {
              const obj: any = {};
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.address1 = ele.address1;
              obj.address2 = ele.address2;
              obj.zipCode = ele.zipCode;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.businessId = ele.businessId;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList1.push(obj);
            });
          }
          this.platformOrgList1 = orgList1;
          this.uniqueOrgList1 = orgList1;
          this.clientNameSearched1 = true;
        },
        error: () => {
          this.platformOrgList1 = [];
          this.uniqueOrgList1 = [];
          this.clientNameSearched1 = true;
        }
      });

    // External Business partition - externals created by the logged-in business,
    // filtered server-side by businessName via searchContent.
    const loggedInBusinessId = localStorage.getItem('myBusinessId');
    if (loggedInBusinessId) {
      this.api.create('agreementDocumentChecklist/findExternalConnections', {
        businessId: loggedInBusinessId,
        roleFilter: 'Client',
        searchContent: trimmed
      }).subscribe({
        next: (extRes: any) => {
          const externals = extRes?.data?.customerFilters || [];
          // Until the backend's searchContent change is deployed, the API returns
          // ALL externals — fall back to a client-side name filter so the dropdown
          // doesn't show unrelated entries.
          const needle = trimmed.toLowerCase();
          this.externalOrgList1 = externals
            .filter((ext: any) =>
              ext?.businessName && ext.businessName.toLowerCase().indexOf(needle) !== -1)
            .map((ext: any) => ({
              organizationId: ext.businessId,
              organizationName: ext.businessName,
              businessId: ext.businessId,
              source: 'EXTERNAL'
            }));
          this.clientNameSearched1 = true;
        },
        error: () => {
          this.externalOrgList1 = [];
          this.clientNameSearched1 = true;
        }
      });
    } else {
      this.externalOrgList1 = [];
    }
  }

  onPaste1(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    if (pastedText != null) {
      this.util.startLoader();
      this.api.query("care/organizations?organizationName=" + pastedText)
        .pipe(debounceTime(2000))
        .subscribe((res) => {
          this.util.stopLoader();
          if (res) {
            this.util.stopLoader();
            const orgList1: Array<Partial<HealthCareOrganization>> = [];
            res.forEach(ele => {
              var obj: any = {}
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.address1 = ele.address1;
              obj.zipCode = ele.zipCode;
              obj.address2 = ele.address2;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList1.push(obj);
            })
            const uniqueList = new Set(orgList1);
            this.uniqueOrgList1 = Array.from(uniqueList);
            this.platformOrgList1 = Array.from(uniqueList);
          }
        }, err => {
        });

      // External Business partition — same external lookup as getOrganization1,
      // so a pasted client name surfaces matching externals too.
      const loggedInBusinessId = localStorage.getItem('myBusinessId');
      if (loggedInBusinessId) {
        this.api.create('agreementDocumentChecklist/findExternalConnections', {
          businessId: loggedInBusinessId,
          roleFilter: 'Client',
          searchContent: pastedText
        }).subscribe({
          next: (extRes: any) => {
            const externals = extRes?.data?.customerFilters || [];
            this.externalOrgList1 = externals.map((ext: any) => ({
              organizationId: ext.businessId,
              organizationName: ext.businessName,
              businessId: ext.businessId,
              source: 'EXTERNAL'
            }));
          },
          error: () => {
            this.externalOrgList1 = [];
          }
        });
      } else {
        this.externalOrgList1 = [];
      }

      this.searchBarShow = true;
      this.searchBarShow1 = true;
    } else {
      this.searchBarShow = false;
      this.searchBarShow1 = false;
      this.platformOrgList1 = [];
      this.externalOrgList1 = [];
    }
  }
  timezoneslist: any = []
  onChangeCountryorg(event, value, index) {
    if (value == "work") {
      this.workExperience.controls[index].patchValue({
        state: null,
        zipcode: null,
        city: null,
        country: event,
      });
      this.workExperience.controls.forEach((ele) => {
        ele.get("state").setValidators([Validators.required]);
        ele.get("state").updateValueAndValidity();
      });
    }
    if (event == "United States") {
    } else if (event == "AU") {
      const countryCode = event;
      this.stateListAU = [];
      this.util.startLoader();
      this.api
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListAU = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "IN") {
      const countryCode = event;
      this.stateListIN = [];
      this.util.startLoader();
      this.api
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListIN = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "CA") {
      const countryCode = event;
      this.stateListCA = [];
      this.util.startLoader();
      this.api
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListCA = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else {
    }
    const countryCode = event;
    if (event != null && this.eperienceForm != undefined) {

      this.workExperience.controls[0].get("timeZone").enable();
    }
    this.timeZonecountryvalues(countryCode);
  }
  onChangeCountry_timezone(event) {
    this.countryChosen = event;
    this.timeZonecountryvalues(this.countryChosen);

  }

  timeZonecountryvalues(countryCode) {
    this.util.startLoader();
    if (countryCode != undefined && countryCode != "") {
      this.timezoneslist = [];
      this.api.query("user/timeZoneByCountryCode/" + countryCode).subscribe((res) => {
        if (res) {
          this.util.stopLoader();
          this.timezoneslist = res.data.zones;
        }
      }, err => {
        this.util.stopLoader();
      });
    }
  }

  onPaste9(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    if (pastedText != null) {
      this.util.startLoader();
      this.api.query("care/organizations?organizationName=" + pastedText)
        .pipe(debounceTime(2000))
        .subscribe((res) => {
          this.util.stopLoader();
          if (res) {
            this.util.stopLoader();
            const orgList: Array<Partial<HealthCareOrganization>> = [];
            res.forEach(ele => {
              var obj: any = {}
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.address1 = ele.address1;
              obj.zipCode = ele.zipCode;
              obj.address2 = ele.address2;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList.push(obj);

            })
            const uniqueList = new Set(orgList);
            this.uniqueOrgList = Array.from(uniqueList);
          }
        }, err => {
        });
      this.searchBarShow = true;
    } else {
      this.searchBarShow = false
    }
  }

  onPaste3(event: ClipboardEvent) {
    // let clipboardData = event.clipboardData;
    // let pastedText = clipboardData.getData('text');
    CustomValidator.jobDescriptionLength(this.jobPostForm.get('jobDescription'))
  }

  onPaste4(event: ClipboardEvent) {
    CustomValidator.jobDescriptionLength(this.candidatePostForm.get('resumeSummary'))
  }
  currentTime: any;
  isSelected(id: number): boolean {
    return this.gigsumoService.isSelected(id, this.selectedNetworks);
  }

  onCheckboxChangenetwork(id: number, checked: boolean, form: FormGroup): void {
    this.selectedNetworks = this.gigsumoService.onCheckboxChange(
      id,
      checked,
      this.selectedNetworks,
      form,
      'selectedNetworks'
    );
  }

  // Prevent Free plan users and Job Seekers from unchecking Marketplace.
  // Also prevent removal of org-locked networks.
  onNetworkSelectionChange(form: FormGroup): void {
    if (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') {
      const hasMarketplace = this.selectedNetworks.some(id => id === '1' || id === 1);
      if (!hasMarketplace) {
        this.selectedNetworks = ['1', ...this.selectedNetworks];
        form.get('selectedNetworks').setValue(this.selectedNetworks);
      }
    }
    // Remove any permission-disabled network that was somehow selected
    if (this.disabledNetworkTypes.size > 0) {
      const filtered = this.selectedNetworks.filter(id => {
        const n = this.networkGroups.find((g: any) => String(g.id) === String(id));
        return !n?.disabled;
      });
      if (filtered.length !== this.selectedNetworks.length) {
        this.selectedNetworks = filtered;
        form.get('selectedNetworks')?.setValue(this.selectedNetworks);
      }
    }
    // Re-add any locked network that was deselected
    if (this.lockedNetworkIds.size > 0) {
      let changed = false;
      this.lockedNetworkIds.forEach(lockedId => {
        const present = this.selectedNetworks.some(id => String(id) === String(lockedId));
        if (!present) {
          this.selectedNetworks = [...this.selectedNetworks, lockedId];
          changed = true;
        }
      });
      if (changed) {
        form.get('selectedNetworks')?.setValue(this.selectedNetworks);
      }
    }
  }

  isNetworkLocked(networkId: any): boolean {
    return this.lockedNetworkIds.has(String(networkId));
  }

  isNetworkDisabledByPermission(network: any): boolean {
    if (!network) return false;
    if (network.id === '1') return this.disabledNetworkTypes.has('Marketplace');
    return this.disabledNetworkTypes.has(network.type);
  }

  selectedNetworks: any[] = [];
  lockedNetworkIds: Set<string> = new Set();
  disabledNetworkTypes: Set<string> = new Set();
  networkGroups: any[] = [];
  networks: any[] = [];
  membershipType = localStorage.getItem('MemberShipType');
  groupedNetworks: any = {};
  getListValues(param) {

    this.clientTypeList = []
    this.jobPostedBehalfOflist = []
    this.payTypeList = []
    this.secondarySkillsList = []
    this.primarySkillsList = []
    this.skillsList = []
    this.periodList = []
    this.recruiterTitleList = []
    this.totalExperienceList = []
    this.workAuthorizationList = []
    this.durationTypeList = []
    this.engagementTypeList = []

    if (this.jobClassificationList.length == 0) {
      this.util.startLoader()
      var data: any = { "domain": "ENGAGEMENT_TYPE,JOB_ENGAGEMENT_TYPES,CLIENT_TYPE,JOB_CLIENT_TYPES,PAY_TYPE,DURATION,PRIMARY_SKILLS,WORK_AUTHORIZATION,CANDIDATE_AVAILABLITY,TOTAL_EXPERIENCE,SECONDARY_SKILLS,GIGSUMO_SKILLS_LIST,GIGSUMO_JOB_TITLE,GIGSUMO_RECRUITERS_TITLE_LIST" }
      if (param == 'JOBS') {
        data.type = 'JOB';
      } else if (param == 'CANDIDATE') {
        data.type = 'CANDIDATE';
      }
      data.userId = localStorage.getItem("userId");
      this.api.create('listvalue/findbyList', data).subscribe(res => {
        if (res.code == '00000') {
          const data = res.data;
          //To get the list on Publish to dropdown
          const businessNetworks = data.businessNetworks ? data.businessNetworks.map((network: any) => ({
            id: network.b2bNetworkId,
            name: network.b2bNetworkName,
            type: 'Business Networks'
          })) : [];

          const memberNetworks = data.memberNetworks ? data.memberNetworks.map((network: any) => ({
            id: network.businessNetworkId,
            name: network.businessNetworkName,
            type: 'Member Networks'
          })) : [];

          const personalNetworks = data.personalNetworks ? data.personalNetworks.map((network: any) => ({
            id: network.networkId,
            name: network.networkName,
            type: 'Personal Networks'
          })) : [];
          const allNetworks = [...businessNetworks, ...memberNetworks, ...personalNetworks];

          this.networks = allNetworks;
          // Group the publish network into single array by monisha
          this.groupedNetworks = allNetworks.reduce((groups: any, network: any) => {
            const { type } = network;
            if (!groups[type]) {
              groups[type] = [];
            }
            groups[type].push(network);
            return groups;
          }, {});
          this.networkGroups = Object.keys(this.groupedNetworks).reduce((result: any[], type: string) => {
            return result.concat(this.groupedNetworks[type].map((network: any) => ({
              ...network,
              type
            })));
          }, []);

          // static data added for marketpalace dropdown by monisha
          const marketplaceNetwork = {
            id: '1', // Assign a unique ID
            name: 'Marketplace',
            type: 'Marketplace'
          };

          // final grouping for array to show in publish to network dropdown by monisha
          this.networkGroups = [marketplaceNetwork, ...this.networkGroups];

          // Pre-select Marketplace for Free plan users and Job Seekers
          if (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') {
            const hasMarketplace = this.selectedNetworks.some(id => id === '1' || id === 1);
            if (!hasMarketplace) {
              this.selectedNetworks = ['1', ...this.selectedNetworks];
            }
          }

          // Apply org-level publish settings (pre-select + lock networks, apply permissions)
          if (this.businessId) {
            this.api.query(`business/getNetworkPermissions?businessId=${this.businessId}`).subscribe({
              next: (settingsRes: any) => {
                const data = settingsRes?.data || {};
                const schedule: any[] = data.publishSchedule || [];
                const day1Step = schedule.find((s: any) => s.day === 1);
                const defaultNetworkIds: string[] = day1Step
                  ? [
                      ...((day1Step.b2bNetworkIds as string[]) || []),
                      ...((day1Step.personalNetworkIds as string[]) || []),
                      ...((day1Step.memberNetworkIds as string[]) || []),
                      ...(day1Step.marketplace ? ['1'] : [])
                    ]
                  : [];
                this.lockedNetworkIds.clear();
                if (defaultNetworkIds.length > 0) {
                  defaultNetworkIds.forEach(networkId => {
                    const id = String(networkId);
                    if (!this.selectedNetworks.some(n => String(n) === id)) {
                      this.selectedNetworks = [...this.selectedNetworks, id];
                    }
                    this.lockedNetworkIds.add(id);
                  });
                }
                // Apply network category permissions
                const perms = data.networkPermissions;
                if (perms) {
                  this.disabledNetworkTypes.clear();
                  if (perms.personalNetworks === false) this.disabledNetworkTypes.add('Personal Networks');
                  if (perms.memberNetworks === false)   this.disabledNetworkTypes.add('Member Networks');
                  if (perms.b2bNetworks === false)      this.disabledNetworkTypes.add('Business Networks');
                  if (perms.marketplace === false)      this.disabledNetworkTypes.add('Marketplace');
                  // Mark disabled on networkGroups
                  this.networkGroups = this.networkGroups.map(n => ({
                    ...n,
                    disabled: this.isNetworkDisabledByPermission(n)
                  }));
                }
              },
              error: () => { /* silent — org settings are optional */ }
            });
          }

          this.jobId = res.data.jobId;

          if (param != 'CANDIDATE') {
            this.jobPostForm.patchValue({ 'jobId': res.data.jobId });

            this.util.startLoader()
            this.api.query('business/check/orgname/' + this.userId).subscribe(res => {
              this.util.stopLoader()
              if (res.code == '00000' || '10008') {

                if (res.data != null && res.data.organisation != null && res.data.organisation.length != 0) {
                  let organisations: Array<any> = res.data.organisation;
                  res.data.organisation.forEach(ele => {
                    this.jobPostedBehalfOflist.push({ country: ele.country, orgName: ele.organizationName, state: ele.state, zipCode: ele.zipCode, city: ele.city, id: ele.organizationId, source: 'INTERNAL' })
                    if (this.userType == 'FREELANCE_RECRUITER' && organisations.length > 1) {
                      this.jobPostForm.get('jobPostedBehalfOf').enable();
                      this.addCurrentOrgValidation();
                    } else if (this.userType == 'FREELANCE_RECRUITER' && organisations.length == 1) {
                      this.jobPostForm.get('jobPostedBehalfOf').patchValue(ele.organizationName);
                      this.jobPostForm.get('jobPostedBehalfOf').disable();
                      this.addCurrentOrgValidation();
                    } else {
                      if (this.userType == 'FREELANCE_RECRUITER') {
                        this.removeCurrentOrgValidation();
                      }
                      this.jobPostForm.get('jobPostedBehalfOf').patchValue(ele.organizationName);
                      this.jobPostForm.get('jobPostedBehalfOf').disable()
                    }
                  })
                } else if (res.code = "100002") {
                  this.jobPostForm.get('jobPostedBehalfOf').disable()
                }
              } else if (res.code == '10002') {
                this.jobPostForm.get('jobPostedBehalfOf').disable()
              }

              // Option C / Piece 2: append external businesses created by the logged-in
              // business so users can post jobs on behalf of an external customer (e.g.
              // Ford posting on behalf of Wipro). Each item carries source: 'EXTERNAL'
              // and the external business ID — captured into the form payload on submit.
              const loggedInBusinessId = localStorage.getItem('myBusinessId');
              if (loggedInBusinessId) {
                this.api.create('agreementDocumentChecklist/findExternalConnections', {
                  businessId: loggedInBusinessId,
                  roleFilter: 'Client'
                }).subscribe({
                  next: (extRes) => {
                    const externals = extRes?.data?.customerFilters || [];
                    const existingIds = new Set(this.jobPostedBehalfOflist.map(o => o.id).filter(Boolean));
                    externals.forEach((ext: any) => {
                      if (ext.businessId && !existingIds.has(ext.businessId)) {
                        this.jobPostedBehalfOflist.push({
                          country: '',
                          orgName: ext.businessName,
                          state: '',
                          city: '',
                          zipCode: '',
                          id: ext.businessId,
                          source: 'EXTERNAL'
                        });
                        existingIds.add(ext.businessId);
                      }
                    });
                    // Re-enable the control so users can pick from the merged list.
                    if (this.jobPostedBehalfOflist.length > 1) {
                      this.jobPostForm.get('jobPostedBehalfOf').enable();
                    }
                  },
                  error: () => {
                    // External list is optional — silent fallback to internal-only list.
                  }
                });
              }
            })

          }
          if (param == 'CANDIDATE') {
            this.candidatePostForm.patchValue({ 'candidateId': res.data.candidateId });
            this.usStatesList = []
            this.api
              .query("country/getAllStates?countryCode=US")
              .subscribe((res) => {
                if (res) {
                  res.forEach(ele => {
                    this.usStatesList.push(ele.stateName)
                    this.otherStatesList.push(ele.stateName)
                  })
                }
              }, err => {
                this.util.stopLoader();
              })
          }
          if (param === 'CANDIDATE') {
            res.data.CLIENT_TYPE.listItems.forEach(ele => {
              this.clientTypeList.push(ele.item);
              var mySet = new Set(this.clientTypeList);
              this.clientTypeList = [...mySet]
            })
          } else if (param === 'JOBS') {
            res.data.JOB_CLIENT_TYPES.listItems.forEach(ele => {
              this.clientTypeList.push(ele.item);
              var mySet = new Set(this.clientTypeList);
              this.clientTypeList = [...mySet]
            })
          }
          res.data.PAY_TYPE.listItems.forEach(ele => {
            this.payTypeList.push(ele.item)
            var mySet = new Set(this.payTypeList);
            this.payTypeList = [...mySet]
          })

          res.data.SECONDARY_SKILLS.listItems.forEach(ele => {
            if (ele.item) {
              this.secondarySkillsList.push(ele.item)
              var mySet = new Set(this.secondarySkillsList);
              this.secondarySkillsList = [...mySet]
            }
          })
          res.data.PRIMARY_SKILLS.listItems.forEach(ele => {
            if (ele.item) {
              this.primarySkillsList.push(ele.item)
              var mySet = new Set(this.primarySkillsList);
              this.primarySkillsList = [...mySet]
            }
          })
          res.data.CANDIDATE_AVAILABLITY.listItems.forEach(ele => {
            this.periodList.push(ele.item)
            var mySet = new Set(this.periodList);
            this.periodList = [...mySet]
          })
          res.data.TOTAL_EXPERIENCE.listItems.forEach(ele => {
            this.totalExperienceList.push(ele.item)
            var mySet = new Set(this.totalExperienceList);
            this.totalExperienceList = [...mySet]
          })
          if (param === 'JOBS') {
            res.data.JOB_ENGAGEMENT_TYPES.listItems.forEach(ele => {
              this.engagementTypeList.push(ele.item)
              var mySet = new Set(this.engagementTypeList);
              this.engagementTypeList = [...mySet]
            })
          } else if (param === 'CANDIDATE') {
            res.data.ENGAGEMENT_TYPE.listItems.forEach(ele => {
              this.engagementTypeList.push(ele.item)
              var mySet = new Set(this.engagementTypeList);
              this.engagementTypeList = [...mySet]
            })
          }


          res.data.DURATION.listItems.forEach(ele => {
            this.durationTypeList.push(ele.item)
            var mySet = new Set(this.durationTypeList);
            this.durationTypeList = [...mySet]
          })

          res.data.GIGSUMO_JOB_TITLE.listItems.forEach(ele => {
            this.candidateJobTitleList.push(ele.item);
            var mySet = new Set(this.candidateJobTitleList);
            this.candidateJobTitleList = [...mySet]
          })
          res.data.GIGSUMO_RECRUITERS_TITLE_LIST.listItems.forEach(ele => {
            this.recruiterTitleList.push(ele.item)

          })

          if (param == 'CANDIDATE') {
            if (this.openModal == true) {
              const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
              this.modalRef = this.modalService.show(this.postTemplate, modalConfig);

            }
            if (this.otpEmailSent == true) {
              this.otpEmailSent = false
              this.commonVariables.emailDomainValidation = false
              this.commonVariables.workExperienceFlag = false
              this.commonVariables.educationFlag = false
              this.searchData.setCommonVariables(this.commonVariables)
            }
            this.commonVariables.candidatePostingFlag = true
            this.commonVariables.jobPostingFlag = false
            this.commonVariables.postPrivacyFlag = false
            this.commonVariables.workExperienceFlag = false
            this.commonVariables.educationFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
          } else if (param == 'JOBS') {
            if (this.openModal == true) {
              const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
              this.modalRef = this.modalService.show(this.postTemplate, modalConfig);
            }
            if (this.otpEmailSent == true) {
              this.otpEmailSent = false
              this.commonVariables.emailDomainValidation = false
              this.commonVariables.workExperienceFlag = false
              this.commonVariables.educationFlag = false
              this.searchData.setCommonVariables(this.commonVariables)
            }

            this.commonVariables.jobPostingFlag = true
            this.commonVariables.postPrivacyFlag = false
            this.commonVariables.workExperienceFlag = false
            this.commonVariables.educationFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
          }

        }
      })
    } else {

      if (param == 'CANDIDATE') {
        if (this.openModal == true) {
          const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
          this.modalRef = this.modalService.show(this.postTemplate, modalConfig);
        }

        this.commonVariables.candidatePostingFlag = true
        this.commonVariables.jobPostingFlag = false
        this.commonVariables.postPrivacyFlag = false
        this.commonVariables.workExperienceFlag = false
        this.commonVariables.educationFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
      } else if (param == 'JOBS') {
        if (this.openModal == true) {
          const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
          this.modalRef = this.modalService.show(this.postTemplate, modalConfig);

        }

        this.commonVariables.jobPostingFlag = true
        this.commonVariables.postPrivacyFlag = false
        this.commonVariables.workExperienceFlag = false
        this.commonVariables.educationFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
      }

    }
  }

  sortConfigWork: TypeaheadOrder = {
    direction: "desc",
    field: "organisationName",
  };
  freelancerInternalHireFlag: boolean = false
  onClientTypeChange(value) {

    if (this.userType != 'FREELANCE_RECRUITER') {
      this.freelancerInternalHireFlag = false
      if (value == GigsumoConstants.DIRECT_HIRE) {
        this.jobPostForm.patchValue({ clientName: this.jobPostedBehalfOflist[0].orgName })
        this.jobPostForm.get('clientName').disable()
      } else {
        this.jobPostForm.get('clientName').enable()
        this.jobPostForm.get('clientName').patchValue(null)
      }
    } else if (this.userType == 'FREELANCE_RECRUITER') {
      if (value == GigsumoConstants.DIRECT_HIRE) {
        if (this.jobPostForm.get('jobPostedBehalfOf').value != null) {
          this.jobPostForm.patchValue({ clientName: this.jobPostForm.get('jobPostedBehalfOf').value })
          this.jobPostForm.get('clientName').disable()
        } else {
          this.jobPostForm.get('clientName').patchValue(null)
          this.jobPostForm.get('clientName').enable()
        }
      } else {
        this.jobPostForm.get('clientName').patchValue(null)
        this.jobPostForm.get('clientName').enable()
      }
    }
    if (value == GigsumoConstants.DIRECT_HIRE && this.userType != "FREELANCE_RECRUITER") {
      this.onChangeCountry(this.jobPostedBehalfOflist[0].country, '');
      const stateTitleCase = this.jobPostedBehalfOflist[0].state;
      this.jobPostForm.patchValue({ country: this.jobPostedBehalfOflist[0].country })
      this.jobPostForm.patchValue({ city: this.jobPostedBehalfOflist[0].city })
      this.jobPostForm.patchValue({ state: stateTitleCase });
      this.jobPostForm.patchValue({ zipCode: this.jobPostedBehalfOflist[0].zipCode })
    } else if (value == GigsumoConstants.DIRECT_HIRE && this.userType === "FREELANCE_RECRUITER") {
      this.jobPostedBehalfOflist.forEach(ele => {
        if (ele.orgName === this.jobPostForm.get('jobPostedBehalfOf').value) {
          this.onChangeCountry(ele.country, '');
          this.jobPostForm.get('country').patchValue(ele.country);
          this.jobPostForm.get('city').patchValue(ele.city);
          this.jobPostForm.get('state').patchValue(ele.state);
          this.jobPostForm.get('zipCode').patchValue(ele.zipCode);
        }
      })
    } else if (value != GigsumoConstants.DIRECT_HIRE) {
      this.jobPostForm.get('country').patchValue(null)
      this.jobPostForm.get('state').patchValue(null)
      this.jobPostForm.get('city').patchValue(null)
      this.jobPostForm.get('zipCode').patchValue(null)
    }
  }



  noResult: boolean = false
  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
    this.jobPostForm.patchValue({
      organisationId: null
    })
  }

  closeEmailDomainValidator() {
    this.beingEdited = false
    if (this.otpEmailSent == true) {

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure you want to discontinue the validation?",
          text: "If you ignore this process, you may not create Jobs or Candidates.",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.domainForm.get('domainValidationOtp').patchValue(null)
            this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
            this.domainForm.get('domainValidationOtp').clearValidators()
            this.domainForm.get('domainValidationOtp').updateValueAndValidity()
            this.domainForm.get('swapEmail').patchValue(null)
            this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
            this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
            this.domainForm.get('swapEmail').setErrors({ emailExistsAlready: null })
            this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
            this.otpEmailSent = false
            this.commonVariables.emailDomainValidation = false
            this.searchData.setCommonVariables(this.commonVariables)
            this.modalService.hide(1);
            this.modalService.hide(2);
            this.modalService.hide(3);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.commonVariables.emailDomainValidation = true
            this.searchData.setCommonVariables(this.commonVariables)
            if (this.openModal == true) {

              // this.modalRef = this.modalService.show(this.postTemplate, this.backdropConfig);
            }
          }
        })
    } else if (this.otpEmailSent == false) {
      if (this.openModal == true) {
        this.modalRef.hide()
        setTimeout(() => {
          this.domainForm.get('domainValidationOtp').patchValue(null)
          this.commonVariables.emailDomainValidation = false
          this.searchData.setCommonVariables(this.commonVariables)
        }, 1000);
      } else {
        this.domainForm.get('domainValidationOtp').patchValue(null)
        this.commonVariables.emailDomainValidation = false
        this.searchData.setCommonVariables(this.commonVariables)
      }

    }
  }

  edit() {
    this.otpEmailSent = false
  }

  otpEmailSent: boolean = false
  domainValidatorSubmit: boolean = false
  proceedAfterValidation(param) {
    this.domainValidatorSubmit = true
    if (this.domainForm.valid) {
      var validateEmail: any;
      validateEmail = this.domainForm.value.swapEmail.split('@')[1];
      const a = this.domainList.indexOf(validateEmail)
      if (a != '-1') {
        this.domainForm.get('swapEmail').setErrors({ genericDomain: true })
      } else {
        this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
        this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
        // this.commonVariables.emailDomainValidation = false

        var data: any = {}
        data.email = this.domainForm.value.swapEmail
        data.firstName = this.firstName
        data.lastName = this.lastName
        data.userId = this.userId
        this.api.create('user/sendOtpToMailId', data).subscribe(res => {
          if (res.code == '00000') {
            this.otpEmailSent = true
            this.domainForm.get('domainValidationOtp').setValidators([Validators.required])
            this.domainForm.get('domainValidationOtp').updateValueAndValidity()

            this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
            this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })

            this.domainForm.get('swapEmail').setErrors({ emailExistsAlready: null })
            this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })

            // CHECK IF WORK EXPERIENC HAS BEEN PROVIDED

            // Here work exp check
            // if (param == 'JOBS' && workExperience.length == 0) {
            //    this.workExperiencecheck();
            // }else if (param == 'JOBS' && workExperience.length > 0) {
            // } else  if (param == 'CANDIDATE') {
            // }


          } else if (res.code == '99998') {
            this.otpEmailSent = false
            this.domainForm.get('swapEmail').setErrors({ emailExistsAlready: true })
          }
        })
        if (param == 'JOBS') {

          // this.commonVariables.jobPostingFlag = true
          // this.commonVariables.candidatePostingFlag = false
          // this.searchData.setCommonVariables(this.commonVariables)
        } else if (param == 'CANDIDATE') {
          // this.commonVariables.jobPostingFlag = false
          // this.commonVariables.candidatePostingFlag = true
          // this.searchData.setCommonVariables(this.commonVariables)
        }
      }
    }
  }


  validateOtp(param) {
    if (this.domainForm.value.domainValidationOtp == null || this.domainForm.value.domainValidationOtp == '' || this.domainForm.value.domainValidationOtp == undefined) {
      this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: true })
    } else {
      var data: any = {}
      data.primaryMailId = this.domainForm.value.swapEmail
      if (this.secondaryEmail == null || this.secondaryEmail == undefined || this.secondaryEmail == 'None provided') {
        data.secondaryMailId = this.primaryEmail  // working pending hre abu
      } else if (this.secondaryEmail != null && this.secondaryEmail != undefined && this.secondaryEmail != 'None provided') {
        data.secondaryMailId = this.secondaryEmail
      }
      data.entityId = this.userId
      data.businessId = this.userId
      data.otp = this.domainForm.value.domainValidationOtp
      this.util.startLoader()
      this.api.create('user/verifyOTPToPrimaryMailId', data).subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
          this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })
          this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
          this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })

          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please use the new business email address to login to the application, the next time you login.",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            // this.langdingPageNavBarComponent.onLogout()
          })
        } else if (res.code == '99999') {
          this.util.stopLoader();
          this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: true })

        }
        else if (res.code == '99998') {
          this.util.stopLoader();
          this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: true })

        }
      })
    }
  }

  closeValidator(param) {
    this.beingEdited = false
    if (this.openModal == true) {
      this.modalRef.hide()
      setTimeout(() => {
        this.domainValidatorSubmit = false
        this.otpEmailSent = false
        this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
        this.domainForm.get('domainValidationOtp').clearValidators()
        this.domainForm.get('domainValidationOtp').updateValueAndValidity()
        this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
        this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
        this.domainForm.get('swapEmail').setErrors({ emailExistsAlready: null })
        this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
        if (param == 'JOBS') {
          this.commonVariables.emailDomainValidation = false
          this.searchData.setCommonVariables(this.commonVariables)
        } else if (param == 'CANDIDATE') {
          this.commonVariables.emailDomainValidation = false
          this.searchData.setCommonVariables(this.commonVariables)
        }
      }, 1000);
    } else {
      this.domainValidatorSubmit = false
      this.otpEmailSent = false
      this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
      this.domainForm.get('domainValidationOtp').clearValidators()
      this.domainForm.get('domainValidationOtp').updateValueAndValidity()
      this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
      this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
      this.domainForm.get('swapEmail').setErrors({ emailExistsAlready: null })
      this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
      if (param == 'JOBS') {
        this.commonVariables.emailDomainValidation = false
        this.searchData.setCommonVariables(this.commonVariables)
      } else if (param == 'CANDIDATE') {
        this.commonVariables.emailDomainValidation = false
        this.searchData.setCommonVariables(this.commonVariables)
      }
    }

  }
  userid = localStorage.getItem('userId')

  async getToJob() {
    try {
      this.util.startLoader();

      // Pre-select Marketplace for Free plan users before form initialization
      if (this.membershipType === 'Free') {
        this.selectedNetworks = ['1'];
      } else {
        this.selectedNetworks = [];
      }

      await this.generateYears();
      await this.getCountries();
      await this.jobformfield();
      await this.onchangejob();
      // All asynchronous operations are complete at this point
      await this.getListValues('JOBS');
    } catch (error) {
    } finally {
      this.util.stopLoader();
    }
  }
  currentOrganisationRequired: boolean = true
  removeCurrentOrgValidation() {
    this.currentOrganisationRequired = false
    this.jobPostForm.get('jobPostedBehalfOf').clearValidators();
    this.jobPostForm.get('jobPostedBehalfOf').updateValueAndValidity();
  }

  addCurrentOrgValidation() {
    this.currentOrganisationRequired = true
    this.jobPostForm.get('jobPostedBehalfOf').setValidators([Validators.required]);
    this.jobPostForm.get('jobPostedBehalfOf').updateValueAndValidity();
  }



  OnChangeCurrentOrg(selectedOrg: string) {
    if (this.jobPostForm.get('clientType').value == GigsumoConstants.DIRECT_HIRE) {
      this.jobPostForm.patchValue({ clientName: this.jobPostForm.get("jobPostedBehalfOf").value })
      this.jobPostForm.get("clientName").disable();
    }
    this.jobPostedBehalfOflist.forEach(ele => {
      if (ele.orgName === selectedOrg && this.jobPostForm.get('clientType').value != GigsumoConstants.DIRECT_HIRE) {
        this.jobPostForm.get('country').patchValue(ele.country);
      } else if (ele.orgName === selectedOrg && this.jobPostForm.get('clientType').value == GigsumoConstants.DIRECT_HIRE) {
        this.jobPostForm.get('country').patchValue(ele.country);
        this.jobPostForm.get('state').patchValue(ele.state);
        this.jobPostForm.get('city').patchValue(ele.city);
        this.jobPostForm.get('zipCode').patchValue(ele.zipCode);
      }
    });
  }

  jobformfield() {
    this.util.startLoader();
    var country: any = ''
    let location: Location;
    if (this.userdata1 != null) {
      this.userdata1.forEach(ele => {
        if (ele.currentOrganization == true) {
          country = ele.country;
          location = {
            country: ele.country, city: ele.city, state: ele.state, zipCode: ele.zipcode
          };
        }
      })
      if (location != undefined) this.onChangeCountry(location.country, '');
    }

    this.jobPostForm = new AppSettings().getCreateJobForm(location);

    
  }

  onchangejob() {
    try {
      var formval: any = localStorage.getItem(this.userid + "_landingPagejobPostForm")
      if (formval != null || formval != undefined) {
        formval = formval.slice(1, -1)

        var tempdata: CryptoJS.lib.WordArray = CryptoJS.AES.decrypt(decodeURIComponent(formval), "secret key");
        var decrypt: any = JSON.parse(tempdata.toString(CryptoJS.enc.Utf8));

        setTimeout(() => {

          if (decrypt.secondarySkills != null) {
            decrypt.secondarySkills.forEach(ele => {
              this.secondarySkillsSelected.push(ele)
            })
          }
          if (decrypt.primarySkills != null) {
            decrypt.primarySkills.forEach(ele => {
              this.primarySkillsSelected.push(ele)
            });
          }

          this.jobPostForm.patchValue(decrypt)
          this.onClientTypeChange(decrypt.clientType);

        }, 4000);
      }
    } catch (error) {
      localStorage.removeItem(this.userid + "_landingPagejobPostForm")
    }
  }

  domainForm: UntypedFormGroup

  get domainControl() {
    return this.domainForm.controls
  }

  primaryEmail: any;
  firstName: any;
  lastName: any;
  phoneNo: any;
  secondaryEmail: any = null
  openModal: boolean = false
  domainList: any = []
  creditPoints: any;
  currentEntity: any;
  workExp: Array<WorkExperience>;
  clientType: any;
  beingEdited: boolean = false
  @ViewChild("postableconsole") postableconsole;
  userdata1: any;
  userdatacandidate: any;
  workauthcountry: any;
  currentOrg: boolean;
  showContent: "JOBS" | "CANDIDATE";

  async createJobsOrCandidates(param, boolean: boolean = true, called: boolean = false) {
    this.gigsumoService.buttonClicked = false;
    this.beingEdited = true;
    this.showContent = param;
    this.currentEntity = param;
    this.parseSuccess = false;

    if (!called) {
      let hasCurrentOrganization: boolean = await this.userService.checkIfUserHasCurrentOrganization(
        { userId: this.userId, userType: this.userType });
      if (!hasCurrentOrganization && this.userType != 'FREELANCE_RECRUITER' && this.userType != 'JOB_SEEKER') {
        this.addWorkExperience();
        return;
      }
    }

    try {

      this.util.startLoader();

      const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS");

      if (isPlanValid) {
        this.afterValidatePlan(param, boolean);
        this.util.stopLoader();
      }

      this.beingEdited = false;
      this.gigsumoService.buttonClicked = true;
      this.util.stopLoader();

    } catch (error) {

    } finally {

      this.util.stopLoader();
    }

  }



  afterValidatePlan(param, boolean) {
    this.disable_for_draft = false;
    this.submit = false;
    this.candidateSubmit = false;
    this.currentDate = [];
    this.maxDate = [];
    this.commonVariables.creditFlag = false
    this.commonVariables.educationFlag = false
    this.commonVariables.workExperienceFlag = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.candidatePostingFlag = false
    this.commonVariables.postPrivacyFlag = false
    this.commonVariables.emailDomainValidation = false
    this.commonVariables.postFormflag = false;
    // this.commonVariables.postPrivacyFlag = true


    if (boolean == true) {
      this.openModal = true
    } else {
      this.openModal = false
    }
    this.currentOrg = false
    // console.log(this.openModal)
    this.fileDragdrop = null;
    this.commonVariables.creditFlag = false;
    var data: any = {}
    data.userId = this.userId
    data.userType = this.userType
    this.util.startLoader();
    this.api.create('user/profileDetails', data).subscribe(res => {
      this.util.stopLoader()

      this.clientType = res.data.userData.clientType
      this.userdata1 = res.data.exeperienceList
      this.userdatacandidate = res.data.exeperienceList
      if (res.data && res.data.exeperienceList) {
        res.data.exeperienceList.forEach(workExperience => {
          if (workExperience.currentOrganization) {
            this.currentOrg = true;
            this.currentOrganizationDetail = workExperience;
            this.workauthcountry = workExperience.country;
          }

        });
      }

      this.onChangeCountry(this.workauthcountry, null)

      this.firstName = res.data.userData.firstName;
      this.lastName = res.data.userData.lastName;
      this.phoneNo = res.data.userData.phoneNo;
      this.primaryEmail = res.data.userData.email;
      if (res.data.userData.secondaryEmail == null || res.data.userData.secondaryEmail == undefined) {
        this.secondaryEmail = 'None provided'
      } else {
        this.secondaryEmail = res.data.userData.secondaryEmail
      }

      var validateEmail: any;
      validateEmail = this.primaryEmail.split('@')[1];

      res.data.GIGSUMO_GENERIC_EMAIL_DOMAINS.listItems.forEach(ele => {
        this.domainList.push(ele.item)
      })
      // this.firstName = res.data.userData.firstName;
      // this.lastName = res.data.userData.lastName;
      // this.primaryEmail = res.data.userData.email;
      // if (res.data.userData.secondaryEmail == null || res.data.userData.secondaryEmail == undefined) {
      //   this.secondaryEmail = 'None provided'
      // } else {
      //   this.secondaryEmail = res.data.userData.secondaryEmail
      // }
      var validateEmail: any;
      validateEmail = this.primaryEmail.split('@')[1];
      const a = this.domainList.indexOf(validateEmail)

      if (param === 'JOBS' && ((res.data.exeperienceList == null || res.data.exeperienceList.length == 0) || (res.data.exeperienceList.length > 0 && !this.currentOrg))) {
        if (this.userType != 'FREELANCE_RECRUITER') {
          this.addWorkExperience(res.data.userData.clientType);
        }
        //Showing timezonepopup only forfreelancer by monisha
        else if (this.userType == 'FREELANCE_RECRUITER' && res.data.userData.timeZoneCountry == null) {
          this.showModal = true;
        } else {
          if (this.currentEntity == 'JOBS') {
            this.getToJob()
          } else if (this.currentEntity == 'CANDIDATE') {
            this.getToCandidate()
          }
        }
      }
      else if (param === 'JOBS' && ((res.data.exeperienceList != null || res.data.exeperienceList.length > 0) && this.currentOrg)) {
        res.data.exeperienceList.forEach(ele => {
          this.workExperienceDetailsCheck.push(ele)
        })

        if (this.currentEntity == 'JOBS') {
          this.getToJob()
        } else if (this.currentEntity == 'CANDIDATE') {
          this.getToCandidate()
        }
      }

      else if (this.userType != 'FREELANCE_RECRUITER' && param === 'CANDIDATE' && ((res.data.exeperienceList === null || res.data.exeperienceList.length === 0) || (res.data.exeperienceList.length > 0 && !this.currentOrg))) {

        res.data.exeperienceList.forEach(ele => {
          this.workExperienceDetailsCheck.push(ele)
        })
        this.addWorkExperience(res.data.userData.clientType);
      } else if (this.userType == 'FREELANCE_RECRUITER' && param === 'CANDIDATE' && res.data.userData.timeZoneCountry == null) {
        this.showModal = true;
      } else if (this.userType == 'FREELANCE_RECRUITER' && param === 'CANDIDATE' && res.data.userData.timeZoneCountry != null) {
        this.getToCandidate();
      }
      else if (param === 'CANDIDATE' && ((res.data.exeperienceList != null || res.data.exeperienceList.length > 0) && this.currentOrg)) {
        //single candidate validation by jobseeker by monisha
        if (this.userType == 'JOB_SEEKER') {
          if (res.data.candidateList) {
            const activeCandidates = res.data.candidateList.filter(candidate => candidate.status.toUpperCase() === 'ACTIVE');
            if (activeCandidates.length >= 1) {
              this.beingEdited = false
              this.gigsumoService.buttonClicked = true;
              Swal.fire({
                position: "center",
                icon: "info",
                title: "Number of profiles exceeded",
                text: "You can't create more than 1 profile for yourself as a job seeker.",
                showConfirmButton: true,
                showCancelButton: false,
              })
            } else if (res.data.candidateList.length < 1) {

              let element: any = {};

              if (localStorage.getItem('userType') == res.data.userData.userType && this.currentEntity == 'JOBS') {

              } else if (localStorage.getItem('userType') == res.data.userData.userType && this.currentEntity == 'CANDIDATE') {

              }



              if (this.currentEntity == 'JOBS') {
                this.getToJob()
              } else if (this.currentEntity == 'CANDIDATE') {

                this.getToCandidate()
              }

            }
          } else {
            let element: any = {};
            if (localStorage.getItem('userType') == res.data.userData.userType) {
              element = res.data.creditConsumptions.find(item => item.creditType === AppSettings.UPGRADE_CANDIDATE)
            }
            if (this.currentEntity == 'JOBS') {
              this.getToJob()
            } else if (this.currentEntity == 'CANDIDATE') {

              this.getToCandidate()
            }

          }
        }
        else {
          res.data.exeperienceList.forEach(ele => {
            this.workExperienceDetailsCheck.push(ele)
          })
          if (this.currentEntity == 'JOBS') {
            this.getToJob()
          } else if (this.currentEntity == 'CANDIDATE') {
            this.getToCandidate()
          }
        }
      }

    })
  }

  openJobOrCandidate(openForm: { content: string, data: any }) {
    if (openForm.content == 'JOBS') {
      this.getToJob();
      this.commonVariables.jobPostingFlag = true
      this.commonVariables.candidatePostingFlag = false
      this.commonVariables.workExperienceFlag = false
      this.commonVariables.educationFlag = false
      this.commonVariables.emailDomainValidation = false
      this.searchData.setCommonVariables(this.commonVariables)

    } else if (openForm.content == 'CANDIDATE') {
      this.getToCandidate();
      this.commonVariables.candidatePostingFlag = true
      this.commonVariables.jobPostingFlag = false
      this.commonVariables.workExperienceFlag = false
      this.commonVariables.educationFlag = false
      this.commonVariables.emailDomainValidation = false
      this.searchData.setCommonVariables(this.commonVariables);
    } else if (openForm.content == 'CREDIT') {
      this.commonVariables.creditFlag = true
      this.commonVariables.educationFlag = false
      this.commonVariables.workExperienceFlag = false
      this.commonVariables.jobPostingFlag = false
      this.commonVariables.candidatePostingFlag = false
      this.commonVariables.postPrivacyFlag = false
      this.commonVariables.emailDomainValidation = false
    }

    setTimeout(() => {
      this.createJobsOrCandidates(this.currentEntity, true, true);
    }, 1000);

  }
  timezonepopup() {
    this.createJobsOrCandidates(this.currentEntity, true, true);
  }
  modelclose(data) {
    this.gigsumoService.buttonClicked = true;
    this.modalService.hide(1);
    this.beingEdited = false;
    this.openModal = false;
    this.showModal = false
  }


  getCountries_forform() {
    this.countryList = [];
    this.util.startLoader();
    this.api.query("country/getAllCountries").subscribe((res) => {
      this.util.stopLoader();
      if (res != undefined) {
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }



  changecountry(countryCode) {
    this.timeZonecountryforFreelaucher(countryCode)
  }

  timeZonecountryforFreelaucher(countryCode) {
    this.timezoneslist = [];
    this.api.query("user/timeZoneByCountryCode/" + countryCode).subscribe((res) => {
      if (res) {
        this.util.stopLoader();
        this.timezoneslist = res.data.zones;
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  checkspace(event: any): boolean {
    return super.validSpace(event);
  }

  showThis(event, i) {
    if (event.target.checked == true) {

      this.commonVariables.noOrgSelected = false;
      this.searchData.setCommonVariables(this.commonVariables);
    } else if (event.target.checked == false) {
      this.commonVariables.noOrgSelected = true;
      this.searchData.setCommonVariables(this.commonVariables);
    }
  }
  saveWorkExperience() {
    this.workSaveFlag = true
    if (this.eperienceForm.valid) {
      this.currentOrg = true;

      this.util.startLoader();
      this.api.create("user/v1/workexperience", this.workExperience.getRawValue()[0]).subscribe((res) => {
        if (res.code == '00000') {
          this.util.stopLoader();
          // Invalidate user cache so profile page shows fresh data
          this.cacheInvalidationService.invalidateCurrentUserCache();
          localStorage.setItem("currentOrganization", this.workExperience.getRawValue()[0].organisationName)
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Work Experience added successfully",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {


            var profiledata: any = {}
            profiledata.userId = localStorage.getItem('userId')
            profiledata.userType = localStorage.getItem('userType')
            this.api.create('user/profileDetails', profiledata).subscribe(res => {
              let element: any = {};
              this.clientType = res.data.userData.clientType
              if (localStorage.getItem('userType') == res.data.userData.userType && this.currentEntity == 'JOBS') {

              } else if (localStorage.getItem('userType') == res.data.userData.userType && this.currentEntity == 'CANDIDATE') {

              }
              if (this.currentEntity == 'JOBS') {
                this.getToJob()
              } else if (this.currentEntity == 'CANDIDATE') {
                this.getToCandidate()
              }
            })
          })
        }
      })
    }
  }

  closeWorkExperience() {
    this.gigsumoService.buttonClicked = true;
    this.beingEdited = false
    if (this.openModal == true) {
      this.modalRef.hide()
      setTimeout(() => {
        this.commonVariables.creditFlag = false
        this.commonVariables.educationFlag = false
        this.commonVariables.workExperienceFlag = false
        this.commonVariables.jobPostingFlag = false
        this.commonVariables.candidatePostingFlag = false
        this.commonVariables.postPrivacyFlag = false
        this.commonVariables.emailDomainValidation = false
      }, 1500);
    } else {
      this.commonVariables.creditFlag = false
      this.commonVariables.educationFlag = false
      this.commonVariables.workExperienceFlag = false
      this.commonVariables.jobPostingFlag = false
      this.commonVariables.candidatePostingFlag = false
      this.commonVariables.postPrivacyFlag = false
      this.commonVariables.emailDomainValidation = false
    }

  }



  routeToCredits() {

    this.showmodel = true
    this.modalRef.hide();
    this.router.navigate(['checkout'])


  }

  workExperience: UntypedFormArray
  eperienceForm: UntypedFormGroup
  currentYear: any = new Date().getFullYear();

  educationDetail: UntypedFormArray;
  addEducation() {
    this.generateYears1()
    this.getCountries()
    this.eduForm = this.formBuilder.group({
      educationDetail: this.formBuilder.array([]),
    });


    this.getInstitutions()
  }


  addWorkExperience(clientType: string = null) {
    this.generateYears1()
    var data = { "domain": "CLIENT_TYPE,PAY_TYPE,GIGSUMO_JOB_TITLE,GIGSUMO_RECRUITERS_TITLE_LIST" }
    this.clientTypeList = []
    this.candidateJobTitleList = []
    this.recruiterTitleList = []
    this.util.startLoader();
    this.api.create('listvalue/findbyList', data).subscribe(res => {
      this.util.stopLoader();
      if (res.code == '00000') {
        res.data.CLIENT_TYPE.listItems.forEach(ele => {
          // if (this.clientType == "Direct Client" && ele.item == "Direct Client") {
          //   ele.item = "Client";
          // }
          this.clientTypeList.push(ele.item);
        })

        res.data.GIGSUMO_JOB_TITLE.listItems.forEach(ele => {
          this.candidateJobTitleList.push(ele.item)
        })

        res.data.GIGSUMO_RECRUITERS_TITLE_LIST.listItems.forEach(ele => {
          this.recruiterTitleList.push(ele.item)
        })

        this.getOrganization(clientType)

      }
    })

  }

  get geteducation() {
    return this.eduForm.get("educationDetail") as UntypedFormArray;
  }

  getEducationFormGroup(index: any): UntypedFormGroup {
    const formGroup = this.educationDetail.controls[index] as UntypedFormGroup;
    return formGroup;
  }

  sortConfigEdu: TypeaheadOrder = {
    direction: "desc",
    field: "institutionName",
  };

  currentlyPursued(event, index) {
    if (event.target.checked == true) {
      this.educationDetail.controls[index].patchValue({
        currentlyPursued: true,
      });
      this.educationDetail.controls[index].patchValue({
        endYear: this.currentYear,
      });
      this.educationDetail.controls[index].patchValue({ endMonth: null });

      this.educationDetail.controls.forEach((ele) => {
        ele.get("endYear").clearValidators();
        ele.get("endYear").updateValueAndValidity();
        ele.get("endMonth").clearValidators();
        ele.get("endMonth").updateValueAndValidity();
      });
    } else if (event.target.checked == false) {
      this.educationDetail.controls[index]
        .get("currentlyPursued")
        .markAsUntouched();
      this.educationDetail.controls[index]
        .get("currentlyPursued")
        .updateValueAndValidity();

      this.educationDetail.controls[0].patchValue({ showThisOnProfile: false });
      this.educationDetail.controls[index].patchValue({
        endYear: this.currentYear,
      });
      this.educationDetail.controls[index].patchValue({ endMonth: null });
      this.educationDetail.controls.forEach((ele) => {
        ele.get("endMonth").setValidators([Validators.required]);
        ele.get("endMonth").updateValueAndValidity();
        ele.get("endYear").setValidators([Validators.required]);
        ele.get("endYear").updateValueAndValidity();
      });
    }
  }

  schoolData: any = {}
  onChangeSchool(event, index) {
    //// console.log(event.item);
    var data = event.value + "/" + event.item.institutionId;
    this.util.startLoader();
    this.api.query("care/intitutions/" + data).subscribe((res) => {
      this.util.stopLoader();
      res.forEach((ele) => {
        this.schoolData.institutionId = event.item.institutionId;
        this.schoolData.city = ele.city;
        this.schoolData.eduId = ele.eduId;
        this.schoolData.userId = this.userId;
        this.schoolData.state = ele.state;
        this.schoolData.country = ele.country;
        this.schoolData.zipcode = ele.zipCode && ele.zipCode !== null ? ele.zipCode : null;
        this.schoolData.street = ele.street && ele.street !== null ? ele.street : null;
        this.getEducationFormGroup(index).patchValue(this.schoolData);

        this.educationDetail.controls[0].get('city').disable()
        this.educationDetail.controls[0].get('country').disable()
        this.educationDetail.controls[0].get('state').disable()
        this.educationDetail.controls[0].get('zipcode').disable()
        this.educationDetail.controls[0].get('street').disable()
      });
    }, err => {
      this.util.stopLoader();
    });
  }

  eduSaveFlag: boolean = false

  eduForm: UntypedFormGroup
  instList: any = []
  getInstitutions() {
    this.instList = []
    this.util.startLoader()
    this.api.query("care/institutions").subscribe((res) => {
      if (res) {
        this.util.stopLoader()
        this.instList = [];
        res.forEach((ele) => {
          var obj: any = {};
          obj.institutionId = ele.institutionId;
          obj.institutionName = ele.institutionName;
          obj.city = ele.city;
          obj.state = ele.state;
          obj.country = ele.country;
          obj.countryName = ele.countryName;
          obj.street = ele.street && ele.street !== null ? ele.street : null;
          this.instList.push(obj);
        });
      }
    }, err => {
      this.util.stopLoader();
    });



    this.educationDetail = this.eduForm.get("educationDetail") as UntypedFormArray;
    this.educationDetail.push(this.createEducation());
    this.commonVariables.educationFlag = true
    this.commonVariables.workExperienceFlag = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.candidatePostingFlag = false
    this.commonVariables.postPrivacyFlag = false
    this.commonVariables.emailDomainValidation = false
    if (this.openModal == true) {
      this.modalRef = this.modalService.show(this.postTemplate, this.backdropConfig);
    }
  }


  createEducation() {
    return this.formBuilder.group({
      schoolName: [null, [Validators.required]],
      institutionId: [null],
      eduId: [null],
      userId: [null],
      degree: [null, [Validators.required]],
      showThisOnProfile: [false],
      currentlyPursued: [true],
      startMonth: [null, [Validators.required]],
      timeZone: [null, [Validators.required]],
      startYear: [this.currentYear, [Validators.required]],
      endMonth: [null],
      endYear: [this.currentYear],
      city: [null, [Validators.required, CustomValidator.max(this.CITY.max)]],
      street: [null, [Validators.required]],
      state: [null, [Validators.required, CustomValidator.max(this.STATE.max)]],
      zipcode: [null, [Validators.required, CustomValidator.minmaxLetters(this.ZIPCODE.min, this.ZIPCODE.max)]],
      country: [null, [Validators.required]],
      speciality: [null, [Validators.required]],
    });
  }



  getWorkFormGroup(index): UntypedFormGroup {
    const formGroup = this.workExperience.controls[index] as UntypedFormGroup;
    return formGroup;
  }

  curOrg(event, index) {

    if (event.target.checked == true) {

      this.workExperience.controls[index].patchValue({
        currentOrganization: true,
      });
      this.workExperience.controls[index].patchValue({
        endYear: this.currentYear,
      });
      this.workExperience.controls[index].patchValue({ endMonth: null });

      this.workExperience.controls.forEach((ele) => {
        ele.get("endYear").clearValidators();
        ele.get("endYear").updateValueAndValidity();
        ele.get("endMonth").clearValidators();
        ele.get("endMonth").updateValueAndValidity();
      });
    } else if (event.target.checked == false) {

      this.workExperience.controls[index]
        .get("currentOrganization")
        .markAsUntouched();
      this.workExperience.controls[index]
        .get("currentOrganization")
        .updateValueAndValidity();

      this.workExperience.controls[index].patchValue({
        endYear: this.currentYear,
      });
      this.workExperience.controls[index].patchValue({ endMonth: null });

      this.workExperience.controls.forEach((ele) => {
        ele.get("endMonth").setValidators([Validators.required]);
        ele.get("endMonth").updateValueAndValidity();
        ele.get("endYear").setValidators([Validators.required]);
        ele.get("endYear").updateValueAndValidity();
      });
      this.workExperience.controls[0]
        .get("badge")
        .setErrors({ checkIfChecked: true });
    }

  }
  profileyears: any = []
  generateYearsprofile() {
    var max = new Date().getFullYear();
    var min = max - 80;
    for (var i = min; i <= max; i++) {
      this.profileyears.push(i);
    }
  }

  monthChange(index, val) {
    if (val == "exp") {
      var a: any = this.workExperience.value[index].startYear;
      var b: any = this.workExperience.value[index].endYear;
      if (a == b) {
        this.workExperience.controls[index].patchValue({
          endMonth: null,
        });
      }
    } else if (val == "edu") {

    }
  }

  months: any = [
    { code: 1, name: "January" },
    { code: 2, name: "February" },
    { code: 3, name: "March" },
    { code: 4, name: "April" },
    { code: 5, name: "May" },
    { code: 6, name: "June" },
    { code: 7, name: "July" },
    { code: 8, name: "August" },
    { code: 9, name: "September" },
    { code: 10, name: "October" },
    { code: 11, name: "November" },
    { code: 12, name: "December" },
  ];

  yearIndex: any;
  yearData: any;

  zipCodeValidaiton(x: number): boolean {
    if (String(x).length > 10) {
      return false;
    }
    return true;
  }

  yearChange(index, event, val, par) {
    if (val == "exp") {
      var stYr = parseInt(this.workExperience.value[index].startYear);
      var maxYr = new Date().getFullYear();
      if (stYr == maxYr) {
        this.workExperience.controls[index].patchValue({ startMonth: null });
      }
      this.yearData = event.target.value;
      this.yearIndex = index;
      this.workExperience.controls[index].patchValue({
        endYear: this.currentYear,
        endMonth: null,
      });
    }

  }

  onChangeYear(i, val, par) {
    const maxyr = new Date().getFullYear();
    if (val == "exp") {
      if (
        this.workExperience.value[0].startYear ==
        this.workExperience.value[0].endYear ||
        this.workExperience.value[0].endYear == maxyr
      ) {
        this.workExperience.controls[0].patchValue({ endMonth: null });
      }
      if (
        this.workExperience.value[0].startYear ==
        this.workExperience.value[0].endYear
      ) {
        this.validateMonth = true;
      } else {
        this.validateMonth = false;
      }
    }

  }

  checkYear(y, i, val) {

    if (val == "exp") {
      let yearDataInt = parseInt(this.workExperience.value[i].startYear);
      let year = parseInt(y);
      if (yearDataInt != null) {
        if (yearDataInt > year) {
          return true;
        } else {
          return false;
        }
      }
    }

  }


  validateMonth: boolean;

  checkMonth(m, i, val) {
    var max = new Date().getFullYear();
    if (val == "exp") {
      let endyr = parseInt(this.workExperience.value[i].endYear);
      let stMonth = this.workExperience.value[i].startMonth;
      let styr = parseInt(this.workExperience.value[i].startYear);
      let stMonthCode;
      let n = new Date().getMonth();
      let monthCode = m;
      this.months.forEach((e) => {
        if (e.name == stMonth) {
          stMonthCode = e.code;
        }
      });
      if (styr == max && (this.validateMonth || styr == endyr)) {
        if (monthCode > n + 1 || stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != max && (this.validateMonth || styr == endyr)) {
        if (stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != endyr && endyr == max) {
        if (monthCode > n + 1) {
          return true;
        } else {
          return false;
        }
      }
    }


  }

  checkMonth1(m, i, val) {
    if (val == "exp") {
      var n = new Date().getMonth();
      var maxYear = new Date().getFullYear();
      var maxMonth = n + 1;
      var monthCode = m;
      let startYear = parseInt(this.workExperience.value[i].startYear);
      if (startYear == maxYear) {
        if (monthCode > maxMonth) {
          return true;
        } else {
          return false;
        }
      }
    }

  }



  getOrganization(clientType: string = null) {
    this.eperienceForm = this.formBuilder.group({
      workExperience: this.formBuilder.array([])
    })
    this.workExperience = this.eperienceForm.get("workExperience") as UntypedFormArray;
    this.workExperience.push(this.createWorkExperience());
    if (this.workExperience.controls[0].get('timeZone') != null && this.userType == "JOB_SEEKER") {
      this.workExperience.controls[0].get('timeZone').clearValidators()
      this.workExperience.controls[0].get('timeZone').updateValueAndValidity()
    }
    this.workExperience.at(0).get('clientType').patchValue(clientType)
    this.commonVariables.workExperienceFlag = true
    this.commonVariables.educationFlag = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.candidatePostingFlag = false
    this.commonVariables.postPrivacyFlag = false
    this.commonVariables.emailDomainValidation = false;
    this.searchData.setCommonVariables(this.commonVariables);
    this.modalRef = this.modalService.show(this.postTemplate, this.backdropConfig);
    this.currentOrgProvider.setCurrentOrg(this.workExperience.controls[0].get('currentOrganization').value);

  }
  closeflagModal() {
    this.commonVariables.workExperienceFlag = false;
    this.beingEdited = false;
  }


  autoComplete: MatAutocompleteTrigger;
  searchBarShow: boolean = false
  uniqueOrgList: Array<Partial<HealthCareOrganization>> = [];

  getOrgList(value) {
    if (value != null) {
      const orgList: Array<Partial<HealthCareOrganization>> = [];
      this.api.query("care/organizations?organizationName=" + this.workExperience.value[0].organisationName)
        .pipe(debounceTime(500))
        .subscribe((res) => {
          if (res) {
            res.forEach(ele => {
              var obj: any = {}
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.zipCode = ele.zipCode;
              obj.address1 = ele.address1;
              obj.address2 = ele.address2;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList.push(obj);
            })
            const uniqueList = new Set(orgList);
            this.uniqueOrgList = Array.from(uniqueList);
          }

        }, err => {
          this.util.stopLoader();

        });
      this.searchBarShow1 = true;
    } else {
      this.searchBarShow1 = false
    }
  }


  // when no result matched the value, organization id is set to null
  changeTypeaheadNoResults(index, val) {
    if (val == "work") {
      this.getWorkFormGroup(index).patchValue({
        organisationId: null,
      });
    } else if (val == "edu") {

    }

  }


  workSaveFlag: boolean = false;

  createWorkExperience(): UntypedFormGroup {
    return this.formBuilder.group({
      currentOrganization: [true],
      organisationName: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/),
        ]),
      ],
      clientType: [null, [Validators.required]],
      action: [null],
      businessId: [null],
      expId: [null],
      userId: [this.userId],
      badge: [true],
      organisationId: [null],
      timeZone: [null, [Validators.required]],
      title: [null, [Validators.required]],
      state: [null, [Validators.required, CustomValidator.max(this.STATE.max)]],
      zipcode: [null, [Validators.required, CustomValidator.minmaxLetters(this.ZIPCODE.min, this.ZIPCODE.max)]],
      city: [null, [Validators.required, CustomValidator.max(this.CITY.max)]],
      country: [null, [Validators.required]],
      startMonth: [null, [Validators.required]],
      startYear: [this.currentYear, [Validators.required]],
    });
  }

  saveEducation() {
    this.eduSaveFlag = true
    if (this.eduForm.valid) {
      this.util.startLoader();
      this.api
        .create("user/create/education", this.educationDetail.getRawValue()[0])
        .subscribe((res) => {
          this.util.stopLoader();
          if (res.code == "0000") {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Education added successfully",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {

              this.getToCandidate()
            })
          }
        })
    }
  }


  onChngOrg(event, source: 'INTERNAL' | 'EXTERNAL' = 'INTERNAL') {
    this.jobPostForm.patchValue({
      organisationId: event.organizationId
    })

    // Capture the selected client business identity so submit() can resolve
    // behalfOfBusinessId. EXTERNAL picks become the job's behalfOf context;
    // INTERNAL picks are the real client and behalfOf stays null.
    this.selectedClientBusinessId = event.organizationId || event.businessId || '';
    this.selectedClientBusinessName = event.organizationName || '';
    this.selectedClientSource = source;
  }

  onChngOrg1(value, index) {

    var data = value.organizationName + "/" + value.organizationId;
    this.util.startLoader();
    this.api.query("care/organization/" + data).subscribe((res) => {

      if (res) {
        const organisationSuggestedDetail = res[0]
        this.workExperience.controls[index].get('timeZone').enable()
        this.timeZonecountryvalues(res[0].countryCode);
        if (res[0].businessId) {
          this.workExperience.controls[index].get('country').disable()
          this.workExperience.controls[index].get('city').disable()
          this.workExperience.controls[index].get('state').disable()
          this.workExperience.controls[index].get('zipcode').disable()
          this.util.startLoader();
          this.api.query("business/details/" + res[0].businessId).subscribe((res) => {
            if (res.code == '00000') {

              this.util.stopLoader();
              if (res.data.businessModelList[0].organizationType && res.data.businessModelList[0].organizationType != null) {
                this.workExperience.controls[index].get('clientType').disable()
              } else {
                this.workExperience.controls[index].get('clientType').enable()
              }

              this.onChangeCountrypatchvalue(res.data.businessModelList[0].companyLocationDetails[0].country, 'work', index)
              setTimeout(() => {
                this.workExperience.controls[index].patchValue({
                  organisationId: organisationSuggestedDetail.organizationId,
                  clientType: res.data.businessModelList[0].organizationType,
                  country: res.data.businessModelList[0].companyLocationDetails[0].country,
                  city: res.data.businessModelList[0].companyLocationDetails[0].city,
                  state: res.data.businessModelList[0].companyLocationDetails[0].state,
                  zipcode: res.data.businessModelList[0].companyLocationDetails[0].zipCode
                })
              }, 500);
            } else {
              this.util.stopLoader();
              this.workExperience.controls[index].get('clientType').enable()
              this.workExperience.controls[index].get('country').enable()
              this.workExperience.controls[index].get('city').enable()
              this.workExperience.controls[index].get('state').enable()
              this.workExperience.controls[index].get('zipcode').enable()
              this.workExperience.controls[index].patchValue({
                clientType: null,
                country: null,
                city: null,
                state: null,
                zipcode: null
              })
            }
          }, err => {
            this.util.stopLoader();
            this.workExperience.controls[index].get('clientType').enable()
            this.workExperience.controls[index].get('country').enable()
            this.workExperience.controls[index].get('city').enable()
            this.workExperience.controls[index].get('state').enable()
            this.workExperience.controls[index].get('zipcode').enable()
            this.workExperience.controls[index].patchValue({
              clientType: null,
              country: null,
              city: null,
              state: null,
              zipcode: null
            })
          })
        } else {
          this.onChangeCountry(value.country, '');
          this.workExperience.controls[index].get('clientType').enable()
          this.workExperience.controls[index].get('country').enable()
          this.workExperience.controls[index].get('city').enable()
          this.workExperience.controls[index].get('state').enable()
          this.workExperience.controls[index].get('zipcode').enable()
          this.workExperience.controls[index].patchValue({
            clientType: null,
            country: value.country,
            city: value.city,
            state: value.state,
            zipcode: value.zipCode
          })
        }
      }

      setTimeout(() => {
        var data: any = {}
        data.userId = this.userId
        data.businessId = value.businessId
        data.organisationId = value.organizationId
        // this.util.startLoader()
        this.api.create('business/find/superadmin', data).subscribe(res => {
          if (res.code == '0000') {
            this.util.stopLoader()
            this.workExperience.controls[0].get("city").disable()
            this.workExperience.controls[0].get("state").disable()
            this.workExperience.controls[0].get("country").disable()
            this.workExperience.controls[0].get("zipcode").disable()
          } else {
            this.util.stopLoader()
          }
        })
      }, 500);
    }, err => {
      this.util.stopLoader();
    });
  }
  onChangeCountrypatchvalue(event, value, index) {
    if (value == "work") {
      this.workExperience.controls[index].patchValue({
        state: null,
        zipcode: null,
        city: null,

        country: event,
      });
      this.workExperience.controls.forEach((ele) => {
        ele.get("state").setValidators([Validators.required]);
        ele.get("state").updateValueAndValidity();
      });
    }
    if (event == "United States") {
    } else if (event == "AU") {
      const countryCode = event;
      this.stateListAU = [];
      this.util.startLoader();
      this.api
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListAU = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "IN") {
      const countryCode = event;
      this.stateListIN = [];
      this.util.startLoader();
      this.api
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListIN = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "CA") {
      const countryCode = event;
      this.stateListCA = [];
      this.util.startLoader();
      this.api
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListCA = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else {
    }
  }
  selectedCountries: boolean = false
  typeTargetValue: null;


  onChangePeriod(val: any) {

  }
  onengagementTypeChange(value) {
    if (value == 'W2 - Full Time') {
      this.jobPostForm.get('duration').disable();
      this.jobPostForm.get('durationType').disable();
      this.updateControl({ value: 'duration', form: this.jobPostForm }, "CLEAR");
      this.updateControl({ value: 'durationType', form: this.jobPostForm }, "CLEAR");
    } else {
      this.jobPostForm.get('duration').enable();
      this.jobPostForm.get('durationType').enable();
      this.jobPostForm.get('durationType').patchValue('Months');
      this.updateControl({ value: 'duration', form: this.jobPostForm });
      this.updateControl({ value: 'durationType', form: this.jobPostForm });
    }

  }

  onChangeCandidate() {
    try {
      var formval: any = localStorage.getItem(this.userid + "_landingPagecandidatePostForm")
      if (formval != null || formval != undefined) {
        formval = formval.slice(1, -1)
        var tempdata = CryptoJS.AES.decrypt(decodeURIComponent(formval), "secret key");
        var decrypt = JSON.parse(tempdata.toString(CryptoJS.enc.Utf8));


        setTimeout(() => {
          this.candidatePostForm.patchValue(decrypt)


        }, 4000);
      }
    } catch (error) {

      localStorage.removeItem(this.userid + "_landingPagecandidatePostForm");
    }
  }

  candidateJobTitleList: any = []
  periodList: any = []

  totalExperienceList: any = []
  otherStatesList: any = []
  engagementTypeList: any = []



  async getToCandidate() {
    try {
      this.util.startLoader();

      // Pre-select Marketplace for Free plan users and JOB_SEEKER before form initialization
      if (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') {
        this.selectedNetworks = ['1'];
      } else {
        this.selectedNetworks = [];
      }

      this.animState0 = 'right';
      this.animState1 = 'right';
      this.animState = 'right';
      this.animState2 = 'middle';

      let location: Location;

      if (this.userdatacandidate != null) {
        this.userdatacandidate.forEach(ele => {
          if (ele.currentOrganization == true) {
            location = {
              country: ele.country,
              city: ele.city,
              state: ele.state,
              zipCode: ele.zipcode
            };
          }
        });

        if (location != undefined) this.onChangeCountry(location.country, null);
      }

      this.candidatePostForm = new AppSettings().getCreateCandidateForm(location);

      if (this.userType == 'JOB_SEEKER') {
        this.candidatePostForm.get('candidateEmailId').clearValidators();
        this.candidatePostForm.get('candidateEmailId').updateValueAndValidity();
      }

      await Promise.all([
        this.getCountries(),
        this.onChangeCandidate(),
        this.generateYears()
      ]);



      if (this.userType == 'JOB_SEEKER') {
        this.candidatePostForm.patchValue({
          createCandidateOnPlatform: false,
          candidateEmailId: null,
          email: this.primaryEmail,
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phoneNo,
          createdBy: localStorage.getItem('userId')
        });

        this.candidatePostForm.get('email').disable();
        this.candidatePostForm.get('firstName').disable();
        this.candidatePostForm.get('lastName').disable();
      } else {
        this.candidatePostForm.get('email').enable();
        this.candidatePostForm.get('firstName').enable();
        this.candidatePostForm.get('lastName').enable();
        this.candidatePostForm.patchValue({
          createdBy: localStorage.getItem('userId')
        });
      }

      await this.getListValues('CANDIDATE');
    } catch (error) {
      console.error('An error occurred:', error);
    } finally {
      setTimeout(() => {
        this.util.stopLoader();
      }, 2500);
    }
  }

  selectedTitle: any;
  onselecte(value) {
    this.selectedTitle = value.item;
  }

  submit: boolean = false;
  serverCurrentDate: string;

  createJob(statusvalue) {

    this.submit = true
    this.disable_for_draft = true;
    if (statusvalue == 'ALL' && this.jobPostForm.status == "INVALID") {
      this.scrollToFirstInvalidControl('jobfrom')
      this.disable_for_draft = false;
      return true;
    }


    localStorage.removeItem(this.userid + "_landingPagejobPostForm")
    this.submit = true

    if (statusvalue == "DRAFTED") {
      for (var allstatus in this.jobPostForm.controls) {
        if (allstatus != 'clientName' && allstatus != 'jobTitle') {

          this.jobPostForm.get(allstatus).clearValidators();

        }
        this.jobPostForm.controls[allstatus].updateValueAndValidity();
      }
      this.jobPostForm.get('status').patchValue('DRAFTED');
    }
    if (this.jobPostForm.valid && this.wordlength < 500) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
        buttonsStyling: false
      })

      this.jobPostForm.value.PostedByUserType = localStorage.getItem('userType');
      this.jobPostForm.patchValue({ 'PostedByUserType': localStorage.getItem('userType') })
      if (statusvalue != "DRAFTED") {
        this.savejobafterValdaiton();
      } else {
        this.draftsavecancel(statusvalue)

      }

    }


  }

  draftsavecancel(statusvalue) {
    this.beingEdited = false
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })


    swalWithBootstrapButtons.fire({
      title: 'Save as Draft',
      text: "Would you like to save it as a draft? You can edit this later and save. If No is selected,all the changes will be lost.",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      allowOutsideClick: false,
      allowEscapeKey: false,
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.jobPostForm.get('status').patchValue('DRAFTED');

        this.savejobafterValdaiton();
      } else {
        this.jobPostForm.get('status').patchValue('ACTIVE');

        if (statusvalue != 'DRAFTED') {
          this.savejobafterValdaiton();
        } else {
          this.commonVariables.jobPostingFlag = false
          this.searchData.setCommonVariables(this.commonVariables)
          this.modalRef.hide();
          this.jobPostForm.reset()
          this.primarySkillsSelected = [];
          this.secondarySkillsSelected = [];
          this.primarySkillsList = []
          this.secondarySkillsList = []
          this.otherSelectedStates = []

        }

      }

    });

  }



  savejobafterValdaiton() {
    localStorage.removeItem(this.userid + "_landingPagejobPostForm")

    this.beingEdited = false
    this.util.startLoader();
    this.jobStreamData = [];
    let datas: any = {};
    datas = this.jobPostForm.getRawValue();
    datas.jobReferenceId = this.jobPostForm.getRawValue().jobId;

    datas.jobPostedBy = localStorage.getItem('userId');

    // Publish to network dropdown by monisha
    const personalNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Personal Networks';
      });

    const memberNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Member Networks';
      });

    const businessNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Business Networks';
      });
    // Add the categorized network ids to the request
    datas.personalNetworksPublished = personalNetworksPublished;
    datas.memberNetworksPublished = memberNetworksPublished;
    datas.businessNetworksPublished = businessNetworksPublished;
    const isMarketplaceSelected = (this.selectedNetworks || []).map(item => Number(item)).includes(1);
    // For Free plan users, always post to Marketplace
    datas.postedToMarketPlace = this.membershipType === 'Free' ? true : isMarketplaceSelected;
    if (this.currentOrganizationDetail && this.currentOrganizationDetail.organisationId) {
      datas.organisationId = this.currentOrganizationDetail.organisationId;
    }
    if (this.membershipType !== 'Free') {
      datas.businessId = localStorage.getItem('myBusinessId') || null;
    }
    // Check if this.workExp is defined before accessing it
    if (this.workExp && this.workExp.length > 0) {
      this.workExp.forEach(ele => {
        if (ele.currentOrganization == true) {
          this.clientType = ele.clientType;
        }
      });
    }

    const currentStatus: string = this.jobPostForm.value.status;
    const jobDescription = this.jobPostForm.value.jobDescription || '';
    const cleanedContent = jobDescription.replace(/<img[^>]*>/g, '');
    datas.jobDescription = cleanedContent;

    // Resolve behalfOfBusinessId from the clientName autocomplete selection.
    // EXTERNAL picks become the job's behalfOf context (Option C — quadruple-key model);
    // INTERNAL picks are real platform businesses where the job applies, not an
    // on-behalf-of relationship — behalfOf stays null. Falls back to the legacy
    // jobPostedBehalfOf-list lookup for FREELANCE_RECRUITER own-org flows that still
    // use the older dropdown.
    const currentClientName = this.jobPostForm.get('clientName')?.value;
    if (this.selectedClientSource === 'EXTERNAL'
        && this.selectedClientBusinessId
        && currentClientName === this.selectedClientBusinessName) {
      datas.behalfOfBusinessId = this.selectedClientBusinessId;
    } else {
      const selectedBehalfOf = this.jobPostForm.get('jobPostedBehalfOf')?.value;
      const legacyMatch = selectedBehalfOf
          ? this.jobPostedBehalfOflist.find(o => o.orgName === selectedBehalfOf && o.source === 'EXTERNAL')
          : null;
      datas.behalfOfBusinessId = legacyMatch && legacyMatch.id ? legacyMatch.id : null;
    }

    this.api.create('jobs/createJob', datas).subscribe(res => {
      this.util.stopLoader();
      if (res.code == '00000') {
        if (environment.AsyncSync == "SYNC") {
          if (res.code == '00000') {
            this.disable_for_draft = false;
            this.jobStreamData = [];
            this.modalRef.hide();
            let data: any = {}
            data.count = 1;
            data.flag = true;
            this.searchData.setjobCount(data);
            this.searchData.setjobHighLight(this.jobPostForm.get('jobId').value);
            this.currentDate = [];
            this.maxDate = [];
            Swal.fire({
              position: "center",
              icon: "success",
              title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Job created"),
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.modalService.hide(1);
              this.modalService.hide(2);
              this.modalService.hide(3);
              this.commonVariables.jobPostingFlag = false
              this.commonVariables.workExperienceFlag = false
              this.commonVariables.educationFlag = false
              this.searchData.setCommonVariables(this.commonVariables)
            })

            setTimeout(() => {
              data.value = 'fromFeed'
              this.router.navigate(["newjobs"], { 
                queryParams: { 
                  createJob: res.data.jobData.jobId, 
                  status: res.data.jobData.status
                } 
              });
              this.searchData.setHighlighter('newjobs')
            }, 2000);

          }


        }
        else if (environment.AsyncSync == "ASYNC") {
          this.disable_for_draft = false;
          this.jobStreamData = [];
          let data: any = {}
          data.count = 1;
          data.flag = true;
          data.status = res.data.jobData.status;

          this.searchData.setjobform(localStorage.getItem('jobForm'));
          this.searchData.setjobHighLight(this.jobPostForm.get('jobId').value);
          this.submit = false
          this.modalRef.hide();
          this.currentDate = [];
          this.maxDate = [];
          Swal.fire({
            position: "center",
            icon: "success",
            title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Job created"),
            showConfirmButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            timer: 2000,
          }).then(() => {
            this.commonVariables.jobPostingFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
            this.modalService.hide(1);
            this.modalService.hide(2);
            this.modalService.hide(3);
          })
          setTimeout(() => {
            data.value = 'fromFeed'
            this.router.navigate(["newjobs"], { 
              queryParams: { 
                createJob: res.data.jobData.jobId, 
                status: data.status, 
                artificialAdd: 'true',
                jobData: JSON.stringify(res.data.jobData)
              } 
            });
            this.searchData.setHighlighter('newjobs')
          }, 2000);

          // COMMENTED OUT: Old complex async polling logic - kept for reference
          // this.searchData.setjobCount(data);
          // this.currentDate = [];
          // this.maxDate = [];
          // Swal.fire({
          //   position: "center",
          //   icon: "success", 
          //   title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Job created"),
          //   showConfirmButton: false,
          //   timer: 2000,
          // }).then(() => {
          //   this.modalService.hide(1);
          //   this.modalService.hide(2);  
          //   this.modalService.hide(3);
          //   this.commonVariables.jobPostingFlag = false
          //   this.commonVariables.workExperienceFlag = false
          //   this.commonVariables.educationFlag = false
          //   this.searchData.setCommonVariables(this.commonVariables)
          // })
          // setTimeout(() => {
          //   data.value = 'fromFeed'
          //   this.router.navigate(["newjobs"], { 
          //     queryParams: { 
          //       createJob: res.data.jobData.jobId, 
          //       status: res.data.jobData.status, 
          //       artificialAdd: 'true',
          //       jobData: JSON.stringify(res.data.jobData)
          //     } 
          //   });
          //   this.searchData.setHighlighter('newjobs')
          // }, 2000);
        }

        // Reset JD parsing state
        this.jdParsingService.isJdParsing = false;
        this.jdParsingService.jdParseSuccess = false;
        this.jdParsingService.jdParseFailed = false;


      }
    }, err => {
      this.util.stopLoader();
    });

  }

  resumeUpload(event) {
    this.resumeupload = event.target.files[0];
  }



  patchEmail() {
    this.candidatePostForm.patchValue({
      //candidateEmailId: this.candidatePostForm.value.email
      candidateEmailId: this.candidatePostForm.get('email').value
    })

    if (localStorage.getItem("userType") != "JOB_SEEKER") {
      this.emailidcehck(this.candidatePostForm.value.email);
    }

  }

  emailidcehck(id) {
    this.api.query("user/checkMailAlreadyExists/" + id).subscribe((res) => {
      if (res.data.exists) {
        this.candidatePostForm.get('email').setErrors({ existingEmailAddress: true })
        // this.candidatePostForm.get('email').reset();
        this.candidatePostForm.get('candidateEmailId').patchValue(null);
        // Swal.fire({
        //   icon: "info",
        //   title: "There already exists an account registered with this email address, Please enter different email",
        //   showConfirmButton: true,

        // });
      } else {
        this.candidatePostForm.get('email').setErrors({ existingEmailAddress: null })
        this.candidatePostForm.get('email').updateValueAndValidity({ emitEvent: false })
      }
    })

  }
  private scrollToFirstInvalidControl(id) {
    let form = document.getElementById(id);
    let firstInvalidControl = form.getElementsByClassName('ng-invalid')[0];
    firstInvalidControl.scrollIntoView();
    (firstInvalidControl as HTMLElement).focus();
  }


  candidateSubmit: boolean = false

  saveCandidate(statusvaluecandidate) {
    this.candidateSubmit = true
    this.disable_for_draft = true;

    // Validate resume upload is mandatory for non-draft submissions
    // if (statusvaluecandidate == 'ACTIVE' && !this.resumeupload) {
    //   this.disable_for_draft = false;
    //   return true;
    // }

    if (statusvaluecandidate == 'ACTIVE' && this.candidatePostForm.status == "INVALID") {
      this.disable_for_draft = false;
      this.scrollToFirstInvalidControl('candidatefrom')
      return true;
    }
    this.beingEdited = false
    localStorage.removeItem(this.userid + "_landingPagecandidatePostForm")

    this.candidateSubmit = true

    this.candidatePostForm.value.createdByUserType = localStorage.getItem('userType')
    this.candidatePostForm.patchValue({ 'createdByUserType': localStorage.getItem('userType') })

    if (this.photoId != null) {
      this.candidatePostForm.value.photo = this.photoId;
      this.candidatePostForm.patchValue({ 'photo': this.photoId })
    }
    if (statusvaluecandidate == "DRAFTED") {

      for (var allstatus in this.candidatePostForm.controls) {
        if (allstatus != 'firstName' && allstatus != 'lastName') {
          this.candidatePostForm.get(allstatus).clearValidators();
        }
        this.candidatePostForm.controls[allstatus].updateValueAndValidity();

      }
      this.candidatePostForm.get('status').patchValue('DRAFTED');
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    if (statusvaluecandidate != "DRAFTED") {
      this.util.stopLoader();
      this.savecandidateafterValdaiton();
    } else {
      this.draftsavecandidate(statusvaluecandidate)
    }
  }
  draftsavecandidate(statusvaluecandidate) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })


    swalWithBootstrapButtons.fire({
      title: 'Save as Draft',
      text: "Would you like to save it as a draft? You can edit this later and save. If No is selected,all the changes will be lost.",
      icon: 'info',
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {

        if (statusvaluecandidate == 'DRAFTED') {
          this.candidatePostForm.get('status').patchValue('DRAFTED');
        }

        this.savecandidateafterValdaiton();

      } else {
        this.candidatePostForm.get('status').patchValue('DRAFTED');

        if (statusvaluecandidate != 'DRAFTED') {
          this.candidatePostForm.get('status').patchValue('DRAFTED');
          this.savecandidateafterValdaiton();
        } else {
          this.commonVariables.jobPostingFlag = false
          this.searchData.setCommonVariables(this.commonVariables)
          //this.modalRef.hide();
          this.modalService.hide(1);
          this.modalService.hide(2);
          this.modalService.hide(3);
          this.jobPostForm.reset()
          this.primarySkillsSelected = [];
          this.secondarySkillsSelected = [];
          this.primarySkillsList = []
          this.secondarySkillsList = []
          this.otherSelectedStates = []
        }
      }
    });

  }
  cancelcloseCandidate() {

    this.candidateSubmit = false
    this.beingEdited = false

    // Cancel any ongoing resume parsing API call
    if (this.resumeParseSubscription) {
      console.log('Cancelling resume parse API call...');
      this.resumeParseSubscription.unsubscribe();
      this.resumeParseSubscription = null;
    }

    if (this.candidatePostForm && this.candidatePostForm.value.firstName != null && this.candidatePostForm.value.lastName != null) {
      this.candidatePostForm.get('status').patchValue('DRAFTED');
      this.draftsavecandidate('DRAFTED');
    } else {
      for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
        this.modalService.hide(i);
      }
      this.primarySkillsSelected = [];
      this.secondarySkillsSelected = [];
      this.otherSelectedStates = []

      // Reset resume parsing state
      this.parseSuccess = false;
      this.parseFailed = false;
      this.parsedResumeData = null;
      this.showParsedDetails = false;
      this.isParsing = false;

      setTimeout(() => {
        this.candidatePostForm.reset();
        this.commonVariables.candidatePostingFlag = false
        this.searchData.setCommonVariables(this.commonVariables)

      }, 1000);


    }

  }


  createCandidateOnProf(event) {
    if (event.target.checked == true) {
      this.candidatePostForm.get('candidateEmailId').setValidators([Validators.required])
    } else {
      this.candidatePostForm.get('candidateEmailId').clearValidators()
      this.candidatePostForm.get('candidateEmailId').updateValueAndValidity({ emitEvent: false })

    }
  }

  savecandidateafterValdaiton() {

    localStorage.removeItem(this.userid + "_landingPagecandidatePostForm")

    this.FormData = new FormData();
    // Only append resume if it's actually being uploaded (not null/empty)
    if (this.resumeupload != null && this.resumeupload !== '') {
      this.FormData.append("resume", this.resumeupload);
    }

    // Add candidateId, userId, and orgId to the FormData payload
    const candidateId = this.candidatePostForm.value.candidateId || '';
    const userId = localStorage.getItem('userId') || '';
    const organisationId = this.currentOrganizationDetail?.organisationId || '';
    this.FormData.append("candidateId", candidateId);
    this.FormData.append("userId", userId);
    this.FormData.append("orgId", organisationId);

    this.resumeupload = "";

    let datas: any = {};
    //networks
    const personalNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Personal Networks';
      });

    const memberNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Member Networks';
      });

    const businessNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Business Networks';
      });
    // Add the categorized network ids to the request
    const isMarketplaceSelected = (this.selectedNetworks || []).map(item => Number(item)).includes(1);
    if (this.currentOrganizationDetail && this.currentOrganizationDetail.organisationId) {
      this.candidatePostForm.get('organisationId').patchValue(this.currentOrganizationDetail.organisationId);
    }

    datas = this.candidatePostForm.getRawValue();
    datas.createdBy = localStorage.getItem('userId');
    datas.personalNetworksPublished = personalNetworksPublished;
    datas.memberNetworksPublished = memberNetworksPublished;
    datas.businessNetworksPublished = businessNetworksPublished;
    // For Free plan users and Job Seekers, always post to Marketplace
    datas.postedToMarketPlace = (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') ? true : isMarketplaceSelected;

    if (localStorage.getItem('userType') == 'JOB_SEEKER') {
      datas.effectiveDate = new Date();
      datas.effectiveUntil = new Date();
    }
    const currentStatus: string = this.candidatePostForm.value.status;
    datas.candidateReferenceId = datas.candidateId;
    if (this.membershipType !== 'Free') {
      datas.businessId = localStorage.getItem('myBusinessId') || null;
    }
    const resumeSummary = this.candidatePostForm.value.resumeSummary || '';
    const cleanedContent = resumeSummary.replace(/<img[^>]*>/g, '');
    datas.resumeSummary = cleanedContent;
    this.FormData.append("candidate", new Blob([JSON.stringify(datas)], { type: "application/json" }));
    this.util.startLoader();
    this.canidateStreamData = [];
    this.api.create('candidates/createCandidate', this.FormData).subscribe(res => {
      if (res.code == '00000') {
        // Save parsed resume data if available
        const candidateId = res.data?.candidateData?.candidateId || res.data?.candidateId;
        if (candidateId && this.parsedResumeData) {
          console.log('🔄 Saving parsed resume data for candidate:', candidateId);
          this.saveParsedResumeDataToBackend(candidateId);
        }

        if (environment.AsyncSync == "SYNC") {
          if (res.code == '00000') {
            this.disable_for_draft = false;
            this.canidateStreamData = [];
            this.candidateSubmit = false
            this.util.stopLoader();
            this.modalRef.hide()
            let data: any = {}
            data.count = 1;
            data.flag = true;
            this.searchData.setcandiadateCount(data);
            this.currentDate = [];
            this.maxDate = [];
            Swal.fire({
              position: "center",
              icon: "success",
              title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Candidate created"),
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.modalService.hide(1);
              this.modalService.hide(2);
              this.modalService.hide(3);
              this.commonVariables.jobPostingFlag = false
              this.commonVariables.workExperienceFlag = false
              this.commonVariables.educationFlag = false
              this.searchData.setCommonVariables(this.commonVariables)
            })

            setTimeout(() => {
              data.value = 'fromFeed'
              this.router.navigate(["newcandidates"], { queryParams: { createCandidate: res.data.candidateData.candidateId, status: this.candidatePostForm.get('status').value } });
              this.searchData.setHighlighter('newcandidates')
            }, 2000);
          }

        } else if (environment.AsyncSync == "ASYNC") {
          // Clean up any existing timers/subscriptions that might cause refresh popup
          if (this.subscription) {
            this.subscription.unsubscribe();
          }
          this.destroy.next(true);
          
          this.disable_for_draft = false;
          this.canidateStreamData = [];
          this.candidateSubmit = false
          this.util.stopLoader();
          this.modalRef.hide()
          let data: any = {}
          data.count = 1;
          data.flag = true;
          data.status = this.candidatePostForm.get('status').value;
          
          this.searchData.setcandiadateCount(data);
          this.currentDate = [];
          this.maxDate = [];
          Swal.fire({
            position: "center",
            icon: "success",
            title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Candidate created"),
            showConfirmButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            timer: 2000,
          }).then(() => {
            this.commonVariables.jobPostingFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
            this.modalService.hide(1);
            this.modalService.hide(2);
            this.modalService.hide(3);
          })

          setTimeout(() => {
            data.value = 'fromFeed'
            this.router.navigate(["newcandidates"], { 
              queryParams: { 
                createCandidate: res.data.candidateData.candidateId, 
                status: data.status,
                artificialAdd: 'true',
                candidateData: JSON.stringify(res.data.candidateData)
              } 
            });
            this.searchData.setHighlighter('newcandidates')
          }, 2000);

          // COMMENTED OUT: Old complex async polling logic - kept for reference
          // let timeout: any = undefined;
          // // 3 mins validate
          // this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe((val) => {
          //   timeout = val;
          // });
          // setTimeout(() => {
          //   const source = interval(0);
          //   this.subscription = source.subscribe(val => {
          //     // time out
          //     if (timeout != undefined) {
          //       this.util.stopLoader();
          //       this.subscription && this.subscription.unsubscribe();
          //       Swal.fire({
          //         position: "center",
          //         icon: "info",
          //         title: "Candidate is being created. Please refresh the page",
          //         showConfirmButton: false,
          //         allowEscapeKey: false,
          //         allowOutsideClick: false,
          //         timer: 10000,
          //       })
          //     }
          //     if (this.canidateStreamData && this.canidateStreamData.code == "00000") {
          //       this.util.stopLoader();
          //       // clear subscriber
          //       this.subscription && this.subscription.unsubscribe();
          //       if (this.canidateStreamData != undefined && this.canidateStreamData.length != 0 && this.canidateStreamData.code == "00000" && res.data.candidateData.candidateId == this.canidateStreamData.requestId) {
          //         if (res.code == '00000') {
          //           this.disable_for_draft = false;
          //           this.canidateStreamData = [];
          //           this.stremService.clearsubjectvalue();
          //           this.candidateSubmit = false
          //           this.util.stopLoader();
          //           this.modalRef.hide()
          //           let data: any = {}
          //           data.count = 1;
          //           data.flag = true;
          //           this.searchData.setcandiadateCount(data);
          //           this.currentDate = [];
          //           this.maxDate = [];
          //           Swal.fire({
          //             position: "center",
          //             icon: "success",
          //             title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Candidate created"),
          //             showConfirmButton: false,
          //             timer: 2000,
          //           }).then(() => {
          //             this.modalService.hide(1);
          //             this.modalService.hide(2);
          //             this.modalService.hide(3);
          //             this.commonVariables.jobPostingFlag = false
          //             this.commonVariables.workExperienceFlag = false
          //             this.commonVariables.educationFlag = false
          //             this.searchData.setCommonVariables(this.commonVariables)
          //           })
          //           setTimeout(() => {
          //             data.value = 'fromFeed'
          //             this.router.navigate(["newcandidates"], { queryParams: { createCandidate: res.data.candidateData.candidateId, status: this.candidatePostForm.get('status').value } });
          //             this.searchData.setHighlighter('newcandidates')
          //           }, 2000);
          //         } else {
          //           Swal.fire({
          //             position: "center",
          //             icon: "info",
          //             title: "Candidate is being created. Please refresh the page",
          //             showConfirmButton: false,
          //             allowEscapeKey: false,
          //             allowOutsideClick: false,
          //             timer: 10000,
          //           })
          //         }
          //       }
          //     }
          //     // setTimeout(() => {
          //     //   this.commonVariables.loadCandidates = true
          //     //   this.searchData.setLoadJobOrCandidate(this.commonVariables)
          //     // }, 5000);
          //   });
          // }, 1000);
        }


      }
    }, err => {
      this.util.stopLoader();
    });


  }
  // private formatDateddd(date) {
  //   const d = new Date(date);
  //   let month = '' + (d.getMonth() + 1);
  //   let day = '' + d.getDate();
  //   const year = d.getFullYear();
  //   if (month.length < 2) month = '0' + month;
  //   if (day.length < 2) day = '0' + day;
  //   return [year, month, day].join('-');
  // }

  years: any = []
  Toyears: any = []
  generateYears() {
    this.years = []
    this.Toyears = []
    // var max = new Date().getFullYear();
    // var min = max - 80;
    for (var i = 0; i <= 20; i++) {
      this.years.push(i);
    }
    for (var i = 1; i <= 20; i++) {
      this.Toyears.push(i);
    }
  }
  years1: any = []
  generateYears1() {
    var max = new Date().getFullYear();
    var min = max - 80;
    for (var i = min; i <= max; i++) {
      this.years1.push(i);
    }
  }

  validateBeginning(year) {
    // var fromYear = this.jobPostForm.value.experienceFrom
    var toYear = this.jobPostForm.value.experienceTo
    if (toYear != null) {
      if (year > toYear) {
        return true
      } else {
        return false
      }
    }
  }

  validateLast(year) {
    // var toYear = this.jobPostForm.value.experienceTo
    var fromYear = this.jobPostForm.value.experienceFrom
    if (fromYear != null) {
      if (fromYear > year) {
        return true
      } else {
        return false
      }
    }
  }

  stateListCA: any = []
  stateListIN: any = []
  stateListAU: any = []
  countryList: any = [];

  getCountries() {
    this.countryList = [];
    this.util.startLoader();
    this.api.query("country/getAllCountries").subscribe((res) => {
      this.util.stopLoader();
      if (res != undefined) {
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }

    }, err => {
      this.util.stopLoader();
    });
  }

  formfield() {
    let location: Location;

    if (this.userdatacandidate != null && this.userdatacandidate != undefined) {
      this.userdatacandidate.forEach(ele => {
        if (ele.currentOrganization == true) {

          location = {
            country: ele.country, city: ele.city, state: this.toTitleCase(ele.state), zipCode: ele.zipcode
          };
        }
      })
    }
    this.candidatePostForm = new AppSettings().getCreateCandidateForm(location);
  }
  payType: null;
  targetRate: null;
  countryChosen: string | null = null;
  figureLength: number = 0;
  usStatesList: any = [];
  workflag: boolean = false;
  onChangeCountry(event, param) {

    this.countryChosen = event;
    if (this.candidatePostForm == undefined) {
      this.formfield();
      setTimeout(() => {
        this.candidatePostForm.get('workAuthorization').enable();
      }, 1500);

    }
    if (param == 'jobs') {
      this.jobPostForm.get('city').patchValue(null)
      this.jobPostForm.get('state').patchValue(null)
      this.jobPostForm.get('zipCode').patchValue(null)
    }

    if (param == 'candidates') {
      this.candidatePostForm.get('city').patchValue(null)
      this.candidatePostForm.get('state').patchValue(null)
      this.candidatePostForm.get('zipCode').patchValue(null)
    }

    this.timeZonecountryvalues(this.countryChosen);

    if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Hourly') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Daily') {
      this.figureLength = 3
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Monthly') {
      this.figureLength = 6
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Weekly') {
      this.figureLength = 5
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Yearly') {
      this.figureLength = 8
    } else if (this.countryChosen == 'IN' && this.payType == 'Hourly') {
      this.figureLength = 4
    } else if (this.countryChosen == 'IN' && this.payType == 'Daily') {
      this.figureLength = 5
    } else if (this.countryChosen == 'IN' && this.payType == 'Monthly') {
      this.figureLength = 7
    } else if (this.countryChosen == 'IN' && this.payType == 'Weekly') {
      this.figureLength = 6
    } else if (this.countryChosen == 'IN' && this.payType == 'Yearly') {
      this.figureLength = 8
    }
    if (event == "US" && this.candidatePostForm != undefined) {
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();

      this.selectedCountries = true
      const countryCode = event;
      this.util.startLoader()
      this.workAuthorizationList = []
      this.api.query('listvalue/find?domain=WORK_AUTHORIZATION_US').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          this.util.stopLoader()
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });

          this.api
            .query("country/getAllStates?countryCode=" + countryCode)
            .subscribe((res) => {
              this.usStatesList = [];
              res.forEach(ele => {
                this.usStatesList.push(ele.stateName);
              })
            }, err => {
              this.util.stopLoader();
            });

        }
      })

    } else if (event == "AU" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();

      this.util.startLoader()
      this.api.query('listvalue/find?domain=WORK_AUTHORIZATION_AU').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          })

          this.selectedCountries = true
          const countryCode = event;
          if (this.stateListAU.length == 0) {
            this.stateListAU = [];
            this.api
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListAU = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })
    } else if (event == "IN" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.util.startLoader()
      this.api.query('listvalue/find?domain=WORK_AUTHORIZATION_IN').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });

          this.selectedCountries = true;
          const countryCode = event;
          if (this.stateListIN.length == 0) {
            this.stateListIN = [];

            this.api
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListIN = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })
    } else if (event == "CA" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();

      this.util.startLoader()
      this.api.query('listvalue/find?domain=WORK_AUTHORIZATION_CA').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });
          this.selectedCountries = true
          const countryCode = event;

          if (this.stateListCA.length == 0) {
            this.api
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListCA = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })

    } else {
      this.selectedCountries = false;

      if (event != null && this.candidatePostForm != undefined) {
        this.workflag = true;
        this.workAuthorizationList = [];
        if (this.countryChosen != 'US' && this.countryChosen != 'AU' && this.countryChosen != 'IN' && this.countryChosen != 'CA') {

          setTimeout(() => {
            this.candidatePostForm.get('workAuthorization').patchValue(null)
            this.candidatePostForm.get('workAuthorization').disable();
            this.candidatePostForm.get('workAuthorization').clearValidators();
            this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
          }, 2000);

        }

      }

    }
    if (this.typeTargetValue != null) {
      this.onTargetRateTyped(this.typeTargetValue, param)
    }

  }

  onChangePayType(value, param) {
    this.payType = value
    // if (this.countryChosen != null) {
    if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Hourly') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Daily') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Monthly') {
      this.figureLength = 6
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Weekly') {
      this.figureLength = 5
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Yearly') {
      this.figureLength = 8
    } else if (this.countryChosen == 'IN' && this.payType == 'Hourly') {
      this.figureLength = 4
    } else if (this.countryChosen == 'IN' && this.payType == 'Daily') {
      this.figureLength = 5
    } else if (this.countryChosen == 'IN' && this.payType == 'Monthly') {
      this.figureLength = 7
    } else if (this.countryChosen == 'IN' && this.payType == 'Weekly') {
      this.figureLength = 6
    } else if (this.countryChosen == 'IN' && this.payType == 'Yearly') {
      this.figureLength = 8
    }
    // }
    if (this.typeTargetValue != null) {
      this.onTargetRateTyped(this.typeTargetValue, param)
    }
  }

  get jobControls(): { [key: string]: AbstractControl } {
    return this.jobPostForm.controls;
  }

  get candidateControls() {
    return this.candidatePostForm.controls
  }

  get isCandidateCorpToCorp(): boolean {
    const val = this.candidatePostForm?.get('engagementType')?.value;
    return val === 'Corp to Corp' || val === 'Corp To Corp';
  }

  onCandidateEngagementTypeChange(value: string): void {
    const isC2C = value === 'Corp to Corp' || value === 'Corp To Corp';
    if (isC2C) {
      this.candidatePostForm.get('clientType')?.setValidators([Validators.required]);
      this.candidatePostForm.get('clientName')?.setValidators([Validators.required]);
    } else {
      this.candidatePostForm.get('clientType')?.clearValidators();
      this.candidatePostForm.get('clientName')?.clearValidators();
      this.candidatePostForm.get('clientType')?.setValue(null);
      this.candidatePostForm.get('clientName')?.setValue(null);
      this.candidatePostForm.get('showClientType')?.setValue(false);
      this.candidatePostForm.get('showClientName')?.setValue(false);
    }
    this.candidatePostForm.get('clientType')?.updateValueAndValidity();
    this.candidatePostForm.get('clientName')?.updateValueAndValidity();
  }

  get credit() {
    return this.creditform.controls
  }

  // JD Parsing state getters
  get isJdParsing(): boolean {
    return this.jdParsingService.isJdParsing;
  }

  get jdParseSuccess(): boolean {
    return this.jdParsingService.jdParseSuccess;
  }

  get jdParseFailed(): boolean {
    return this.jdParsingService.jdParseFailed;
  }

  // Parse job description method
  parseJobDescription(): void {
    // Initialize JD parsing service with form and config
    this.jdParsingService.patchFormToService(this.jobPostForm, {
      engagementTypeList: this.engagementTypeList,
      payTypeList: this.payTypeList,
      countryList: this.countryList,
      years: this.years,
      Toyears: this.Toyears,
      years2: this.years, // Using years for duration as per HTML template
      durationTypeList: this.durationTypeList,
      usStatesList: this.usStatesList,
      stateListCA: this.stateListCA,
      stateListIN: this.stateListIN,
      stateListAU: this.stateListAU
    });

    // Subscribe once to update ng-select bindings after parse completes
    this.jdParsingService.parsedSkills$.pipe(take(1)).subscribe(({ primarySkills, secondarySkills }) => {
      this.primarySkillsSelected = primarySkills;
      this.secondarySkillsSelected = secondarySkills;
      // Add parsed skills to available option lists so ng-select can display them
      [...primarySkills, ...secondarySkills].forEach(skill => {
        if (!this.primarySkillsList.includes(skill)) this.primarySkillsList.push(skill);
        if (!this.secondarySkillsList.includes(skill)) this.secondarySkillsList.push(skill);
      });
    });

    this.jdParsingService.parseJobDescription();
  }

  cancelJob() {
    this.submit = false
    this.beingEdited = false
    if (this.jobPostForm && this.jobPostForm.get('clientName').value != null && this.jobPostForm.value.jobTitle != null) {
      this.jobPostForm.get('status').patchValue('DRAFTED');
      this.draftsavecancel('DRAFTED');
    } else {
      for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
        this.modalService.hide(i);
      }
      this.primarySkillsSelected = [];
      this.secondarySkillsSelected = [];
      this.primarySkillsList = []
      this.secondarySkillsList = []
      this.otherSelectedStates = []
      setTimeout(() => {
        this.jobPostForm.reset()
        this.commonVariables.jobPostingFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
      }, 1000);

      // Reset JD parsing state
      this.jdParsingService.isJdParsing = false;
      this.jdParsingService.jdParseSuccess = false;
      this.jdParsingService.jdParseFailed = false;
    }

  }

  closeCredit() {
    this.beingEdited = false
    this.commonVariables.creditFlag = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.postPrivacyFlag = false
    this.commonVariables.workExperienceFlag = false
    this.commonVariables.educationFlag = false
    this.searchData.setCommonVariables(this.commonVariables)
  }

  closeExperience() {
    this.gigsumoService.buttonClicked = true;
    this.beingEdited = false
    if (this.openModal == true) {
      this.modalRef.hide()
      this.modalService.hide(1);
      this.modalService.hide(2);
      this.modalService.hide(3);
      setTimeout(() => {
        this.commonVariables.workExperienceFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
      }, 1000);
    } else {
      this.commonVariables.workExperienceFlag = false
      this.searchData.setCommonVariables(this.commonVariables)
    }



  }

  closeEducation() {
    this.beingEdited = false

    if (this.openModal == true) {
      this.modalRef.hide()
      setTimeout(() => {
        this.commonVariables.educationFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
      }, 1500);
    } else {
      this.commonVariables.educationFlag = false
      this.searchData.setCommonVariables(this.commonVariables)
    }


  }

  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }

  closeCandidate() {
    this.beingEdited = false
    if (this.openModal == true) {
      this.modalRef.hide()
      setTimeout(() => {
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];
        this.otherSelectedStates = []
        // this.animState0 = 'middle'
        // this.animState1 = 'left'
        // this.animState = 'right'
        this.commonVariables.jobPostingFlag = false
        this.commonVariables.candidatePostingFlag = false
        this.commonVariables.postPrivacyFlag = false
        this.commonVariables.workExperienceFlag = false
        this.commonVariables.educationFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
        this.candidatePostForm.reset();
        this.candidateSubmit = false;


        this.fileshow = undefined;
        this.myFileInputcandidate.nativeElement.value = null;
        this.photoId = null;
      }, 1500);
    } else {
      this.primarySkillsSelected = [];
      this.secondarySkillsSelected = [];
      this.otherSelectedStates = []
      // this.animState0 = 'middle'
      // this.animState1 = 'left'
      // this.animState = 'right'
      this.commonVariables.jobPostingFlag = false
      this.commonVariables.candidatePostingFlag = false
      this.commonVariables.postPrivacyFlag = false
      this.commonVariables.workExperienceFlag = false
      this.commonVariables.educationFlag = false
      this.searchData.setCommonVariables(this.commonVariables)
      this.candidatePostForm.reset();
      this.candidateSubmit = false;


      this.fileshow = undefined;
      this.myFileInputcandidate.nativeElement.value = null;
      this.photoId = null;
    }



  }

  onKeyZip(event: any, param, index) {
    let data: any = {};
    data.countryCode = "US";
    data.zipCode = event.target.value;
    data.stateCode = "";
    if (data.zipCode.length === 5) {
      this.api.create("country/geodetails", data).subscribe((res) => {
        if (
          res &&
          res != null &&
          res != "" &&
          res.length > 0 &&
          event.target.value != ""
        ) {
          res.forEach((ele) => {
            let cityName = ele.cityName;
            let stateName = ele.stateName;
            if (param == 'job') {
              this.jobPostForm.patchValue({
                city: cityName,
                state: stateName,
              });
            } else if (param == 'candidate') {
              this.candidatePostForm.patchValue({
                city: cityName,
                state: stateName,
              });
            } else if (param == 'work') {
              this.workExperience.controls[0].patchValue({
                city: cityName,
                state: stateName,
              });
            }
          });
        }
      });
    } else if (data.zipCode.length < 5 || data.zipCode.length > 5) {

    }
  }
  uploadMediaHere(value) {
    if (value == 'photo') {
      this.myFileInput1.nativeElement.click();
    } else if (value == 'video') {
      this.myFileInput2.nativeElement.click();
    }
  }
  uploadMediaHere1(value) {

    if (value == 'photo') {
      this.myFileInput3.nativeElement.click();
    } else if (value == 'video') {
      this.myFileInput4.nativeElement.click();
    }
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.isJoinedCommunity = localStorage.getItem('isJoined')
      this.isCommunityAdmin = localStorage.getItem('communityAdmin');
      this.isCommunitySuperAdmin = localStorage.getItem('communitySuperadmin');
    }, 2000);

    setTimeout(() => {
      if (document.getElementById('jingalala') != null) {
        document.getElementById('jingalala').style.visibility = "visible";
      }

      if (document.getElementById('blengi') != null) {
        document.getElementById('blengi').style.visibility = 'visible'
      }
    }, 3000);
  }


  profPhoto: any = null
  profName: any;
  profileitems: any

  /** Composer avatar URL — derived from whichever source is populated first.
   *  `profPhoto` (set in `getLoginUserDetails`) prefixes the URL but only after
   *  the API resolves; `profileitems.photo` is set synchronously inside the
   *  same subscribe at `:4674` but may hold a raw filename.
   *  Returns a renderable URL or null. */
  get composerAvatarUrl(): string | null {
    if (this.profPhoto) return this.profPhoto;
    const raw = this.profileitems?.photo
      ?? this.profileitems?.data?.photo
      ?? this.profileitems?.data?.user?.photo
      ?? this.loginUser?.photo
      ?? null;
    if (!raw) return null;
    if (typeof raw !== 'string') return null;
    if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
    return AppSettings.photoUrl + raw;
  }

  /** TEMP DIAGNOSTIC — remove after confirming the composer avatar shows. */
  private composerAvatarLogged = false;
  logComposerAvatar(stage: string, url: string | null): void {
    if (stage === 'LOADED' && this.composerAvatarLogged) return;
    this.composerAvatarLogged = true;
    // eslint-disable-next-line no-console
    console.log('[GSC AVATAR]', stage, {
      url,
      profPhoto: this.profPhoto,
      profileitems_photo: this.profileitems?.photo,
      loginUser_photo: this.loginUser?.photo,
      profileitems_keys: this.profileitems ? Object.keys(this.profileitems) : null,
    });
  }
  getLoginUserDetails(): void {
    const userId = localStorage.getItem("userId");
    this.util.startLoader();
    this.api.query("user/" + userId).subscribe((res: any) => {
      this.profileitems = res;
      this.util.stopLoader();
      if (res) {
        // NOTE: The `/user/{id}` endpoint returns the user object flat (no `code`
        // wrapper). The rest of the codebase (TourService, recruiter-dashboard) reads
        // `res` directly for this reason. A previous `res.code === "00000"` gate here
        // blocked all photo/loginUser assignment, which is why the composer avatar
        // always fell back to initials even when a photo existed.
        this.profName = res.firstName + " " + res.lastName
        if (res.photo && res.photo != null) {
          this.profilePhoto.setPhoto(res.photo);
          // Prevent double URL prepending
          if (res.photo.startsWith('http://') || res.photo.startsWith('https://')) {
            this.profPhoto = res.photo;
          } else {
            this.profPhoto = AppSettings.photoUrl + res.photo;
          }

        } else {
          this.profilePhoto.setPhoto(null);
          this.profPhoto = null
        }

        res.fullName = res.firstName + " " + res.lastName
        // Prevent double URL prepending for loginUser.photo
        if (res.photo && res.photo != null) {
          if (res.photo.startsWith('http://') || res.photo.startsWith('https://')) {
            res.photo = res.photo;
          } else {
            res.photo = AppSettings.photoUrl + res.photo;
          }
        } else {
          res.photo = null;
        }
        this.loginUser = res;
      }
    });
  }

  modalOpenFlag: boolean = false
  @HostListener('window:scroll')
  handleScroll() {
    // var windowScroll: any;
    if (this.modalOpenFlag == false) {
      this.scrollValue.windowScroll = window.pageYOffset
      this.searchData.setScroll(this.scrollValue)
    }

  }

  // After a create/edit the new post is at index 0; bring it into view. The home feed
  // scrolls with the window; community/network pages scroll an inner container
  // (.community-scroll), so scroll every scrollable ancestor too.
  private scrollFeedToTop(): void {
    let el: HTMLElement | null = this.hostRef.nativeElement.parentElement;
    while (el) {
      const oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) {
        el.scrollTo({ top: 0, behavior: 'smooth' });
      }
      el = el.parentElement;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Keep the saved offset in sync so a later modal cancel cannot restore a stale one.
    this.scrollValue.windowScroll = 0;
    this.searchData.setScroll(this.scrollValue);
  }

  savePostSelected(postviewModelName) {
    this.animState0 = 'middle'
    this.animState1 = 'right'
    this.animState = 'right'
    this.postPrivacy = postviewModelName;
    this.tempcheckedList = [...new Set(this.checkedList)];
    // this.dismiss();
    // this.flag
    var commonVariables: any = {};
    this.commonVariables.postPrivacyFlag = false;
    this.commonVariables.postFormflag = true;
    this.searchData.setCommonVariables(commonVariables);
  }

  getPostModel(value, template) {
    if (value != "Everyone") {
      this.checkedList = [];
      this.tempcheckedList = [];
      this.postviewModelName = value;

      this.modalRef_PostView = this.modalService.show(template, {
        backdrop: "static",
        animated: true,
      });
      this.queryPostview(value);
    } else {
      this.checkedList = [];
      this.tempcheckedList = [];
      this.postPrivacy = "Everyone";
      this.privacyValue = 'Everyone'
    }
  }

  nowNthenValue = []
  sdfsdf: boolean = true
  changePostModal(value, param) {

    this.animState0 = 'left'
    this.animState1 = 'middle'
    this.animState = 'right'
    this.nowNthenValue.push(value)
    this.privacyValue = value
    this.searchName = ""
    this.modalSearchTerm = ""
    this.modelList = []
    if (param == 'post') {
      if (value !== "Everyone") {
        var commonVariables: any = {};
        // commonVariables.postPrivacyFlag = true;
        this.searchData.setCommonVariables(commonVariables);
        this.postviewModelName = value;
        this.queryPostview(value);
      } else {
        this.selectedEntities = []
        this.resetPrivacyEntities()
        this.nowNthenValue = []
        this.checkedList = [];
        this.tempcheckedList = [];
        this.postPrivacy = "Everyone";
        this.privacyValue = 'Everyone'
        this.postviewModelName = value;
      }
    } else if (param == 'photo') {
      if (value !== "Everyone") {
        var commonVariables: any = {};
        commonVariables.postPrivacyFlag = true;
        this.searchData.setCommonVariables(commonVariables);



        this.postviewModelName = value;
        this.queryPostview(value);
      } else {
        this.nowNthenValue = []
        this.checkedList = [];
        this.tempcheckedList = [];
        this.postPrivacy = "Everyone";
        this.privacyValue = 'Everyone'
      }
    } else if (param == 'edit') {

      if (value !== "Everyone") {

        var commonVariables: any = {};
        commonVariables.postPrivacyFlag = true;
        this.searchData.setCommonVariables(commonVariables);
        this.postviewModelName = value;
        this.queryPostview(value);
      } else {
        this.nowNthenValue = []
        this.checkedList = [];
        this.tempcheckedList = [];
        this.postPrivacy = "Everyone";
        this.privacyValue = 'Everyone'
      }
    }
  }

  modalListLoading: boolean = false;
  networkZeroFlag: boolean = false
  communityZeroFlag: boolean = false


  queryPostview(val) {
    let datas: any = {};
    datas.userId = localStorage.getItem("userId");
    // Open the privacy panel immediately and show inline skeletons while the
    // active tab's list loads — friendlier than the full-screen spinner. Hide
    // the create-post form at the same time (the success handlers already do
    // this) so the two aren't briefly stacked during the load. Reset the
    // empty-state flags so stale ones don't flash before the new data lands.
    this.commonVariables.postFormflag = false;
    this.commonVariables.postPrivacyFlag = true;
    this.modalListLoading = true;
    this.networkZeroFlag = false;
    this.communityZeroFlag = false;
    this.connectionZeroFlag = false;
    this.teamZeroFlag = false;
    if (val == "Connections") {
      datas.status = "CONNECTED";
      // Cursor pagination params — server returns up to `limit` rows and a
      // `searchAfterKey` that we ship back on the next call. Resetting
      // here covers the case where the modal is re-opened.
      datas.limit = 12;
      datas.searchAfterKey = null;
      datas.searchContent = this.modalSearchTerm || null;
      this.connectionAfterKey = null;
      this.connectionPrevAfterKey = null;
      this.connectionsHasMore = false;
      this.connectionLoadingMore = false;
      this.api.create("user/connection/info", datas).subscribe((res) => {
        this.modalListLoading = false;
        if (res.code == "00000") {
          this.modelList = []
          if (this.nowNthenValue.length > 1) {
            res.data.response.forEach((element2) => {
              element2.checked = false;
            });
            var y = this.nowNthenValue.length - 1
            var z = this.nowNthenValue.length - 2
            var a = this.nowNthenValue[y]
            var b = this.nowNthenValue[z]
            if (a !== b) {
              this.selectedEntities = []
              this.checkedList = [];
              this.tempcheckedList = [];
              res.data.response.forEach((element2) => {
                element2.checked = false;
              });
              // Collapse the tab-switch history so a subsequent search / clear
              // refetch on this same tab takes the reconcile path instead of
              // resetting the selection again. The reset must fire ONCE per
              // genuine tab switch (pushed by changePostModal), not on every
              // search refetch (which never pushes nowNthenValue).
              this.nowNthenValue = [a];
            } else {
              this.checkedList.forEach(element1 => {
                res.data.response.forEach((element2) => {
                  if (element1 === element2.userId) {
                    element2.checked = true;
                  }
                });
              });
            }
          } else if (this.nowNthenValue.length == 1 && this.privacyValue == 'Connections') {

            this.checkedList.forEach(element1 => {
              res.data.response.forEach((element2) => {
                if (element1 === element2.userId) {
                  element2.checked = true;
                } else {
                  if (element1 === element2.userId) {
                    element2.checked = true;
                  }
                }
              });
            });
          } else {
            res.data.response.forEach((element2) => {
              element2.checked = false;
            });
            this.checkedList.forEach(element1 => {
              res.data.response.forEach((element2) => {
                if (element1 === element2.userId) {
                  element2.checked = true;
                } else {
                  if (element1 === element2.userId) {
                    element2.checked = true;
                  }
                }
              });
            });
          }
          this.modelList = res.data.response;
          // Only "you have no connections" when there's NO active search; a
          // no-match search keeps the search box visible and shows the
          // "No records available!" message instead (matches Network).
          this.connectionZeroFlag = this.modelList.length === 0 && !this.modalSearchTerm;
          // Seed the cursor from the first page. Subsequent batches are
          // pulled in by `onConnectionsScrollDown()` as the user scrolls
          // the fixed-height list to its bottom.
          this.updateConnectionCursor(res.data && res.data.searchAfterKey, this.modelList.length);
          this.commonVariables.postFormflag = false;
          this.commonVariables.postPrivacyFlag = true;
        }
      }, err => {
        this.modalListLoading = false;
      });
    } else if (val == "Community") {
      this.modelList = []
      datas.searchContent = this.modalSearchTerm || null;
      this.api.queryPassval("community/check/user", datas).subscribe((res) => {
        this.modalListLoading = false;
        if (res.code == "00000") {
          // Normalise null → [] up front: the API returns null for an empty /
          // no-community result, and the forEach calls below would throw on
          // null and abort before communityZeroFlag was set — hiding the
          // "You are not part of any Communities" message.
          res.data.communityModelList = res.data.communityModelList || [];

          if (this.nowNthenValue.length > 1) {
            res.data.communityModelList.forEach((element2) => {
              element2.checked = false;
            });

            var y = this.nowNthenValue.length - 1
            var z = this.nowNthenValue.length - 2
            var a = this.nowNthenValue[y]
            var b = this.nowNthenValue[z]
            if (a !== b) {
              this.selectedEntities = []
              this.checkedList = [];
              this.tempcheckedList = [];
              res.data.communityModelList.forEach((element2) => {
                element2.checked = false;
                element2.userId = element2.communityId;
              });
              // Collapse the tab-switch history — see Connections branch. Keeps
              // a search / clear refetch from re-resetting the selection.
              this.nowNthenValue = [a];
            } else {
              this.checkedList.forEach(element1 => {
                res.data.communityModelList.forEach((element2) => {
                  if (element1 === element2.communityId) {
                    element2.checked = true;
                    element2.userId = element2.communityId;
                  }
                })
              });
            }
          } else {
            res.data.communityModelList.forEach((element2) => {
              element2.checked = false;
              element2.userId = element2.communityId;
            });
            // Retain prior selections across a search / clear refetch. A
            // single-level selection (nowNthenValue.length <= 1) must still
            // re-check rows already in checkedList, otherwise clearing the
            // search wiped the visible selection. Mirrors the Connections tab.
            this.checkedList.forEach((element1) => {
              res.data.communityModelList.forEach((element2) => {
                if (element1 === element2.communityId) {
                  element2.checked = true;
                  element2.userId = element2.communityId;
                }
              });
            });
          }
          // Default to [] — the API can return null for an empty/no-match
          // result, which would otherwise leave modelList null and break the
          // "No records available!" check (null?.length === 0 is false).
          this.modelList = res.data.communityModelList || []
          // Search-aware empty state (same pattern as Connections/Network):
          // genuine "no communities" only when there's no active search.
          this.communityZeroFlag = this.modelList.length === 0 && !this.modalSearchTerm;
          this.commonVariables.postFormflag = false;
          this.commonVariables.postPrivacyFlag = true;
        }
      }, err => {
        this.modalListLoading = false;
      });
    } else if (val == "Network") {
      this.modelList = []
      this.networkZeroFlag = false;
      // Reset the cursor — covers re-opening the modal and search refetches.
      this.networkAfterKey = null;
      this.networkPrevAfterKey = null;
      this.networkHasMore = false;
      this.networkLoadingMore = false;
      const payload: any = {
        userId: localStorage.getItem("userId"),
        withMember: true,
        limit: 10,
        offset: 0,
        status: "ACTIVE",
        searchContent: this.modalSearchTerm || null,
        searchAfterKey: null,
      };

      this.api.create("network/home", payload).subscribe({
        next: (res) => {
          this.modalListLoading = false;
          if (res.code === "00000") {

            if (res.data.network && res.data.network.length > 0) {
              if (this.nowNthenValue.length > 1) {
                res.data.network.forEach((element2) => {
                  element2.checked = false;
                });

                const y = this.nowNthenValue.length - 1;
                const z = this.nowNthenValue.length - 2;
                const a = this.nowNthenValue[y];
                const b = this.nowNthenValue[z];

                if (a !== b) {
                  this.selectedEntities = [];
                  this.checkedList = [];
                  this.tempcheckedList = [];
                  res.data.network.forEach((element2) => {
                    element2.checked = false;
                    element2.userId = element2.networkId;
                  });
                  // Collapse the tab-switch history — see Connections branch.
                  // Keeps a search / clear refetch from re-resetting the selection.
                  this.nowNthenValue = [a];
                } else {
                  this.checkedList.forEach((element1) => {
                    res.data.network.forEach((element2) => {
                      if (element1 === element2.networkId) {
                        element2.checked = true;
                        element2.userId = element2.networkId;
                      }
                    });
                  });
                }
              } else {
                res.data.network.forEach((element2) => {
                  element2.checked = false;
                  element2.userId = element2.networkId;
                });
                // Retain prior selections across a search / clear refetch. A
                // single-level selection (nowNthenValue.length <= 1) must still
                // re-check rows already in checkedList, otherwise clearing the
                // search wiped the visible selection. Mirrors the Connections tab.
                this.checkedList.forEach((element1) => {
                  res.data.network.forEach((element2) => {
                    if (element1 === element2.networkId) {
                      element2.checked = true;
                      element2.userId = element2.networkId;
                    }
                  });
                });
              }

              this.modelList = res.data.network;
              this.updateNetworkCursor(res.data.searchAfterKey, res.data.network.length);
              // If no searchAfterKey returned, explicitly set hasMore to false
              if (!res.data.searchAfterKey) {
                this.networkHasMore = false;
              }
            } else {
              // Empty result: only "you have no networks" when there's NO active
              // search. A no-match search keeps networkZeroFlag false so the
              // search box stays visible; the template then shows the
              // "No records available!" message instead.
              this.networkZeroFlag = !this.modalSearchTerm;
              this.networkHasMore = false;
            }

            this.commonVariables.postFormflag = false;
            this.commonVariables.postPrivacyFlag = true;
          }
        },
        error: (err) => {
          this.modalListLoading = false;
          console.error("Error fetching network data:", err);
        },
      });
    }
  }


  storedPage: any;
  // Retained for the other multi-select modals (Network / Community /
  // Workspace) which still use ngx-pagination. The Connections list now
  // bypasses this — see loadMoreConnections() which auto-chains through
  // server pages via cursor.
  config: any = {
    itemsPerPage: 12,
    currentPage: 1
  }

  pagecount(count) {
    this.config.currentPage = count
    this.storedPage = count
  }

  // Triggered by the infinite-scroll directive on the fixed-height
  // connection list. Each scroll-to-bottom pulls one more server page;
  // the directive itself keeps firing as long as the user keeps reaching
  // the end of the loaded rows.
  onConnectionsScrollDown(): void {
    this.loadMoreConnections();
  }

  // Single scroll handler for the post-privacy modal list. Routes to the
  // right cursor loader based on which tab is open (Connections / Network).
  onModalScrollDown(): void {
    if (this.postviewModelName === 'Connections') {
      this.loadMoreConnections();
    } else if (this.postviewModelName === 'Network') {
      this.loadMoreNetworks();
    }
  }

  // Fetches the next batch of networks using the stored searchAfterKey and
  // appends to modelList. Mirrors loadMoreConnections(); the infinite-scroll
  // handler decides when to fetch more.
  private loadMoreNetworks(): void {
    if (!this.networkHasMore || this.networkLoadingMore) return;
    this.networkLoadingMore = true;

    const payload: any = {
      userId: localStorage.getItem('userId'),
      withMember: true,
      limit: 10,
      offset: 0,
      status: 'ACTIVE',
      searchContent: this.modalSearchTerm || null,
      searchAfterKey: this.networkAfterKey,
    };

    this.api.create('network/home', payload).subscribe((res) => {
      if (res?.code === '00000') {
        const rows = (res.data && res.data.network) || [];
        // Match the initial-load shaping: networkId drives userId + checked.
        rows.forEach((row: any) => {
          row.userId = row.networkId;
          row.checked = this.checkedList?.includes(row.networkId);
        });
        // Defensive de-dupe in case the cursor returns overlap.
        const seen = new Set(this.modelList.map((r: any) => r.networkId));
        const fresh = rows.filter((r: any) => !seen.has(r.networkId));
        this.modelList = [...this.modelList, ...fresh];

        this.updateNetworkCursor(res.data && res.data.searchAfterKey, rows.length);
      }
      this.networkLoadingMore = false;
    }, () => {
      this.networkLoadingMore = false;
    });
  }

  // Translate a network `searchAfterKey` into hasMore + cursor state. Same
  // logic as updateConnectionCursor: a repeated key, an empty key, or an
  // empty page all mean "no more pages".
  private updateNetworkCursor(afterKey: any, batchLength: number): void {
    const sameAsPrev = JSON.stringify(afterKey) === JSON.stringify(this.networkPrevAfterKey);
    const isEmptyKey = afterKey == null || (Array.isArray(afterKey) && afterKey.length === 0);
    const isLastPage = batchLength < 10; // If batch is smaller than limit, this is the last page
    if (sameAsPrev || isEmptyKey || batchLength === 0 || isLastPage) {
      this.networkHasMore = false;
    } else {
      this.networkPrevAfterKey = afterKey;
      this.networkAfterKey = afterKey;
      this.networkHasMore = true;
    }
  }

  // Fetches the next batch of connections using the stored cursor and
  // appends to modelList. Single-shot (per call) — the infinite-scroll
  // handler decides when to fetch more.
  private loadMoreConnections(): void {
    if (!this.connectionsHasMore || this.connectionLoadingMore) return;
    this.connectionLoadingMore = true;

    const datas: any = {
      userId: localStorage.getItem('userId'),
      status: 'CONNECTED',
      limit: 12,
      searchAfterKey: this.connectionAfterKey,
      searchContent: this.modalSearchTerm || null
    };

    this.api.create('user/connection/info', datas).subscribe((res) => {
      if (res?.code === '00000') {
        const rows = (res.data && res.data.response) || [];
        // Re-apply checked state so already-selected rows stay ticked.
        rows.forEach((row: any) => {
          row.checked = this.checkedList?.includes(row.userId);
        });
        // Defensive de-dupe in case the cursor returns overlap.
        const seen = new Set(this.modelList.map((r: any) => r.userId));
        const fresh = rows.filter((r: any) => !seen.has(r.userId));
        this.modelList = [...this.modelList, ...fresh];

        this.updateConnectionCursor(res.data && res.data.searchAfterKey, rows.length);
      }
      this.connectionLoadingMore = false;
    }, () => {
      this.connectionLoadingMore = false;
    });
  }

  // Translate a `searchAfterKey` from the response into hasMore + cursor
  // state. Mirrors `/connection`'s detection logic — same key as the
  // previous request, an empty key, an empty page, or a page shorter than
  // the requested limit all mean "done". The short-page check matters for
  // small lists: a single connection still comes back with a valid cursor
  // key, and a list too short to scroll never triggers loadMoreConnections,
  // so without it hasMore stays true and the end-of-list message never shows.
  private updateConnectionCursor(afterKey: any, batchLength: number): void {
    const sameAsPrev = JSON.stringify(afterKey) === JSON.stringify(this.connectionPrevAfterKey);
    const isEmptyKey = afterKey == null || (Array.isArray(afterKey) && afterKey.length === 0);
    const isLastPage = batchLength < 12; // both connection requests ask for limit: 12
    if (sameAsPrev || isEmptyKey || batchLength === 0 || isLastPage) {
      this.connectionsHasMore = false;
    } else {
      this.connectionPrevAfterKey = afterKey;
      this.connectionAfterKey = afterKey;
      this.connectionsHasMore = true;
    }
  }

  onSearch(event: any) {
    const value = event?.target?.value || '';
    if (value != '') {
      this.config.currentPage = 1
    } else if (value == '') {
      this.config.currentPage = this.storedPage
    }
    // Show the skeleton the instant the search text actually changes — BEFORE
    // the debounced fetch fires. Without this the list visibly client-filters
    // and flashes "No records available!" during the ~400ms debounce window
    // (Network glitch). Gated to the modal tabs and only when the value
    // differs from the loaded term, so the debounced query is guaranteed to
    // run and clear the flag.
    if (value.trim() !== (this.modalSearchTerm || '') &&
        ['Connections', 'Network', 'Community'].includes(this.postviewModelName)) {
      this.modalListLoading = true;
    }
    // Server-side search for the post-privacy modal lists. The subscriber
    // in ngOnInit debounces, resets the cursor, and refetches the active
    // tab so search spans all records (not just the loaded batch). The
    // guard inside the subscriber ignores keystrokes from other modal
    // inputs that share this handler but don't drive `postviewModelName`.
    this.modalSearchSubject.next(value);
  }


  selectedEntities: any = []

  // "+N more" / "Show less" toggle for the connection chips in the Edit modal,
  // mirroring the applicant card's skill chips
  // (candidate-card-table-view.component.ts:577).
  showAllPrivacyEntities = false

  togglePrivacyEntities(): void {
    this.showAllPrivacyEntities = !this.showAllPrivacyEntities
  }

  private resetPrivacyEntities(): void {
    this.showAllPrivacyEntities = false
  }

  onCheckboxChange(option, event) {
    // Derive the id + display label from the ACTIVE tab (postviewModelName)
    // rather than a server-supplied flag. Searched connection rows don't
    // always carry `option.connection`, which previously left the branch
    // dead — nothing pushed to checkedList, so Continue stayed disabled and
    // the selection vanished on clearing the search. Keying off the tab
    // keeps selection reliable for both the initial list and search results.
    let id: any;
    let label: string;
    if (this.postviewModelName === 'Network') {
      id = option.networkId;
      label = option.networkName;
    } else if (this.postviewModelName === 'Community') {
      id = option.communityId;
      label = option.communityName;
    } else {
      // Connections
      id = option.userId;
      label = option.fullName ||
        ((option.firstName || '') + ' ' + (option.lastName || '')).trim();
    }

    if (event.target.checked) {
      option.checked = true;
      if (id != null && !this.checkedList.includes(id)) {
        this.checkedList.push(id);
      }
      if (label) {
        this.selectedEntities.push(label);
        this.selectedEntities = this.duplicate(this.selectedEntities);
      }
    } else {
      option.checked = false;
      // Remove by VALUE, not by index — checkedList and selectedEntities are
      // not index-aligned with modelList, so the old index-based splice
      // removed the wrong entries.
      this.checkedList = this.checkedList.filter((x: any) => x !== id);
      if (label) {
        const idx = this.selectedEntities.indexOf(label);
        if (idx > -1) this.selectedEntities.splice(idx, 1);
      }
    }
  }
  duplicate(data) {
    var temp = [];
    var arr = data.filter(function (el) {
      if (temp.indexOf(el) == -1) {
        temp.push(el);
        return true;
      }
      return false;
    });
    return arr;
  }

  remove(chooseEntity: string): void {
    const index = this.selectedEntities.indexOf(chooseEntity);

    if (index >= 0) {
      this.selectedEntities.splice(index, 1);
    }
  }
  selectable = true;
  removable = true;
  fruitCtrl = new UntypedFormControl();
  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedEntities.push(event.option.viewValue);
    // this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }


  imagePopup(template) {
    this.modalRef = this.modalService.show(template, {
      backdrop: "static",
      animated: true,
    });
  }

  additems(data) {
    data.forEach((element, index) => {
      this.userData.push(element);
    });
  }

  onScrollDown() {

    if (this.postLoading == false) {
      this.currentPageCount += 1;
      this.startCount = this.currentPageCount;
      if (this.startCount != 0) {
        this.commonPost_getpostdatas(this.startCount, this.pageCount);
      }
    }

  }



  sortData(data) {
    return data;
    // return data.sort((a, b) => {
    //   return <any>new Date(b.postedOn) - <any>new Date(a.postedOn);
    // });
  }

  getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])
      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  }

  images: any = []

  load(value) {
    if (value.length > 1) {
      this.postflags = true;
    } else {
      this.postflags = false;
    }
  }

  privacyLock: any = ''
  editPost: boolean = false
  // True while the edit modal is fading out. The privacy row's visibility is held at
  // editPrivacyRowFrozen for that whole window so no deferred reset can make it appear
  // or disappear mid-fade. editCloseToken lets a new edit cancel a pending cleanup.
  closingEdit: boolean = false
  editPrivacyRowFrozen: boolean = false
  editCloseToken: number = 0
  privacyentityset: any;
  // Shown in place of the privacy dropdown whenever showEditPrivacyRow is false, so the
  // author row is never left empty.
  editPostedOn: any = null;

  get showEditPrivacyRow(): boolean {
    if (this.closingEdit) {
      return this.editPrivacyRowFrozen
    }
    return (this.editPost && this.privacyValue === 'Connections') || !this.editPost
  }

  findPost(data, template: TemplateRef<any>) {

    // Cancel any cleanup still pending from the modal we just closed, so it cannot wipe
    // the state we are about to set up here.
    this.editCloseToken++
    this.closingEdit = false
    this.editPost = true
    // The save request reads this.postPrivacy, which every create/edit resets to "Everyone".
    // Without restoring it here an edit of a Connections post was sent as "Everyone": the
    // response echoed that, so the "shared with" names vanished from the card until a
    // refresh, and any change to the connection list was silently not saved.
    this.postPrivacy = data.postPrivacy || 'Everyone';
    if (data.postPrivacy == 'Connections') {
      this.postTypeForm.get('postType').patchValue('Connections')
      this.privacyValue = 'Connections'
    } else if (data.postPrivacy == 'Network') {
      this.postTypeForm.get('postType').patchValue('Network')
      this.privacyValue = 'Network'
    } else if (data.postPrivacy == 'Community') {
      this.postTypeForm.get('postType').patchValue('Community')
      this.privacyValue = 'Community'
    } else if (data.postPrivacy == 'Everyone') {
      this.postTypeForm.get('postType').patchValue('Everyone')
      this.privacyValue = 'Everyone'
    }
    this.imagEditData = [];
    this.commanddataEdit = "";
    this.imagEditDatatemp = [];
    this.typesofFile == "";
    this.posteditId = "";
    // An image-only post has no text (null). Keep this a string so the edit save
    // can call .includes() on it instead of throwing and silently doing nothing.
    this.commanddataEdit = data.postContent || "";
    this.commanddata1 = data.postContent;
    this.posteditId = data.postId;
    this.editPostedOn = data.postedOn || null;

    if (data.medias && data.medias != null && data.medias.length > 0) {
      this.typesofFile = data.medias[0].type;
      data.medias.forEach((element) => {
        if (element.status == "ACTIVE") {
          this.imagEditData.push(element);
        }
      });
    } else {
      this.imagEditData = [];
    }
    this.privacyentityset = data;
    this.selectedEntities = []
    // Start the edit from the stored recipients only. sharePostPage() used to leave the
    // previous selection in these lists, so opening Edit on a fresh share pushed every
    // id a second time and the save persisted the duplicated list (names shown twice
    // on the card and as chips). Skipping ids already present also heals a post whose
    // stored list is already duplicated on its next save.
    this.checkedList = [];
    this.tempcheckedList = [];
    this.resetPrivacyEntities()
    this.api.create("post/queryPrivacyEntities", data).subscribe(res => {

      if (res != undefined && res) {

        res.forEach(element => {
          if (this.tempcheckedList.includes(element.postEntityId)) {
            return;
          }
          this.selectedEntities.push(element.name)
          this.tempcheckedList.push(element.postEntityId)

          this.checkedList.push(element.postEntityId)
        });
        ;
      }
    })

    setTimeout(() => {
      this.util.startLoader()
      this.modalRefedit = this.modalService.show(template, {
        animated: true,
        backdrop: "static",
      });
      this.util.stopLoader()
    }, 600);
  }

  deleteImage(fileId: string) {


    this.imagEditData.forEach((element, i) => {
      if (element.fileId == fileId) {
        this.imagEditData.splice(i, 1);

      }
      if (this.imagEditData.length == 0) {
        this.uploadFiles = [];
      }
    });
  }
  // Delete Post
  removepost(data) {
    var postId = data.postId;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.api.delete("post/remove/" + data.postId).subscribe((res) => {
            if (res != null) {
              if (res.code == "00000") {

                let indx = this.userData.findIndex(item => item.postId == postId);
                this.userData.splice(indx, 1);

                // Tell every live post list (this one included) so shares of
                // the deleted post flip to "no longer available" right away.
                this.commonvalues.setPostDeleted(postId);

                // this.userbadges.profileStatus();
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Your post has been deleted.",
                  showConfirmButton: false,
                  timer: 2000,
                });
              } else if (res.code == "99999") {
                Swal.fire("Post not deleted");
              }
            }
          }, err => {
            this.util.stopLoader();
          });


        }

      });
  }

  close() {
    this.gigsumoService.buttonClicked = true;
    this.beingEdited = false
    if (this.openModal == true) {
      this.modalRef.hide();
      setTimeout(() => {
        this.otherSelectedStates = []
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];
        this.editPost = false
        this.selectedvideo = false;
        this.selectedImage = false;
        this.searchName = ""
        this.resetPrivacyEntities()
        this.modalRef.hide();
        $("#file-input").val("");
        $("#file-input-upload").val("");

        this.networkZeroFlag = false
        this.commonVariables.postFormflag = true;
        this.teamZeroFlag = false
        this.connectionZeroFlag = false
        this.communityZeroFlag = false
        this.commonVariables.postPrivacyFlag = false;
        this.searchData.setCommonVariables(commonVariables);
        this.postTypeForm.get('postType').setValue('Everyone')
        setTimeout(() => {
          this.privacyValue = 'Everyone'
          this.linkTitle = null
          this.linkImage = null
          this.linkDescription = null
          this.linkURL = null
          this.modelList.forEach(element => {
            element.checked = false
          })
          CustomValidator.count1 = 0
          CustomValidator.count = 0
          CustomValidator.stoppingCount = undefined
          $("#summessage").summernote("reset");
          this.uploadFiles = [];
          this.selectedEntities = []
          this.checkedList = []
          window.scrollTo(0, this.scrollValue.windowScroll);
          this.modalOpenFlag = false
        }, 500);
      }, 1500);
    } else {
      this.commonVariables.postFormflag = true;
      this.commonVariables.postPrivacyFlag = false;
      this.otherSelectedStates = []
      this.primarySkillsSelected = [];
      this.secondarySkillsSelected = [];
      this.editPost = false
      this.selectedvideo = false;
      this.selectedImage = false;
      this.searchName = ""
      this.modalRef.hide();
      $("#file-input").val("");
      $("#file-input-upload").val("");
      var commonVariables: any = {};
      commonVariables.postPrivacyFlag = false;
      this.networkZeroFlag = false
      this.teamZeroFlag = false
      this.connectionZeroFlag = false
      this.communityZeroFlag = false
      this.searchData.setCommonVariables(commonVariables);
      this.postTypeForm.get('postType').setValue('Everyone')
      setTimeout(() => {
        this.privacyValue = 'Everyone'
        this.linkTitle = null
        this.linkImage = null
        this.linkDescription = null
        this.linkURL = null
        this.modelList.forEach(element => {
          element.checked = false
        })
        CustomValidator.count1 = 0
        CustomValidator.count = 0
        CustomValidator.stoppingCount = undefined
        $("#summessage").summernote("reset");
        this.uploadFiles = [];
        this.selectedEntities = []
        this.resetPrivacyEntities()
        this.checkedList = []
        window.scrollTo(0, this.scrollValue.windowScroll);
        this.modalOpenFlag = false
      }, 500);
    }

  }

  connectionZeroFlag: boolean = false
  teamZeroFlag: boolean = false
  dismiss() {
    if (this.openModal == true) {
      this.modalRef.hide()
      setTimeout(() => {
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];
        this.otherSelectedStates = []
        this.animState0 = 'middle'
        this.animState1 = 'left'
        this.animState = 'left'
        if (this.editPost != true) {
          this.privacyValue = 'Everyone'
          this.checkedList = [];
          this.selectedEntities = []
        }

        this.searchName = "";
        this.page = 0;
        this.networkZeroFlag = false
        this.connectionZeroFlag = false
        this.teamZeroFlag = false
        this.communityZeroFlag = false
        var commonVariables: any = {};
        this.commonVariables.postPrivacyFlag = false;
        this.commonVariables.postFormflag = true;
        this.searchData.setCommonVariables(commonVariables);
        this.postTypeForm.get('postType').setValue('Everyone')
        CustomValidator.count1 = 0
        CustomValidator.count = 0
        CustomValidator.stoppingCount = undefined
      }, 1500);
    } else {
      this.primarySkillsSelected = [];
      this.secondarySkillsSelected = [];
      this.otherSelectedStates = []
      this.animState0 = 'middle'
      this.animState1 = 'left'
      this.animState = 'left'
      if (this.editPost != true) {
        this.privacyValue = 'Everyone'
        this.checkedList = [];
        this.selectedEntities = []
      }
      this.commonVariables.postPrivacyFlag = false;
      this.commonVariables.postFormflag = true;
      // this.editPost = false
      // this.modalRef_PostView.hide();
      this.searchName = "";
      this.page = 0;
      this.networkZeroFlag = false
      this.connectionZeroFlag = false
      this.teamZeroFlag = false
      this.communityZeroFlag = false
      var commonVariables: any = {};
      commonVariables.postPrivacyFlag = false;
      this.searchData.setCommonVariables(commonVariables);
      this.postTypeForm.get('postType').setValue('Everyone')
      CustomValidator.count1 = 0
      CustomValidator.count = 0
      CustomValidator.stoppingCount = undefined
    }

  }

  jobformreset() {
    this.submit = false;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    });

    swalWithBootstrapButtons.fire({
      title: 'Are you sure ?',
      text: " All data will be lost.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        this.jobPostForm.reset({
          jobId: this.jobPostForm.get('jobId').value,
          jobPostedBehalfOf: this.jobPostForm.get('jobPostedBehalfOf').value, durationType: 'Months'
        })
        this.jobPostForm.get('city').enable();
        this.jobPostForm.get('country').enable();
        this.jobPostForm.get('state').enable();
        this.jobPostForm.get('zipCode').enable();
        this.jobPostForm.get('clientType').enable();
        this.jobPostForm.get('duration').enable();
        this.jobPostForm.get('durationType').enable();
        this.updateControl({ value: 'duration', form: this.jobPostForm });
        this.updateControl({ value: 'durationType', form: this.jobPostForm });
        localStorage.removeItem(this.userid + "_landingPagejobPostForm");

        // For Free plan users, preserve Marketplace selection
        if (this.membershipType === 'Free') {
          this.selectedNetworks = ['1'];
          this.jobPostForm.get('selectedNetworks').setValue(this.selectedNetworks);
        } else {
          this.selectedNetworks = [];
        }

        // Reset JD parsing state
        this.jdParsingService.isJdParsing = false;
        this.jdParsingService.jdParseSuccess = false;
        this.jdParsingService.jdParseFailed = false;
      }
    })
  }
  candidateformreset() {
    this.candidateSubmit = false;

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    });

    swalWithBootstrapButtons.fire({
      title: 'Are you sure ?',
      text: " All data will be lost",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        this.candidatePostForm.reset({
          candidateId: this.candidatePostForm.get('candidateId').value
        });
        this.candidatePostForm.get('workAuthorization').disable();
        this.workAuthorizationList = [];

        // Resume upload / parsing teardown. Clear previously only reset the reactive form,
        // so the uploaded resume chip, the "parsed successfully" state, a running progress
        // bar and an in-flight parse response all survived (and could refill the form).
        if (this.resumeParseSubscription) {
          this.resumeParseSubscription.unsubscribe();
          this.resumeParseSubscription = null;
        }
        if (this.progressSimulationInterval) {
          clearInterval(this.progressSimulationInterval);
          this.progressSimulationInterval = null;
        }
        this.isUploading = false;
        this.uploadProgress = 0;
        this.parseRetryCount = 0;
        this.isParsing = false;
        this.removeFiles();

        // ng-select mirrors bound with [(ngModel)] next to formControlName
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];
        this.otherSelectedStates = [];
        this.selectedJobTitle = undefined;

        // Candidate photo
        this.fileshow = undefined;
        this.photoId = null;
        if (this.myFileInputcandidate?.nativeElement) {
          this.myFileInputcandidate.nativeElement.value = null;
        }

        setTimeout(() => {

          if (this.userType == 'JOB_SEEKER') {
            this.candidatePostForm.patchValue({
              email: this.primaryEmail,
              firstName: this.firstName,
              lastName: this.lastName,
            })

            this.candidatePostForm.get('email').disable()
            this.candidatePostForm.get('firstName').disable()
            this.candidatePostForm.get('lastName').disable()
          }

          localStorage.removeItem(this.userid + "_landingPagecandidatePostForm");

          // For Free plan users and JOB_SEEKER, preserve Marketplace selection
          if (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') {
            this.selectedNetworks = ['1'];
            this.candidatePostForm.get('selectedNetworks').setValue(this.selectedNetworks);
          } else {
            this.selectedNetworks = [];
          }

        }, 500);
      }
    })

  }

  closeuploadEdit() {
    this.beingEdited = false
    this.selectedvideo = false;
    this.selectedImage = false;

    $("#file-input-upload").val("");

    this.modalRef.hide();

    this.commanddata1 = this.commanddata1;
    this.uploadFiles.forEach((element, i) => {
      element.url = element.src;
      element.fileId = element.src;
      element.orderBy = this.imagEditData.length + 1;

      if (element.t == "video") {
        element.type = "video";
      } else if (element.t == "image") {
        element.type = "image";
      }

      this.imagEditData.push(element);
    });
  }

  privacyValue = 'Everyone'

  closeEdit() {
    // Already closing. A repeat click would call hide() on a modal that is gone, which
    // returns without emitting onHidden and would strand the cleanup below.
    if (this.closingEdit) {
      return
    }

    // Hold the privacy row at its current visibility until the next edit opens, so none
    // of the resets can make the Network dropdown appear while the dialog is still up.
    this.editPrivacyRowFrozen = this.showEditPrivacyRow
    this.closingEdit = true
    const closeToken = ++this.editCloseToken

    this.beingEdited = false

    this.selectedvideo = false;
    this.selectedImage = false;

    // Clear the editor only once the modal's view is actually destroyed. On a timer the
    // resets can land while the dialog is still painted, which blanks the post text on
    // screen and drops Summernote back to its placeholder.
    this.modalService.onHidden
      .pipe(take(1), takeUntil(this.destroy))
      .subscribe(() => {
        // A new post is already being edited; leave its state alone.
        if (closeToken !== this.editCloseToken) {
          return
        }
        this.resetEditState()
      })

    this.modalRefedit.hide();

    $("#file-input").val("");
  }

  private resetEditState() {
    // closingEdit deliberately stays set. findPost() clears it when the next edit modal
    // opens, which is the only time the privacy row is rendered.
    this.editPost = false
    this.commanddataEdit = "";
    this.imagEditData = null;
    this.imagEditDatatemp = [];
    this.uploadFiles = [];
    this.selectedEntities = []
    this.resetPrivacyEntities()
    this.checkedList = []
    this.tempcheckedList = []
    this.linkTitle = null
    this.linkImage = null
    this.linkDescription = null
    this.linkURL = null
    CustomValidator.count1 = 0
    CustomValidator.count = 0
    CustomValidator.stoppingCount = undefined
  }

  savewithattachment(status: any, data, entityid, entity) {
    this.FormData = new FormData();
    var mediasData: any = [];
    this.FormData.append("medias", "medias");
    this.FormData.append("file", "file");

    this.FormData.delete("medias");
    this.FormData.delete("file");

    if (status === "new") {

      this.modalRef.hide();


      this.modalRef.hide()
      this.selectedEntities = []
      this.startCount = 0;

      this.currentPageCount = 1;
      this.commanddata = "";
      setTimeout(() => {
        // this.userbadges.profileStatus();
      }, 2000);

      if (this.uploadFiles != null) {
        this.uploadFiles.forEach((element) => {
          this.FormData.append("file", element.file);
        });
      }

      this.dataPostandUpdate("post/createwithmedia", data, "new", null, null);

    } else if (status === "edit") {

      const editorHtml: string = $("#summessageges").summernote("code") || "";
      let content = editorHtml
        .replace(/&nbsp;|<\/?[^>]+(>|$)/g, "")
        .trim();
      // Text is optional when the post has media. Take the text from the editor the
      // user is looking at (the same source the gate below checks) so the saved
      // postContent always matches it, and a visually empty editor ("<p><br></p>")
      // is stored as "" rather than blank markup.
      this.commanddataEdit = content.length > 0 ? editorHtml : "";
      if (this.imagEditData != undefined) {
        this.imagEditData.forEach((element) => {
          if (element.status == "INACTIVE") {
            this.FormData.append("file", element.file);
          } else if (element.status == "ACTIVE") {
            mediasData.push(element);
          }
        });
      }
      if (this.uploadFiles.length == 0 && mediasData.length == 0 && content.length == 0) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Empty post",
          text: "This post appears to be blank. Please write something or attach a link or a photo to post.",
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 3500,
        });
        $("#summessageges").summernote("reset");
        $("#SummernoteText").summernote("reset");
        return;
      }
      const substring = "<img";
      //Copy paste image restiction on text editor by monisha
      if (
        (content.length > 0 || mediasData.length !== 0 || this.uploadFiles.length >= 1) &&
        this.commanddataEdit.includes(substring)
      ) {
        this.commanddataEdit = this.commanddataEdit.replace(/<img[^>]*>/g, '');

      }
      if (
        this.urlLinkDetctForm.valid &&
        !this.commanddataEdit.includes(substring) &&
        (this.uploadFiles.length >= 1 || content.length !== 0 || mediasData.length !== 0)
      ) {
        this.dataPostandUpdate("post/updatewithmedia", mediasData, "edit", entityid, entity);
        this.modalRefedit.hide();
      }
    }
  }

  dataPostandUpdate(path: any, mediapostdata: any, status?: any, entityid?: any, entity?: any) {
    let postEntityId;
    if (status !== "edit") {
      if (this.Commomdatass === "USER") {
        postEntityId = this.userId;
      } else if (this.Commomdatass === "COMMUNITY") {
        postEntityId = this.communityid;
      } else if (this.Commomdatass === "BUSINESS") {
        postEntityId = this.businessId;
      } else if (this.Commomdatass === "NETWORK") {
        postEntityId = this.networkId;
      } else if (this.Commomdatass === "TEAM") {
        postEntityId = this.teamId;
      }
    }
    let postcont = null;
    let qwe = "";

    if (this.editPost == true) {
      try {
        qwe = $("#summessageges").summernote("code").replace(/&nbsp;|<\/?[^>]+(>|$)/g, "").trim();
      } catch (error) {

      }
    } else if (this.editPost == false) {
      try {
        qwe = $("#summessage").summernote("code").replace(/&nbsp;|<\/?[^>]+(>|$)/g, "").trim();
      } catch (error) {

      }
    }
    if (this.commanddata1 &&
      this.commanddata1 != null &&
      this.commanddata1.length != 0
    ) {
      postcont = this.commanddata1.trim();
    } else if (qwe && qwe != null && qwe.length != 0) {
      postcont = qwe
    }
    else {
      postcont = null;
    }

    var edit

    this.sendMessageData = {
      postType: "OWN",
      sourcePostId: "",
      postName: this.entername,
      postContent: postcont,
      postEntity: this.Commomdatass,
      postEntityId: postEntityId,
      postedBy: localStorage.getItem("userId"),
      postPrivacyEntities: this.tempcheckedList,
      postPrivacy: this.postPrivacy,
    };

    if (status && status !== null && (status === "edit" || status === 'mediaWithTexts')) {
      edit = true
      this.sendMessageData = {};
      this.sendMessageData = {
        postType: "OWN",
        sourcePostId: "",
        postName: this.entername,
        postContent: this.commanddataEdit,
        postEntity: entity,
        postEntityId: entityid,
        postId: this.posteditId,
        postedBy: localStorage.getItem("userId"),
        medias: mediapostdata,
        postPrivacyEntities: this.tempcheckedList,
        postPrivacy: this.postPrivacy,
      };
    } else {
      edit = false
    }

    this.FormData.append(
      "post",
      new Blob([JSON.stringify(this.sendMessageData)], {
        type: "application/json",
      })
    );

    this.util.startLoader();
    this.api
      .messagePageService("POST", path, this.FormData)
      .subscribe((res) => {
        if (res) {
          let timeout: any = undefined;
          this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe((val) => {
            timeout = val;
          });

          this.util.stopLoader();
          this.showWelcomePost = false;
          this.FormData.delete("file");
          this.FormData.delete("post");
          this.tempcheckedList = [];
          this.checkedList = []
          this.postPrivacy = "Everyone";
          this.editPost = false
          this.privacyValue = 'Everyone'
          $("#file-input").val("");
          this.commanddata1 = null;
          this.attachment = false;
          this.sendMessageData = {};
          this.uploadFiles = [];
          this.selectedEntities = []
          this.entername = "";
          res.edit = edit;
          res.userName = res.PostEntityName;
          // The update response echoes the request, and the edit request always says
          // postType "OWN" / sourcePostId "" (see sendMessageData above), so an edited
          // SHARE post came back as an own post and the feed dropped the embedded
          // original (author, text, image) until a refresh. Restore the share identity
          // from the card being edited (findPost keeps it in privacyentityset).
          const editedCard = this.privacyentityset;
          if (edit && editedCard && editedCard.postId === res.postId && editedCard.postType === "SHARE") {
            res.postType = "SHARE";
            if (!res.sourcePostId && editedCard.shareduser && editedCard.shareduser[0]) {
              res.sourcePostId = editedCard.shareduser[0].postId;
            }
            if (res.sharedCount == null) {
              res.sharedCount = editedCard.sharedCount;
            }
          }
          // Both callers funnel through here: "post/createwithmedia" and
          // "post/updatewithmedia". `edit` is the same flag stamped onto res above,
          // so it picks the wording for us.
          Swal.fire({
            position: "center",
            icon: "success",
            title: edit ? "Post updated successfully" : "Post created successfully",
            showConfirmButton: false,
            timer: 2000,
          });
          this.localPushData(res);
          $("#summessage").summernote("reset");
          this.linkTitle = null
          this.linkImage = null
          this.linkDescription = null
          this.linkURL = null
        }
      },
        err => {
          if (err.status == 500) {
            this.uploadFiles = []
            this.checkedList = []
            this.tempcheckedList = []
          }
          // This handler used to return silently and never stop the loader, so a
          // failed media post left the spinner running forever with no message.
          // On the edit path the modal is already hidden before the request is
          // sent, so the user's changes disappeared with no explanation at all.
          // stopLoader() is required here: the spinner otherwise covers the dialog.
          this.util.stopLoader();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Post could not be saved. Please try again.",
            showDenyButton: false,
            confirmButtonText: `ok`,
          });
        });
  }

  redirectUserFromShareModel(post?: any, data?: any) {
    this.closeSharePage();
    this.userprofile(post, data);
  }

  // Poster name in an entity post header always means the person, not the entity.
  openPosterProfile(post: any) {
    if (post?.isPlatformPost || !post?.postedBy) return;
    this.userprofile(undefined, post.postedBy);
  }

  userprofile(post?: any, data?: any) {
    let userData: any = {};
    userData.userId = data;
    if (post && post?.isPlatformPost) {
      return;
    }
    if (post) {
      if (post.postEntity === "COMMUNITY1") {
        let datas: any = {};
        this.communityid = post.postEntityId;

        this.api
          .query("community/details/" + this.communityid)
          .subscribe((res) => {
            this.router.navigate(["community"], { queryParams: res.data.communityDetails });
          }, err => {
            this.util.stopLoader();
          });
      } else if (post.postEntity === "BUSINESS") {
        let datas: any = {};
        datas.businessId = post.postEntityId;
        datas.userId = localStorage.getItem("userId");
        this.api.create("business/check/admin", datas).subscribe((res) => {

          localStorage.setItem("businessId", post.postEntityId);
          localStorage.setItem("isAdmin", res.isAdmin);
          localStorage.setItem("isSuperAdmin", res.isSuperAdmin);
          localStorage.setItem("screen", "business");
          localStorage.setItem("adminviewflag", "false");
          res.businessId = post.postEntityId;
          this.router.navigate(["business/post"], { queryParams: res });
        }, err => {
          this.util.stopLoader();
          if (err.status == 500) {
            this.util.stopLoader();
          }
        });
      } else if (post.postEntity === "NETWORK1") {
        this.api.query("network/get/" + post.postEntityId).subscribe((res) => {
          if (res != undefined && res != null) {
            this.router.navigate(["networkPage/home"], {
              queryParams: res.data.Network,
            });
          }
        }, err => {
          this.util.stopLoader();
        });
      } else if (post.postEntity === "TEAM1") {
        this.api.query("teams/get/" + post.postEntityId).subscribe((res) => {
          if (res != undefined && res != null) {
            this.router.navigate(["teamPage/home"], {
              queryParams: res.data.teams,
            });
          }
        }, err => {
          this.util.stopLoader();
        });
      } else {
        const userId = localStorage.getItem("userId");
        if (userId === data) {
          var datum: any = {}
          datum.userId = userId;

          this.router.navigate(["personalProfile"], { queryParams: datum });
        } else {
          this.router.navigate(["personalProfile"], { queryParams: userData });
        }
      }
    } else {
      const userId = localStorage.getItem("userId");
      if (userId === data) {
        var datum: any = {}
        datum.userId = userId;
        this.router.navigate(["personalProfile"], { queryParams: datum });

      } else {
        this.router.navigate(["personalProfile"], { queryParams: userData });
      }
    }
  }


  loadPost(postId: string) {

    if (postId) {
      this.afterKey = undefined;
      setTimeout(() => {
        this.commonPost_getpostdatas(null, null);
      }, 1500);
    }
  }



  fileUpload(
    event: any,
    imgtype: string,
    template?: TemplateRef<any>,
    option?: any,
  ) {

    this.uploadFiles = [];
    this.commanddata1 = null;
    const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
    const videofileaccept = ["video/mp4", "video/webm"];
    var files = event.target.files;
    if (files[0].size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      return true;
    }
    for (var i = 0, file; (file = files[i]); i++) {
      if (imgtype == "image" && acceptedImageTypes.includes(file.type)) {
      } else if (
        imgtype == "image" &&
        !acceptedImageTypes.includes(file.type)
      ) {
        Swal.fire("", `${this.FORMERROR.IMAGE_TYPE_VALID}`, "info");
        this.uploadFiles = [];
        this.modalRef.hide();

        return true;
      } else if (imgtype == "video" && videofileaccept.includes(file.type)) {
      } else if (imgtype == "video" && !videofileaccept.includes(file.type)) {
        Swal.fire("", "Please select only video type files.", "info");
        this.uploadFiles = [];
        this.modalRef.hide();

        return true;
      } else if (
        (imgtype == "both" && videofileaccept.includes(file.type)) ||
        (imgtype == "both" && acceptedImageTypes.includes(file.type))
      ) {
      } else if (
        (imgtype == "both" && !videofileaccept.includes(file.type)) ||
        (imgtype == "both" && !acceptedImageTypes.includes(file.type))
      ) {
        Swal.fire("", `${this.FORMERROR.IMAGE_VIDEO_VALID}`, "info");
        this.uploadFiles = [];
        this.modalRef.hide();

        return true;
      }
    }

    if (template != null) {
      // The composer's Photo / Video buttons open #fileuploadPopUp here rather than
      // through startAPost(), so collapse the connection chips the same way it does.
      this.resetPrivacyEntities()
      this.modalRef = this.modalService.show(template, {
        animated: true,
        backdrop: "static",
      });
    }

    this.selectedImage = false;
    this.selectedImage = false;

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        reader.onload = (event1: any) => {
          const type = event.target.files[i].type;
          let type1 = "image";
          if (type.includes("image")) {
            this.selectedImage = true;
            type1 = "image";
          } else if (type.includes("video")) {
            this.selectedvideo = true;
            type1 = "video";
          } else if (type.includes("application")) {
            type1 = "application";
          } else if (type.includes("audio")) {
            type1 = "audio";
          } else {
            type1 = "others";
          }
          const data = {
            t: type1,
            ft: type,
            fileName: type,
            file: event.target.files[i],
            status: "INACTIVE",
            src: event1.target.result,
          };
          this.uploadFiles.push(data);
        };
        reader.readAsDataURL(event.target.files[i]);


        if (!this.attachment) {
          this.attachment = true;
          setTimeout(() => {

          }, 100);
        }
      }
    }


  }
  selectedImage1?: number = null
  wasShareModalOpen: boolean = false;
  // `modalRef` is reused by every modal in this component and is never reset to
  // null after `.hide()`, so it stays truthy long after the share modal is gone.
  // This flag tracks only the share modal specifically, so the carousel's close
  // button reopens Share only when the image was actually opened from within it.
  isShareModalOpen: boolean = false;

  pushImages(values: any[], index: number): void {
    if (!Array.isArray(values) || !values[index] || !values[index].url) {
      return;
    }

    // Track if share modal was open before opening carousel
    if (this.isShareModalOpen) {
      this.wasShareModalOpen = true;
      // Hide the share modal to allow carousel to be visible
      this.modalRef.hide();
      // Also try to hide any other modals that might be open
      this.modalService.hide(1);
    }
    
    this.selectedImage1 = index;
    if (this.videoPlayer?.nativeElement) {
      try {
        this.videoPlayer.nativeElement.src = values[index].url;
        this.videoPlayer.nativeElement.load();
        this.videoPlayer.nativeElement.play();
      } catch (error) {

      }
    }
    this.images = values;
  }
  
  closeCarouselAndReopenShareModal(): void {
    this.selectedImage1 = null;
    
    // Reopen share modal if it was open before
    if (this.wasShareModalOpen && this.shareModalTemplate) {
      // Small delay to ensure carousel is fully closed
      setTimeout(() => {
        this.modalRef = this.modalService.show(this.shareModalTemplate, {
          backdrop: "static",
          animated: true,
        });
        this.wasShareModalOpen = false;
      }, 150);
    }
  }

  singleimagevidshows(datas, template: TemplateRef<any>) {
    this.modalOpenFlag = true
    this.singleimagedata = datas;
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
    });
  }

  tyu() {
    this.modalRef.hide()
    setTimeout(() => {
      window.scrollTo(0, this.scrollValue.windowScroll);
      this.modalOpenFlag = false
    }, 1000);
  }


  closeSharePage(): void {
    this.modalRef.hide();
    this.isShareModalOpen = false;
    this.sharePost = {}; // Reset entire sharePost object to empty state
    setTimeout(() => {
      this.linkTitle = null
      this.linkImage = null
      this.linkDescription = null
      this.linkURL = null
      CustomValidator.count1 = 0
      CustomValidator.count = 0
      CustomValidator.stoppingCount = undefined
    }, 600);
    this.postTypeForm.get('postType').setValue('Everyone')

  }

  sdf() {
    this.modalRef.hide();
    setTimeout(() => {
      this.linkTitle = null
      this.linkImage = null
      this.linkDescription = null
      this.linkURL = null
      CustomValidator.count1 = 0
      CustomValidator.count = 0
      CustomValidator.stoppingCount = undefined
    }, 600);
  }

  sharePostPage(): void {
    let postEntityId = "";
    if (this.Commomdatass === "USER") {
      postEntityId = this.userId;
    } else if (this.Commomdatass === "COMMUNITY") {
      postEntityId = this.communityid;
    } else if (this.Commomdatass === "BUSINESS") {
      postEntityId = this.businessId;
    } else if (this.Commomdatass === "NETWORK") {
      postEntityId = this.networkId;
    } else if (this.Commomdatass === "TEAM") {
      postEntityId = this.teamId;
    }
    let postEntityType = this.Commomdatass;
    // Non-admins share a business post as themselves: the share is saved as a
    // USER share on their own feed (name-only header, no "▶ Business"), never
    // attributed to the business. Backend enforces the same rule (B0116).
    if (this.Commomdatass === "BUSINESS" && !this.showPostTool()) {
      postEntityType = "USER";
      postEntityId = this.userId;
    }

    if (this.sharePost.postId == "SHARE") {
      this.sharePost.postId = this.sharePost.sourcePostId;
    } else {
      this.sharePost.postId = this.sharePost.postId;
    }

    let datas = {
      postType: "SHARE",
      sourcePostId: this.sharePost.postId,
      postContent: this.sharePost.thoughts,
      postEntity: postEntityType,
      postEntityId: postEntityId,
      postedBy: localStorage.getItem("userId"),
      postPrivacyEntities: this.tempcheckedList,
      postPrivacy: this.postPrivacy,
    };
    this.util.startLoader();
    this.api.create("post/create", datas).subscribe((res) => {
      if (res && res.code && res.code !== '00000') {
        this.util.stopLoader();
        this.modalRef.hide();
        this.isShareModalOpen = false;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.message || 'You are not allowed to share on this page.',
          confirmButtonText: `ok`,
        });
        return;
      }
      setTimeout(() => {
      }, 1000);
      this.selectedEntities = []
      // Clear the selected-recipient ids like the own-post save does. Leaving them
      // here made the next Edit on this share push the same ids again, so the edit
      // saved every recipient twice.
      this.checkedList = [];
      this.tempcheckedList = [];
      this.util.stopLoader();
      this.modalRef.hide();
      this.isShareModalOpen = false;
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Post shared successfully",
        showConfirmButton: false,
        timer: 2000,
      });
      // A retargeted share (non-admin on a business page → USER share) does not
      // belong to the feed on screen, so it must not be pushed into it locally.
      if (datas.postEntity === this.Commomdatass) {
        res.edit = false;
        this.localPushData(res);
      // Bump the original post's share count so "N share(s)" updates without a reload.
      const sharedCards = new Set<any>((this.userData || []).filter((p: any) => p.postId === datas.sourcePostId));
      if (this.shareSourceCard) {
        sharedCards.add(this.shareSourceCard);
      }
      sharedCards.forEach((p: any) => {
        p.sharedCount = (p.sharedCount || 0) + 1;
      });
      this.shareSourceCard = null;
      }
      // this.userbadges.profileStatus();
      this.sharePost.thoughts = "";


    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while processing your request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });
  }

  share(post: any, template?: TemplateRef<any>) {
    this.checkedList = [];
    this.tempcheckedList = [];
    this.postPrivacy = "Everyone";
    this.privacyValue = 'Everyone'
    this.isShareModalOpen = true;
    this.shareSourceCard = post;

    // Store the template reference for reopening after carousel
    if (template) {
      this.shareModalTemplate = template;
    }

    this.modalRef = this.modalService.show(template, {
      backdrop: "static",
      animated: true,
    });
    if (post.medias == null) {
      post.medias = [];
    }
    
    if(!post.postContent){
      post.postContent = '    ';
    }

    // Set sharePost based on post type - only assign once
    if (post.postType == "SHARE" && post.shareduser && post.shareduser[0]) {
      this.sharePost = post.shareduser[0];
    } else {
      this.sharePost = post;
    }

    // `profName` / `profPhoto` are the identity of the person about to share, not the
    // source post's. The business branch kept below used to overwrite them with the
    // business, which showed the business as the author of the share and leaked into the
    // create-post box and the other modals that read the same two fields. The business
    // name and logo the preview needs are already on the post from addBusinessDataToPost
    // and addBusinessDataToSharedPost, so nothing has to be fetched here.
    // // Handle business logo for share modal
    // const postToCheck = post.postType == "SHARE" && post.shareduser && post.shareduser[0] ? post.shareduser[0] : post;
    // if (postToCheck && postToCheck.postEntity === 'BUSINESS' && postToCheck.postEntityId) {
    //   this.loadBusinessDetailsForShare(postToCheck.postEntityId);
    // } else {
    //   // Reset to user profile for non-business posts
    //   this.resetToUserProfile();
    // }
    this.resetToUserProfile();
  }

  welcomeShare(post: any, template?: TemplateRef<any>) {
    this.isShareModalOpen = true;
    // Store the template reference for reopening after carousel
    if (template) {
      this.shareModalTemplate = template;
    }

    this.modalRef = this.modalService.show(template, {
      backdrop: "static",
      animated: true,
    });
    if (post.medias == null) {
      post.medias = [];
    }
    // Set sharePost based on post type - only assign once
    if (post.postType == "SHARE" && post.shareduser && post.shareduser[0]) {
      this.sharePost = post.shareduser[0];
    } else {
      this.sharePost = post;
    }

    // `profName` / `profPhoto` are the identity of the person about to share, not the
    // source post's. The business branch kept below used to overwrite them with the
    // business, which showed the business as the author of the share and leaked into the
    // create-post box and the other modals that read the same two fields. The business
    // name and logo the preview needs are already on the post from addBusinessDataToPost
    // and addBusinessDataToSharedPost, so nothing has to be fetched here.
    // // Handle business logo for share modal
    // const postToCheck = post.postType == "SHARE" && post.shareduser && post.shareduser[0] ? post.shareduser[0] : post;
    // if (postToCheck && postToCheck.postEntity === 'BUSINESS' && postToCheck.postEntityId) {
    //   this.loadBusinessDetailsForShare(postToCheck.postEntityId);
    // } else {
    //   // Reset to user profile for non-business posts
    //   this.resetToUserProfile();
    // }
    this.resetToUserProfile();
  }

  // Superseded by the comment in share() / welcomeShare() above: this wrote the business
  // into `profName` / `profPhoto`, which are the sharer's identity, not the source post's.
  // Kept for reference rather than deleted.
  // loadBusinessDetailsForShare(businessId: string): void {
  //   let datas: any = {};
  //   datas.businessId = businessId;
  //   datas.userId = localStorage.getItem("userId");
  //
  //   this.api.create("business/check/admin", datas).subscribe((res) => {
  //     let img = "assets/images/gallery/company.png";
  //     if (res.businessLogo != null) {
  //       img = AppSettings.photoUrl + res.businessLogo;
  //     }
  //
  //     this.profName = res.businessName;
  //     this.profPhoto = img;
  //
  //     // Also update the sharePost object to ensure the business logo is displayed in the share modal
  //     if (this.sharePost) {
  //       // Set the full URL for business logo, matching the pattern used elsewhere in the codebase
  //       this.sharePost.photo = img;
  //       this.sharePost.userName = res.businessName;
  //     }
  //   }, err => {
  //     // On error, fall back to user profile
  //     this.resetToUserProfile();
  //   });
  // }

  resetToUserProfile(): void {
    // Use profileitems if available, otherwise fall back to loginUser
    const userProfile = this.profileitems || this.loginUser;
    if (userProfile) {
      this.profName = userProfile.firstName + " " + userProfile.lastName;
      if (userProfile.photo && userProfile.photo != null) {
        if (userProfile.photo.startsWith('http://') || userProfile.photo.startsWith('https://')) {
          this.profPhoto = userProfile.photo;
        } else {
          this.profPhoto = AppSettings.photoUrl + userProfile.photo;
        }
      } else {
        this.profPhoto = null;
      }
    }
  }


  adjustHeight(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = "auto"; // Reset height
    textarea.style.height = textarea.scrollHeight + "px"; // Set height based on content
  }


  comment(i) {
    this.sharecmd = "";
    this.userData.forEach((element) => {
      element.cmd = false;
    });
    this.userData[i].cmd = true;
  }

  editingCommentId: string | null = null;
  editingCommentText = "";

  startEditComment(cmd: any) {
    this.editingCommentId = cmd.commentId;
    // Comments render via [innerHtml]; edit the plain text.
    this.editingCommentText = (cmd.comment || "").replace(/<br\s*\/?>/gi, "\n").replace(/<[^>]*>/g, "");
  }

  cancelEditComment() {
    this.editingCommentId = null;
    this.editingCommentText = "";
  }

  saveEditComment(post: any, cmd: any) {
    const text = (this.editingCommentText || "").trim();
    if (!text || text.length > 500) {
      return;
    }
    this.util.startLoader();
    const body = {
      postId: post.postId,
      commentId: cmd.commentId,
      comment: text,
    };
    this.api.create("post/edit/comments", body).subscribe((res) => {
      this.util.stopLoader();
      if (res && res.code === "00000") {
        cmd.comment = res.data?.comment?.comment ?? text;
        this.cancelEditComment();
      } else {
        Swal.fire({ icon: "error", title: "Oops...", text: res?.message || "Unable to update the comment. Please try again." });
      }
    }, () => {
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong while processing your request. Please, try again later.",
      });
    });
  }

  deleteComment(post: any, cmd: any) {
    Swal.fire({
      title: "Delete comment?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      this.util.startLoader();
      const body = {
        userId: localStorage.getItem("userId"),
        commentId: cmd.commentId,
        postId: post.postId,
      };
      this.api.create("post/remove/comments", body).subscribe((res) => {
        this.util.stopLoader();
        if (res && res.code === "00000") {
          if (Array.isArray(res.data?.comments)) {
            // Server returns the remaining (up to 3) comments, so the list refills itself.
            res.data.comments.forEach((c: any) => {
              if (c.photo && !c.photo.startsWith('http://') && !c.photo.startsWith('https://')) {
                c.photo = AppSettings.photoUrl + c.photo;
              }
            });
            // Never trust the list to exclude the deleted comment (stale/cached response).
            post.comments = res.data.comments.filter((c: any) => c.commentId !== cmd.commentId);
          } else {
            post.comments = (post.comments || []).filter((c: any) => c.commentId !== cmd.commentId);
          }
          post.commentsCount = Math.max(
            res.data?.commentsCount ?? ((post.commentsCount || 1) - 1), 0);
          // Also update the matching card in userData in case `post` is a different object reference.
          const card = this.userData?.find((p: any) => p.postId == post.postId);
          if (card && card !== post) {
            card.comments = post.comments;
            card.commentsCount = post.commentsCount;
          }
          if (this.editingCommentId === cmd.commentId) {
            this.cancelEditComment();
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res?.message || "Unable to delete the comment. Please try again.",
          });
        }
      }, () => {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong processing your request. Please, try again later.",
        });
      });
    });
  }

  cmdpage(data, methodname, i, removepostId) {

    if (methodname == "comment") {
      let postcont = null;
      if (data.cmd) {
        postcont = data.cmd.trim();

      }
      let datas = {
        userId: localStorage.getItem("userId"),
        postId: data.postId,
        comment: postcont,

      };

      if (postcont != null && postcont.length > 0) {
        this.util.startLoader();
        this.api.create("post/add/comments", datas).subscribe((res) => {
          this.util.stopLoader();
          if (res && res.code === "00000" && res.data && res.data.comment) {
            data.cmd = null;
            setTimeout(() => {
              const textareas = document.querySelectorAll('.comment-area') as NodeListOf<HTMLTextAreaElement>;
              if (textareas[i]) {
                textareas[i].value = ''; // Clear input
                textareas[i].style.height = "40px"; // Reset height
              }
            }, 0);
            const cmntList = res.data.comment;
            this.indexforSearchafterKey = [];
            let e1 = cmntList;

            if (e1.photo) {
              // Prevent double URL prepending
              if (!e1.photo.startsWith('http://') && !e1.photo.startsWith('https://')) {
                e1.photo = AppSettings.photoUrl + e1.photo;
              }
            }

            if (
              this.userData[i].comments &&
              this.userData[i].comments != null &&
              this.userData[i].comments != ""
            ) {
            } else {
              this.userData[i].comments = [];
            }
            let index = this.userData[i].comments.findIndex(
              (item: any) => item.commentId === e1.commentId
            );
            if (index < 0) {
              this.userData[i].comments.unshift(e1);
            } else {
              Object.assign(this.userData[i].comments[index], e1);
            }
            if (this.userData[i].comments.length > 3) {
              this.userData[i].comments.splice(
                3,
                this.userData[i].comments.length - 3
              );
            }
            if (res.data && res.data.commentsCount) {
              this.userData[i].commentsCount = res.data.commentsCount;
            } else {
              this.userData[i].commentsCount = 0;
            }

            this.userData[i].c = {
              offSet: 0,
              pageCount: 3,
            };

          }
        }, err => {
          this.util.stopLoader();
          if (err.status == 500) {
            this.util.stopLoader();
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: 'Something went wrong while processing your request. Please, try again later.',
              showDenyButton: false,
              confirmButtonText: `ok`,
            })
          }
        });
      }
    } else if (methodname == "remove") {
      let remove = {
        userId: localStorage.getItem("userId"),
        commentId: data.commentId,
        postId: removepostId.postId,
      };
      this.util.startLoader();
      this.api.create("post/remove/comments", remove).subscribe((res) => {

        this.sharecmd = "";
        if (res.data.comments) {
          res.data.comments.forEach((e1) => {
            this.api
              .query("user/connection/" + e1.userId)
              .subscribe((userres) => {
                this.util.stopLoader();
                // Prevent double URL prepending
                if (userres.photo && !userres.photo.startsWith('http://') && !userres.photo.startsWith('https://')) {
                  e1.photo = AppSettings.photoUrl + userres.photo;
                } else {
                  e1.photo = userres.photo;
                }
              }, err => {
                this.util.stopLoader();
              });
            this.userData[i].comments = res.data.comments;
            this.userData = this.userData;
          });
        } else {
          this.util.stopLoader();
        }
      }, err => {
        this.util.stopLoader();
        if (err.status == 500) {
          this.util.stopLoader();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: 'Something went wrong processing your request. Please, try again later.',
            showDenyButton: false,
            confirmButtonText: `ok`,
          })
        }
      });
    }
  }


  // Post ids with a like/unlike request in flight. The handler flips the liked flag
  // optimistically, so the template swaps to the opposite button straight away and a fast
  // second click used to fire the opposite endpoint while the first call was still open.
  // Repeated clicking sent a burst of interleaved like and unlike calls for one user and
  // post, which is what produced duplicate entries.
  private likeInFlight = new Set<any>();

  like(data, i, flag) {
    const postId = data?.postId;
    if (postId == null || this.likeInFlight.has(postId)) {
      return;
    }

    // The feed renders `movedatafirst(userData)`, which de-duplicates by post id and, when
    // a notification redirect is active, moves that post to the front. So the index `i`
    // belongs to the rendered array, not to `userData`, and the two only line up when
    // neither of those applies. Resolve the record by id instead; `i` is kept in the
    // signature so the template's call sites stay as they are.
    // Searched from the end, because `movedatafirst` keeps the LAST record for an id, so
    // that is the object the template is bound to. Taking the first match would update a
    // stale duplicate and leave the button unchanged on screen.
    let post = data;
    if (this.userData && this.userData.length) {
      for (let idx = this.userData.length - 1; idx >= 0; idx--) {
        if (this.userData[idx] && this.userData[idx].postId === postId) {
          post = this.userData[idx];
          break;
        }
      }
    }
    if (!post) {
      return;
    }

    let datas = {
      userId: localStorage.getItem("userId"),
      postId: postId,
    };
    const previousLikedStatus = post.userLikedStatus;
    post.userLikedStatus = flag;
    let url = "post/like";
    if (!flag) {
      url = "post/unlike";
    }

    this.likeInFlight.add(postId);
    this.util.startLoader();
    this.api.create(url, datas, 'Unable to retrieve post').subscribe((res) => {
      this.likeInFlight.delete(postId);
      this.util.stopLoader();

      if (res.code == "00000") {
        post.userLikedStatus = flag;
        if (res.data && res.data.likesCount) {
          post.likesCount = res.data.likesCount;
        } else {
          post.likesCount = 0;
        }
        this.userData = this.userData;
      }
    }, err => {
      // Put the button back the way it was, so a failed call does not leave the post
      // showing a state the server never recorded.
      this.likeInFlight.delete(postId);
      post.userLikedStatus = previousLikedStatus;
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while processing your request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });
  }

  save() {
    this.counts = 0;
    let postEntityId;
    if (this.Commomdatass === "USER") {
      postEntityId = this.userId;
    } else if (this.Commomdatass === "COMMUNITY") {
      postEntityId = this.communityid;
    } else if (this.Commomdatass === "BUSINESS") {
      postEntityId = this.businessId;
    } else if (this.Commomdatass === "NETWORK") {
      postEntityId = this.networkId;
    } else if (this.Commomdatass === "TEAM") {
      postEntityId = this.teamId;
    }

    let postcont = $("#summessage").summernote("code").replace(/&nbsp;|<\/?[^>]+(>|$)/g, "").trim();
    const substring = "<img";
    if (this.urlLinkDetctForm.controls.snippedLinkText.errors?.maxchar) {
      return;
    }
    if (postcont.length > 0 && this.commanddata.includes(substring)) {
      this.commanddata = this.commanddata.replace(/<img[^>]*>/g, '');
    } else if (postcont.length == 0 && this.uploadFiles.length == 0) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Empty Post',
        text: "This post appears to be blank. Please write something or attach a link or a photo to post.",

        allowOutsideClick: false,
        showConfirmButton: false,
        timer: 3500
      })
      $("#summessage").summernote("reset");
      $("#SummernoteText").summernote("reset");
    }


    let datas = {
      postType: "OWN",
      sourcePostId: "",
      postContent: this.commanddata,
      postEntity: this.Commomdatass,
      postEntityId: postEntityId,
      postedBy: localStorage.getItem("userId"),
      postPrivacyEntities: this.tempcheckedList,
      postPrivacy: this.postPrivacy,
    };


    if (postcont.length > 0 && !this.commanddata.includes(substring) && this.uploadFiles.length == 0) {
      this.util.startLoader();
      this.api.create("post/create", datas).subscribe((res) => {
        if (res.code == '00000') {
          let timeout: any = undefined;
          this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe((val) => {
            timeout = val;
          });
          this.streamData = [];

          this.util.stopLoader();
          this.modalRef.hide()
          // Confirm the save straight away. The feed insert below is deferred by a
          // 1000 ms timeout, so without this the composer just closes and nothing
          // tells the user the post went through.
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Post created successfully",
            showConfirmButton: false,
            timer: 2000,
          });
          this.selectedEntities = []
          this.startCount = 0;
          this.showWelcomePost = false;
          this.currentPageCount = 1;
          this.commanddata = "";
          this.checkedList = [];
          this.tempcheckedList = [];
          this.postPrivacy = "Everyone";
          this.privacyValue = 'Everyone'
          setTimeout(() => {
            res.edit = false;
            this.localPushData(res)
            // this.userbadges.profileStatus();
          }, 1000);
        }
      }, err => {
        this.util.stopLoader();
        if (err.status == 500) {
          this.util.stopLoader();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: 'Something went wrong while processing your request. Please, try again later.',
            showDenyButton: false,
            confirmButtonText: `ok`,
          })
        }
      });
    } else if ((postcont.length == 0 && this.uploadFiles.length != 0)) {
      let datas = {
        postType: "OWN",
        sourcePostId: "",
        postContent: this.commanddata,
        postEntity: this.Commomdatass,
        postEntityId: postEntityId,
        postedBy: localStorage.getItem("userId"),
        postPrivacyEntities: this.tempcheckedList,
        postPrivacy: this.postPrivacy,
      };
      this.savewithattachment('new', datas, null, null)
    }
    else if (postcont.length > 0 && !this.commanddata.includes(substring) && this.uploadFiles.length != 0) {

      let content = $("#summessage")
        .summernote("code")
        .replace(/&nbsp;|<\/?[^>]+(>|$)/g, "")
        .trim();
      let postcont = $("#summessage").summernote("code").replace(/&nbsp;|<\/?[^>]+(>|$)/g, "").trim();
      postcont = postcont.replace(/<img[^>]*>/g, '');
      let datas = {
        postType: "OWN",
        sourcePostId: "",
        postContent: postcont,
        postEntity: this.Commomdatass,
        postEntityId: postEntityId,
        postedBy: localStorage.getItem("userId"),
        postPrivacyEntities: this.tempcheckedList,
        postPrivacy: this.postPrivacy,
      };
      this.savewithattachment('new', datas, null, null)
    }
  }



  getpostdatas() {
    this.afterKey = undefined;
    this.commonPost_getpostdatas(null, null);
  }


  sortBy(list: Array<any>, prop: string) {
    return list;
    // return list.sort((a, b) => (b[prop] > a[prop] ? 1 : -1));
  }
  stopscroll: boolean = false

  commonPost_getpostdatas(startIndex, pageCount) {
    this.postLoading = true;
    this.loadApicall = true;

    let postEntityId;

    switch (this.Commomdatass) {
      case "USER":
        postEntityId = this.userId;
        break;
      case "COMMUNITY":
        postEntityId = this.communityid;
        break;
      case "BUSINESS":
        postEntityId = this.businessId;
        break;
      case "NETWORK":
        postEntityId = this.networkId;
        break;
      case "TEAM":
        postEntityId = this.teamId;
        break;
      default:
        postEntityId = null;
    }

    let apiName = this.ownerView !== undefined ? "post/owner" : "post/query";
    const datas: any = {
      postEntity: this.Commomdatass,
      postId: this.postId,
      searchAfterKey: this.afterKey,
      limit: 10,
      page: {
        pageSize: 10,
      },
    };

    if (this.ownerView !== undefined) {
      datas.userId = postEntityId;
    } else {
      datas.postEntityId = postEntityId;
    }

    if (this.afterKey === undefined || (this.afterKey !== null && this.afterKey.length > 0)) {
      datas.searchAfterKey = this.afterKey;
    } else {
      this.postLoading = false;
      this.loadApicall = false;
      return;
    }

    if (startIndex !== null) {
      datas.page.offSet = startIndex;
      datas.page.pageCount = pageCount;
      datas.page.pageSize = 10;
    } else {
      datas.page.offSet = 0;
      datas.page.pageSize = 10;
      this.userData = []; // Clear existing data before loading new posts
    }

    this.api.create(apiName, datas).subscribe(
      (response) => {
        this.postLoading = false;
        this.loadApicall = false;
        this.shareData = [];
        this.commentData = [];

        // Notification deep link (?postId=) on the first page (no searchAfterKey — the
        // same test PostService uses): for the USER feed the server returns the post as
        // `notifiedPost` whenever it still exists (other entity feeds never send it, so
        // they are excluded). Deleting a post hard-deletes it, so a missing
        // `notifiedPost` means it is gone — say so instead of silently showing the feed.
        if (this.postId && this.Commomdatass === "USER" && apiName === "post/query"
          && datas.searchAfterKey == null && response?.data && !response.data.notifiedPost) {
          this.postId = undefined;
          Swal.fire({
            position: "center",
            icon: "info",
            title: "This post has been deleted or is no longer available.",
            showConfirmButton: false,
            timer: 2500,
          });
        }

        if (response && response.data && response.data.postList) {
          this.afterKey = response.data.searchAfterKey || [];
          this.stopscroll = response.data.postList.length === 0 || response.data.postList.length < 9;
          let sortedPosts = response.data.notifiedPost
            ? [response.data.notifiedPost, ...response.data.postList]
            : this.sortBy(response.data.postList, "postedOn");
          // this.userbadges.profileStatus();
          // Process and filter new posts

          if (!Array.isArray(this.userData)) {
            this.userData = [];
          }
          const newPosts = sortedPosts.filter(post =>
            !this.userData.some(existingPost => existingPost.postId === post.postId)
          );

          // Append the raw batch FIRST, in server order, so the feed renders
          // immediately even when the per-post enrichment calls
          // (addUserDataToPost / addCommunityDataToPost / addNetworkToPost /
          // addTeamsToPost) fail or return falsy details. Each enrichment path
          // pushes its enriched postViewData afterwards and calls
          // `removeDuplicates(userData, "postId")`, which keeps the first-seen
          // position with the last value, so the enriched record lands in the
          // raw record's slot.
          //
          // This MUST run before processPostElement(): when HttpCacheInterceptor
          // serves `user/connection/{id}` from cache it emits synchronously, so
          // the enriched post (e.g. the Gigsumo welcome post) would otherwise be
          // pushed into a still-empty userData and jump above the newest post —
          // which is what happened after Profile -> Home within the cache TTL.
          this.userData = [...this.userData, ...newPosts];
          this.userData = this.sortData(this.userData);
          this.contentLoaded = true;

          newPosts.forEach((element) => {
            this.processPostElement(element);
          });
        } else {
          this.stopscroll = true;
        }
      },
      (err) => {
        this.postLoading = false;
        this.loadApicall = false;
        this.util.stopLoader();
        if (err.status === 500) {
          this.util.stopLoader();
        }
      }
    );
  }

  showPostTool(): boolean {
    if (this.businessPage) {
      return (this.businessData.isSuperAdmin == 'true' || this.businessData.isAdmin == 'true') && this.businessPage == true && this.businessData.viewingAsMember != 'true' ? true : false
    } else {
      return (this.postView == 'COMMUNITY')
        || (this.postView === 'GIG_HOME_PAGE')
        || (this.postView === 'NETWORK')
        || (this.postView === 'TEAM')
        || (this.postView === 'postList') ? true : false;
    }
  }

  private stripInlineFontStyles(html: string): string {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.body.querySelectorAll<HTMLElement>('[style]').forEach((el) => {
        el.style.removeProperty('font-family');
        el.style.removeProperty('font-size');
        if (!el.getAttribute('style')) {
          el.removeAttribute('style');
        }
      });
      return doc.body.innerHTML;
    } catch {
      return html;
    }
  }

  processPostElement(element) {
    console.error('post element in  ----> ', element);
    if (element.medias) {
      element.medias.forEach((e1) => {
        if (e1.url !== null) {
          var path = AppSettings.photoUrl + e1.fileId;
          e1.url = path;
        }
      });
    }

    if (element.comments) {
      element.comments.forEach((e1: any) => {
        // Prevent double URL prepending
        if (e1.photo) {
          if (!e1.photo.startsWith('http://') && !e1.photo.startsWith('https://')) {
            e1.photo = AppSettings.photoUrl + e1.photo;
          }
        } else {
          e1.photo = null;
        }
      });
    }

    if (!element.postContent) {
      element.postContent = null;
    } else if (element.isPlatformPost && element.postId !== 'WELCOME001') {
      // Platform/instructional posts (e.g. "How to create your first Candidate?")
      // are backend-authored HTML rendered via [innerHtml]. Their inline
      // font-family/font-size - even with !important - still beats the
      // `.platform-html-content` stylesheet override in the .scss (an inline
      // !important always wins over a stylesheet !important), so the font
      // drifts from the Gigsumo welcome card it's meant to match. Stripping
      // just those two inline properties lets the stylesheet rule take over.
      element.postContent = this.stripInlineFontStyles(element.postContent);
    }

    var postData = {
      status: element.status,
      isWelcomePost: element.isWelcomePost,
      isPlatformPost: element.isPlatformPost,
      userId: element.userId,
      connected: element.connected,
      postId: element.postId,
      postType: element.postType,
      sourcePostId: element.postId,
      postContent: element.postContent,
      postEntity: element.postEntity,
      postEntityId: element.postEntityId,
      postedBy: element.postedBy,
      postedByType: element.postedByType,
      postedOn: element.postedOn,
      likesCount: element.likesCount,
      commentsCount: element.commentsCount,
      sharedCount: element.sharedCount,
      postPrivacy: element.postPrivacy,
      postPrivacyEntities: element.postPrivacyEntities,
      hashTags: element.hashTags,
      medias: element.medias,
      likes: element.likes,
      shares: element.shares,
      page: element.page,
      code: element.code,
      message: element.message,
      comments: element.comments,
      isGlobalCommunityPost: element.isGlobalCommunityPost,
      user: element.user,
      visible: false,
      userLikedStatus: element.userLikedStatus,
      postedByUserData: element.postedByUserData,
    };

    console.error('post postviewdata in  ----> ', element);

    if (element.isPlatformPost) {
      // Platform ("Gigsumo") post — stamp the fixed Gigsumo identity
      // SYNCHRONOUSLY on both the raw `element` (which the feed fetch handler
      // pushes into `userData` up-front — same object reference) and the
      // enriched `postData`. The header name branch renders only when
      // `postEntity === 'USER' && isPlatformPost` and prints `userName`; those
      // were previously set only inside the async `user/connection` callback,
      // so if that lost the dedupe race (or the lookup was slow/failed) the raw
      // record rendered with no `postEntity`/`userName` and the "Gigsumo" name
      // vanished — intermittently, e.g. after re-entering the Activity Feed.
      // Setting them synchronously makes the name/avatar render regardless.
      element.postEntity = "USER";
      element.userName = "Gigsumo";
      element.firstName = "Gigsumo";
      element.lastName = "User";
      element.photo = 'assets/icon/Sumoface_final.png';
      const pd: any = postData;
      pd.postEntity = "USER";
      pd.userName = "Gigsumo";
      pd.firstName = "Gigsumo";
      pd.lastName = "User";
      pd.photo = 'assets/icon/Sumoface_final.png';
      this.addUserDataToPost(element, postData, element.postEntityId);
      // Fully handled — skip the entity switch (a platform post is always a
      // Gigsumo USER post, so routing it through the switch again would just
      // fire a redundant duplicate `addUserDataToPost` call).
      return;
    }

    this.addPrivacyEntitiesToPost(element, postData);

    switch (element.postEntity) {
      case "USER":
        this.addUserDataToPost(element, postData, element.postEntityId);
        break;
      case "BUSINESS":
        this.addBusinessDataToPost(element, postData, element.postEntityId);
        break;
      case "COMMUNITY":
        this.addCommunityDataToPost(element, postData, element.postEntityId);
        break;
      case "NETWORK":
        this.addNetworkToPost(element, postData, element.postEntityId);
        break;
      case "TEAM":
        this.addTeamsToPost(element, postData, element.postEntityId);
        break;
    }
  }

  subscribeGigSumoCommunity() {
    this.gigCommunitySubscribed = true
    var data: any = {}
    data.userId = localStorage.getItem('userId')
    data.userType = localStorage.getItem('userType')
    this.api.create('community/addToGigsumoCommunity', data).subscribe(res => {
      if (res.code == '00000') {
        this.gigCommunitySubscribed = true;
        this.globalCommunity.joined = true;
      }
      else {
        this.gigCommunitySubscribed = false;
        this.globalCommunity.joined = false;

      }
    })
  }

  addSharedPostData(sourcePost, postViewData): void {
    let shareData = [];
    this.api
      .query("post/query/" + sourcePost.sourcePostId)
      .subscribe((shareres) => {
        //this.util.stopLoader()
        let shareResponse = shareres[0];
        if (
          shareResponse != undefined &&
          shareResponse.medias != null &&
          shareResponse.medias != undefined
        ) {
          shareResponse.medias.forEach((e1) => {
            if (e1.url != null) {
              e1.url = AppSettings.photoUrl + e1.url;
            } else {

            }
          });


          let shareViewData = {

            status: shareResponse.status,
            userId: shareResponse.userId,
            connected: shareResponse.connected,
            postId: shareResponse.postId,
            postType: shareResponse.postType,
            sourcePostId: shareResponse.postId,
            postContent: shareResponse.postContent,
            postEntity: shareResponse.postEntity,
            postEntityId: shareResponse.postEntityId,
            postedBy: shareResponse.postedBy,
            postedByType: shareResponse.postedByType,
            postedOn: shareResponse.postedOn,

            likesCount: shareResponse.likesCount,
            commentsCount: shareResponse.commentsCount,
            sharedCount: shareResponse.sharedCount,
            postPrivacyEntities: shareResponse.postPrivacyEntities,
            postPrivacy: shareResponse.postPrivacy,
            hashTags: shareResponse.hashTags,
            medias: shareResponse.medias,
            likes: shareResponse.likes,
            shares: shareResponse.shares,
            page: shareResponse.page,
            code: shareResponse.code,
            message: shareResponse.message,
            comments: shareResponse.comments,
            visible: false,
            postedByUserData: shareResponse.postedByUserData
          };

          if (shareResponse.postEntity === "USER") {
            this.addUserDataToSharedPost(
              postViewData,
              shareViewData,
              shareResponse.postEntityId,

            );
          } else if (shareResponse.postEntity === "BUSINESS") {
            this.addBusinessDataToSharedPost(
              postViewData,
              shareViewData,
              shareResponse.postEntityId,

            );
          } else if (shareResponse.postEntity === "COMMUNITY") {
            this.addCommunityDataToSharedPost(
              postViewData,
              shareViewData,
              shareResponse.postEntityId,

            );
          } else if (shareResponse.postEntity === "NETWORK") {
            this.addNetworkDataToSharedPost(
              postViewData,
              shareViewData,
              shareResponse.postEntityId,

            );
          } else if (shareResponse.postEntity === "TEAM") {
            this.addTeamDataToSharedPost(
              postViewData,
              shareViewData,
              shareResponse.postEntityId,

            );
          }
        }
        // post/query returned nothing: the original was deleted.
        else if (shareResponse == undefined) {
          this.addUnavailableSharedPost(sourcePost, postViewData);
        }
      }, err => {
        this.util.stopLoader();
      });
  }

  post = { cmd: '' };
  isInvalid: boolean = false;

  validateComment() {

    if (!this.post.cmd || this.post.cmd.length > 500) {
      this.isInvalid = true;
    } else {
      this.isInvalid = false;
    }
  }
  // trackBy for the feed *ngFor. movedatafirst() returns a fresh (deduped)
  // array every change detection; without a stable key Angular would rebuild
  // every post's DOM each tick.
  trackByPostId(_index: number, post: any): any {
    return post?.postId ?? _index;
  }

  //notification redirect post should be shown on the top by monisha
  movedatafirst(userData: any[]): any[] {
    if (!userData || userData.length === 0) {
      return userData;
    }

    // De-duplicate by postId before rendering. The feed pushes each post's raw
    // record up-front and enriches it asynchronously; overlapping fetches (e.g.
    // re-opening the Activity Feed while a previous fetch's enrichment calls are
    // still in flight) can leave two records for the same postId. Keeping the
    // LAST occurrence retains the most-enriched copy. This is what caused the
    // Gigsumo welcome posts to render twice. Map preserves first-seen order, so
    // the feed order is unchanged.
    const byId = new Map<any, any>();
    for (const post of userData) {
      byId.set(post?.postId, post);
    }
    const deduped = Array.from(byId.values());

    if (!this.postId) {
      return deduped;
    }

    const filteredPosts = deduped.filter(post => post.postId === this.postId);
    const otherPosts = deduped.filter(post => post.postId !== this.postId);

    return [...filteredPosts, ...otherPosts];
  }



  // Resolves the connection names a Connections-only post was shared with and stamps
  // them on both the raw element (pushed into userData first by the feed fetch) and the
  // enriched clone that replaces it, so the header row renders whichever object is live.
  private addPrivacyEntitiesToPost(element, postViewData): void {
    if (!element || element.postPrivacy !== 'Connections' || !element.postPrivacyEntities?.length) {
      return;
    }
    const body = {
      postId: element.postId,
      postPrivacy: element.postPrivacy,
      postPrivacyEntities: element.postPrivacyEntities
    };
    this.api.create('post/queryPrivacyEntities', body).subscribe((res) => {
      // Dedupe: a post saved while the selection list still held the previous share's
      // ids carries every recipient twice, and the label read "A, B, A, B" until re-saved.
      const names = Array.isArray(res) ? [...new Set<string>(res.map((r: any) => r?.name).filter(Boolean))] : [];
      if (!names.length) return;
      const label = names.join(', ');
      element.privacyEntityNames = names;
      element.privacyEntityLabel = label;
      postViewData.privacyEntityNames = names;
      postViewData.privacyEntityLabel = label;
    }, () => {
      // Lookup failed: the header keeps showing the plain poster name.
    });
  }

  addUserDataToPost(element, postViewData, userId): void {

    this.api.query("user/connection/" + userId).subscribe((userres) => {
      this.util.stopLoader();
      postViewData.userName = userres.firstName + " " + userres.lastName;
      postViewData.photo = userres.photo;
      postViewData.img = userres.photo;
      postViewData.organisation = userres.organisation;
      postViewData.title = userres.title;

      // The post header reads its avatar from `postedByUserData`. A post that was just
      // created or just shared is built from the create response, which carries the new
      // row and no joined poster block, so the author's picture only appeared after a
      // reload swapped the record for a feed one. On a USER post the author is the post
      // entity, so `userres` is that person; fill in only the empty fields, leaving a
      // feed record's own block untouched. Platform posts are skipped — they render a
      // fixed Gigsumo avatar through their own branch.
      if (!postViewData.isPlatformPost) {
        const poster: any = postViewData.postedByUserData || {};
        if (!poster.photo && userres.photo) {
          poster.photo = userres.photo;
        }
        if (!poster.firstName) {
          poster.firstName = userres.firstName;
        }
        if (!poster.lastName) {
          poster.lastName = userres.lastName;
        }
        if (!poster.fullName) {
          poster.fullName = postViewData.userName;
        }
        postViewData.postedByUserData = poster;
      }

      if (postViewData.isPlatformPost) {
        postViewData.userName = "Gigsumo";
        postViewData.firstName = "Gigsumo";
        postViewData.lastName = "User";
        postViewData.photo = 'assets/icon/Sumoface_final.png';
      }

      if (element.postType === "SHARE") {
        this.addSharedPostData(element, postViewData);
      } else {
        if (element.edit) {
          // Replace in place only. localPushData has already moved the edited post to the
          // top; splicing here and then assigning at the same index used to delete the
          // post that followed the edited one.
          let indx = this.userData.findIndex(item => item.postId == element.postId);
          if (indx > -1) {
            this.userData[indx] = postViewData;
          }
        } else {
          this.userData.push(postViewData);
          this.userData = this.removeDuplicates(this.userData, "postId");
          this.userData = this.sortData(this.userData);
        }
      }
      console.error('post element out  ----> ', postViewData);
      console.error('post element out this.userdata  ----> ', this.userData);
    }, err => {
      this.util.stopLoader();
    });
  }






  addBusinessDataToPost(element, postViewData, businessId): void {

    let datas: any = {};
    datas.businessId = businessId;
    datas.userId = localStorage.getItem("userId");

    this.api.create("business/check/admin", datas).subscribe((res) => {
      // ApiService.create rethrows only a known set of statuses (see handleError) and
      // turns anything else into `of(undefined)`, so this success path can run with no
      // response at all. Dereferencing it threw here, and an error thrown in an rxjs
      // `next` handler does not reach the error callback below — so neither path stamped
      // a photo and the header's loading placeholder would never resolve. Treat a missing
      // response as "no logo is coming" and fall through to the company placeholder.
      const details = res || {};
      let img = "assets/images/gallery/company.png";
      if (details.businessLogo != null) {
        img = AppSettings.photoUrl + details.businessLogo;
      }

      postViewData.userName = details.businessName || postViewData.userName;
      postViewData.photo = img;
      postViewData.img = img;
      if (element.postType === "SHARE") {
        this.addSharedPostData(element, postViewData);
      } else {
        if (element.edit) {
          // Replace in place only. localPushData has already moved the edited post to the
          // top; splicing here and then assigning at the same index used to delete the
          // post that followed the edited one.
          let indx = this.userData.findIndex(item => item.postId == element.postId);
          if (indx > -1) {
            this.userData[indx] = postViewData;
          }
        } else {
          this.userData.push(postViewData);
          this.userData = this.removeDuplicates(this.userData, "postId");
          this.userData = this.sortData(this.userData);
        }
      }
      console.error('post element out  ----> ', postViewData);
      console.error('post element out this.userdata  ----> ', this.userData);
    }, err => {
      this.util.stopLoader();
      // When this lookup fails the enriched record is never pushed, so the raw `element`
      // is what stays in userData with no `photo` on it. Stamp the same fallback
      // onProfilePhotoError uses for BUSINESS, otherwise the in-flight avatar placeholder
      // in the header shimmers forever.
      const businessFallbackLogo = "assets/images/gallery/company.png";
      element.photo = element.photo || businessFallbackLogo;
      element.img = element.img || businessFallbackLogo;
      postViewData.photo = postViewData.photo || businessFallbackLogo;
      postViewData.img = postViewData.img || businessFallbackLogo;
      if (err.status == 500) {
        this.util.stopLoader();
      }
    });
  }
  addCommunityDataToPost(element, postViewData, communityId): void {
    // The feed pushes the raw `element` into `userData` up front, so a community post
    // renders before the enriched record arrives — and keeps rendering as the raw record
    // when the lookup below returns no details (community/details/{id} returns nothing
    // for a non-member, or the request fails and the cached subject never emits again).
    // This placeholder used to be stamped on both objects synchronously, which painted
    // the Gigsumo brand mark from the first frame until the lookup answered — a full
    // network round trip on a fresh login, since the cache is cleared at logout. The
    // logo now stays unset while the lookup is in flight and the header renders a
    // neutral loading circle; the placeholder is applied only on the paths below where
    // no real logo is ever coming, which is what it was added for.
    const fallbackLogo = "assets/icon/Sumoface_final.png";

    // The service swallows a failed fetch, so its subject can sit at null indefinitely
    // and the loading circle would never resolve. Give the lookup a grace period, then
    // fall back to the placeholder — the state this function used to start in.
    const logoGraceMs = 6000;
    setTimeout(() => {
      if (!postViewData.logo) {
        postViewData.logo = fallbackLogo;
        postViewData.img = fallbackLogo;
      }
      if (!element.logo) {
        element.logo = fallbackLogo;
      }
    }, logoGraceMs);

    // The cached subject can emit more than once now that it refreshes itself on a
    // timer, which is how a viewer who is not the editor picks up a new logo. The
    // enrichment below must still run exactly once — re-running it would re-push the
    // post and re-request its shared block — so later emissions only repaint.
    let communityPostEnriched = false;

    this.gigsumoService.getCommunityDetails(communityId).subscribe(
      (communityDetails) => {
        if (!communityDetails) return;

        // A community with no logo would otherwise build a `<photoUrl>null` src and
        // 404 its way into the error handler; guard it the way community-card does.
        const communityLogo = communityDetails.logo
          ? AppSettings.photoUrl + communityDetails.logo
          : fallbackLogo;

        if (communityPostEnriched) {
          if (communityDetails.communityName) {
            postViewData.userName = communityDetails.communityName;
          }
          postViewData.logo = communityLogo;
          postViewData.img = communityLogo;
          return;
        }
        communityPostEnriched = true;

        // Applied here rather than inside the timeout below. The timeout exists to defer
        // the feed array push, not these three writes, and deferring them guaranteed at
        // least one painted frame of the placeholder even for a community already in the
        // cache, whose subject replays its value synchronously on subscribe. Writing them
        // now means a cached community paints its real logo and name on the first frame.
        postViewData.userName = communityDetails.communityName;
        postViewData.logo = communityLogo;
        postViewData.img = communityLogo;
        element.userName = element.userName || communityDetails.communityName;
        element.logo = element.logo || communityLogo;

        setTimeout(() => {
          if (element.postType === "SHARE") {
            this.addSharedPostData(element, postViewData);
          } else {
            if (element.edit) {
              // Replace in place only; see addUserDataToPost.
              let indx = this.userData.findIndex((item) => item.postId == element.postId);
              if (indx > -1) {
                this.userData[indx] = postViewData;
              }
            } else {
              this.userData.push(postViewData);
              this.userData = this.removeDuplicates(this.userData, "postId");
              this.userData = this.sortData(this.userData);
            }
          }
        });
        console.error('post element out  ----> ', postViewData);
        console.error('post element out this.userdata  ----> ', this.userData);
      },
      (err) => {
        this.util.stopLoader();
      }
    );

    // Removed 2026-09-23: this used to call addAdminToGlobalCommunity(communityId),
    // which POSTed /community/add/admin from inside the post-rendering loop.
    // Granting admin rights is a membership operation and has no business running
    // here - see the method's removal note below for why it was wrong.

  }

  // Repaints the community avatar/name on posts already rendered in the feed.
  // `community/update` drops the edited community from GigsumoService's cache, so the
  // lookup below misses and refetches. The post objects are mutated in place — no
  // push, dedupe or sort — so the feed's contents and order are left exactly as they
  // were. A post whose community was not edited simply re-reads its cached value.
  refreshCommunityPostAvatars(): void {
    if (!this.userData || !this.userData.length) {
      return;
    }

    const communityIds: any[] = [];
    this.userData.forEach((post: any) => {
      if (post && post.postEntity === "COMMUNITY" && post.postEntityId &&
        communityIds.indexOf(post.postEntityId) === -1) {
        communityIds.push(post.postEntityId);
      }
    });

    communityIds.forEach((communityId) => {
      // The cached subject replays a null before the refetch lands, so wait for the
      // first real value and then complete — nothing is left subscribed.
      this.gigsumoService.getCommunityDetails(communityId)
        .pipe(filter((details: any) => !!details), take(1))
        .subscribe((communityDetails: any) => {
          const communityLogo = communityDetails.logo
            ? AppSettings.photoUrl + communityDetails.logo
            : "assets/icon/Sumoface_final.png";

          this.userData.forEach((post: any) => {
            if (post && post.postEntity === "COMMUNITY" && post.postEntityId === communityId) {
              if (communityDetails.communityName) {
                post.userName = communityDetails.communityName;
              }
              post.logo = communityLogo;
              post.img = communityLogo;
            }
          });
        });
    });
  }

  // Removed 2026-09-23 - addAdminToGlobalCommunity() / `adminAdded`, added by
  // 5dd734584 "add admin called via bussiness post" (2026-01-23). It ran from
  // addCommunityDataToPost(), i.e. once per COMMUNITY post while the feed
  // rendered, and POSTed /community/add/admin with adminType "ADMIN".
  //
  // Three things were wrong with it:
  //
  //  * Scope. The id passed was element.postEntityId - the community that POST
  //    belongs to, not the global community the name promised. Neither this
  //    component nor CommunityService.addAdminInCommunity checks
  //    isGlobalCommunity, so an ADMIN scrolling past any community's post was
  //    silently made an admin OF THAT COMMUNITY.
  //  * Repetition. The `adminAdded` latch compared the response OBJECT to a
  //    string (`res == '00000'`), so it never became true and the call re-fired
  //    for every community post, on every feed load and every tab switch -
  //    ~20 identical requests per page load in QA. It also fired from tabs that
  //    don't render the feed, because the getpostdatas subscription is not torn
  //    down in ngOnDestroy and its callback still ran after navigation.
  //  * Placement. Assigning admin rights from a rendering loop means it repeats
  //    forever; it should happen once, server-side, when membership is created.
  //
  // The deliberate Page Admins actions (community-pageadmin addAdmin() /
  // makeadmin() / accept()) still call the endpoint and are unaffected.
  //
  // NOTE: nothing now grants ADMIN users a col_community_admin row on the global
  // community - addUserToGigsumoCommunity only does that for SUPERADMIN. If that
  // is required, add it there so it runs once on first login.


  addNetworkToPost(element, postViewData, networkId): void {

    // A network post is identified by the network's own avatar, the way a community or a
    // business post already is. The feed pushes the raw `element` into `userData` up
    // front, so stamp the placeholder on both objects synchronously — the same shape
    // addCommunityDataToPost uses — and let the lookup below overwrite it. The fallback
    // is the icon the network's own page shows for a network with no logo.
    const networkFallbackLogo = "assets/icon/icons8-share-400.png";
    element.logo = element.logo || networkFallbackLogo;
    postViewData.logo = networkFallbackLogo;

    this.api.query("network/get/" + networkId).subscribe((res) => {
      if (
        res != undefined &&
        res != null &&
        res.data.Network != undefined &&
        res.data.Network != null
      ) {
        let img = null;
        let photo = img;
        if (postViewData.postedByUserData != null && postViewData.postedByUserData.photo != null) {
          photo = AppSettings.photoUrl + postViewData.postedByUserData.photo;
        }

        postViewData.userName = res.data.Network.networkName;
        postViewData.networkId = res.data.Network.networkId;
        postViewData.networkOwnerId = res.data.Network.networkOwnerId;
        postViewData.logo = res.data.Network.logo
          ? AppSettings.photoUrl + res.data.Network.logo
          : networkFallbackLogo;
        postViewData.photo = photo;
        postViewData.img = img;
        if (element.postType === "SHARE") {
          this.addSharedPostData(element, postViewData);
        } else {

          if (element.edit) {
            let indx = this.userData.findIndex(item => item.postId == element.postId);
            if (indx > -1) {
              this.userData[indx] = postViewData;
            }
          } else {

            this.userData.push(postViewData);
            this.userData = this.removeDuplicates(this.userData, "postId");
            this.userData = this.sortData(this.userData);
          }
        }

        console.error('post element out  ----> ', postViewData);
        console.error('post element out this.userdata  ----> ', this.userData);
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  addTeamsToPost(element, postViewData, teamId): void {
    // See addNetworkToPost — a team post carries the team's own avatar, stamped on the
    // raw element and the enriched record up front so the feed never renders an empty
    // slot while the lookup is in flight.
    const teamFallbackLogo = "assets/icon/icons8-share-400.png";
    element.logo = element.logo || teamFallbackLogo;
    postViewData.logo = teamFallbackLogo;

    this.api.query("teams/get/" + teamId).subscribe((res) => {
      if (
        res != undefined &&
        res != null &&
        res.data.teams != undefined &&
        res.data.teams != null
      ) {
        let img = null;

        let photo = img;

        if (postViewData.postedByUserData != null && postViewData.postedByUserData.photo != null) {
          photo = AppSettings.photoUrl + postViewData.postedByUserData.photo;
        }

        postViewData.userName = res.data.teams.teamName;
        postViewData.teamId = res.data.teams.teamId;
        postViewData.teamsOwnerId = res.data.teams.teamsOwnerId;
        postViewData.logo = res.data.teams.logo
          ? AppSettings.photoUrl + res.data.teams.logo
          : teamFallbackLogo;
        postViewData.photo = photo;
        postViewData.img = img;
        if (element.postType === "SHARE") {
          this.addSharedPostData(element, postViewData);
        } else {

          if (element.edit) {
            // Replace in place only; see addUserDataToPost.
            let indx = this.userData.findIndex(item => item.postId == element.postId);
            if (indx > -1) {
              this.userData[indx] = postViewData;
            }
          } else {
            this.userData.push(postViewData);
            this.userData = this.removeDuplicates(this.userData, "postId");
            this.userData = this.sortData(this.userData);
          }
        }
      }

      console.error('post element out  ----> ', postViewData);
      console.error('post element out this.userdata  ----> ', this.userData);
    }, err => {
      this.util.stopLoader();
    });
  }

  // Runs in every live instance when any instance deletes an original post
  // (broadcast from removepost via CommonValues.postDeleted). Matching is on
  // shareduser[0] because the outer card's sourcePostId holds the share's own
  // id, not the original's.
  handlePostDeletedElsewhere(deletedPostId): void {
    // The instance the delete was clicked in already spliced its own card.
    const indx = this.userData.findIndex(item => item.postId == deletedPostId);
    if (indx > -1) {
      this.userData.splice(indx, 1);
    }

    this.userData.forEach(post => {
      const shared = post.shareduser && post.shareduser[0];
      if (post.postType === "SHARE" && shared && !shared.sourceUnavailable
        && (shared.sourcePostId == deletedPostId || shared.postId == deletedPostId)) {
        this.addUnavailableSharedPost({
          sourcePostId: deletedPostId,
          sourcePostEntity: shared.postEntity,
          sourcePostEntityId: shared.postEntityId,
          sourcePostedBy: shared.postedBy,
          sourcePostedOn: shared.postedOn,
        }, post);
      }
    });
  }

  // The original of this share no longer exists (post/query returned nothing). Posts are
  // hard-deleted, so the card is built from the poster snapshot the server stamps on the
  // share row (sourcePostEntity / sourcePostEntityId / sourcePostedBy / sourcePostedOn),
  // and the template prints "This post is no longer available" where the content was.
  // Shares that were made before the snapshot existed, and whose original was deleted
  // before it could be stamped, carry no entity: they get the message with no header.
  addUnavailableSharedPost(sourcePost, postViewData): void {
    let shareViewData: any = {
      sourceUnavailable: true,
      // The edit flow restores a SHARE's sourcePostId from shareduser[0].postId.
      postId: sourcePost.sourcePostId,
      sourcePostId: sourcePost.sourcePostId,
      postType: "OWN",
      postEntity: sourcePost.sourcePostEntity || null,
      postEntityId: sourcePost.sourcePostEntityId || null,
      postedBy: sourcePost.sourcePostedBy || null,
      postedOn: sourcePost.sourcePostedOn || null,
      postContent: null,
      medias: [],
      likes: [],
      comments: [],
      shares: [],
      likesCount: 0,
      commentsCount: 0,
      sharedCount: 0,
      visible: false,
      // The network and team helpers below read postedByUserData.photo unguarded.
      postedByUserData: { photo: null },
    };

    if (!shareViewData.postEntity) {
      postViewData.shareduser = [shareViewData];
      this.userData.push(postViewData);
      this.userData = this.removeDuplicates(this.userData, "postId");
      this.userData = this.sortData(this.userData);
      return;
    }

    const dispatch = () => {
      if (shareViewData.postEntity === "USER") {
        this.addUserDataToSharedPost(postViewData, shareViewData, shareViewData.postEntityId);
      } else if (shareViewData.postEntity === "BUSINESS") {
        this.addBusinessDataToSharedPost(postViewData, shareViewData, shareViewData.postEntityId);
      } else if (shareViewData.postEntity === "COMMUNITY") {
        this.addCommunityDataToSharedPost(postViewData, shareViewData, shareViewData.postEntityId);
      } else if (shareViewData.postEntity === "NETWORK") {
        this.addNetworkDataToSharedPost(postViewData, shareViewData, shareViewData.postEntityId);
      } else if (shareViewData.postEntity === "TEAM") {
        this.addTeamDataToSharedPost(postViewData, shareViewData, shareViewData.postEntityId);
      }
    };

    // For a USER post the helper above already names the poster. The other headers print
    // the person from postedByUserData, which post/query used to supply; resolve it the
    // same way addUserDataToSharedPost does, and fall back to initials if that fails.
    if (shareViewData.postEntity !== "USER" && shareViewData.postedBy) {
      this.api.query("user/connection/" + shareViewData.postedBy).subscribe((userres) => {
        if (userres) {
          shareViewData.postedByUserData = {
            userId: userres.userId,
            firstName: userres.firstName,
            lastName: userres.lastName,
            fullName: ((userres.firstName || "") + " " + (userres.lastName || "")).trim(),
            photo: userres.photo,
          };
        }
        dispatch();
      }, err => {
        dispatch();
      });
    } else {
      dispatch();
    }
  }

  addUserDataToSharedPost(postViewData, shareViewData, userId): void {

    this.api.query("user/connection/" + userId).subscribe((userres) => {
      this.util.stopLoader()

      shareViewData.userName = userres.firstName + " " + userres.lastName;

      shareViewData.photo = userres.photo;
      shareViewData.img = userres.photo;
      shareViewData.organisation = userres.organisation;
      shareViewData.title = userres.title;

      // The card reads its avatar from `postedByUserData`, which is copied straight out
      // of the source-post response and does not always carry the poster — which left a
      // repost showing initials while the original post showed the owner's picture. On a
      // USER source post the poster is the post entity, so `userres` above is that same
      // person. Fill in only what the response left empty, so a payload that does carry
      // the block still wins.
      const sharedPoster: any = shareViewData.postedByUserData || {};
      if (!sharedPoster.photo && userres.photo) {
        sharedPoster.photo = userres.photo;
      }
      if (!sharedPoster.firstName) {
        sharedPoster.firstName = userres.firstName;
      }
      if (!sharedPoster.lastName) {
        sharedPoster.lastName = userres.lastName;
      }
      if (!sharedPoster.fullName) {
        sharedPoster.fullName = shareViewData.userName;
      }
      shareViewData.postedByUserData = sharedPoster;

      let shareData = [];
      shareData.push(shareViewData);
      (postViewData.shareduser = shareData), this.userData.push(postViewData);
      this.userData = this.removeDuplicates(this.userData, "postId");
      this.userData = this.sortData(this.userData);


    }, err => {
      this.util.stopLoader();
    });
  }

  addBusinessDataToSharedPost(postViewData, shareViewData, businessId): void {

    let datas: any = {};
    datas.businessId = businessId;
    datas.userId = localStorage.getItem("userId");

    this.api.create("business/check/admin", datas).subscribe((res) => {
      //loder
      let img = "assets/images/gallery/company.png";
      if (res.businessLogo != null) {
        img = AppSettings.photoUrl + res.businessLogo;
      }

      shareViewData.userName = res.businessName;
      shareViewData.photo = img;
      shareViewData.img = img;
      let shareData = [];
      shareData.push(shareViewData);
      (postViewData.shareduser = shareData), this.userData.push(postViewData);
      this.userData = this.removeDuplicates(this.userData, "postId");

      this.userData = this.sortData(this.userData);


    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
      }
    });
  }

  addCommunityDataToSharedPost(postViewData, shareViewData, communityId): void {

    let datas: any = {};
    datas.communityId = communityId;
    datas.userId = localStorage.getItem("userId");

    const sharedCommunityId = communityId != null ? communityId : this.communityid;

    this.api.query("community/details/" + sharedCommunityId).subscribe((res) => {
      // The inner card of a shared post is the source post's own header, so a community
      // source is identified by the community logo — the same value
      // addCommunityDataToPost stamps on a top-level community post. This was built from
      // `postedByUserData.photo`, which rendered the original poster's profile picture
      // beside the community name after the post was shared.
      const fallbackLogo = "assets/icon/Sumoface_final.png";
      const communityDetails = res.data != null ? res.data.communityDetails : null;
      let photo = fallbackLogo;
      if (communityDetails != null) {
        if (communityDetails.communityName) {
          shareViewData.userName = communityDetails.communityName;
        }
        if (communityDetails.logo) {
          photo = AppSettings.photoUrl + communityDetails.logo;
        }
      }
      shareViewData.photo = photo;
      shareViewData.logo = photo;
      shareViewData.img = photo;
      let shareData = [];
      shareData.push(shareViewData);

      (postViewData.shareduser = shareData), this.userData.push(postViewData);
      this.userData = this.removeDuplicates(this.userData, "postId");
      this.userData = this.sortData(this.userData);

    }, err => {
      this.util.stopLoader();
    });
  }

  addNetworkDataToSharedPost(postViewData, shareViewData, networkId): void {
    this.api.query("network/get/" + networkId).subscribe((res) => {
      if (
        res != undefined &&
        res != null &&
        res.data.Network.networkName != undefined &&
        res.data.Network.networkName != null
      ) {
        let img = null;
        let photo = img;
        if (shareViewData.postedByUserData.photo != null) {
          photo = AppSettings.photoUrl + shareViewData.postedByUserData.photo;
        }

        // The inner card of a shared post is the source post's own header, so a network
        // source shows the network's avatar. Same rule as the top-level post in
        // addNetworkToPost; `photo` stays the poster's picture for the callers that
        // still read it.
        shareViewData.logo = res.data.Network.logo
          ? AppSettings.photoUrl + res.data.Network.logo
          : "assets/icon/icons8-share-400.png";
        shareViewData.photo = photo;
        shareViewData.img = img;
        shareViewData.userName = res.data.Network.networkName;
        shareViewData.networkId = res.data.Network.networkId;
        shareViewData.networkOwnerId = res.data.Network.networkOwnerId;
        let shareData = [];
        shareData.push(shareViewData);
        (postViewData.shareduser = shareData), this.userData.push(postViewData);
        this.userData = this.removeDuplicates(this.userData, "postId");
        this.userData = this.sortData(this.userData);

      }
    }, err => {
      this.util.stopLoader();
    });
  }

  addTeamDataToSharedPost(postViewData, shareViewData, teamId): void {
    this.api.query("teams/get/" + teamId).subscribe((res) => {
      if (res != undefined && res != null) {
        let img = "";

        let photo = img;
        if (shareViewData.postedByUserData.photo != null) {
          photo = AppSettings.photoUrl + shareViewData.postedByUserData.photo;
        }
        // See addNetworkDataToSharedPost — a team source post shows the team's avatar.
        shareViewData.logo = res.data.teams.logo
          ? AppSettings.photoUrl + res.data.teams.logo
          : "assets/icon/icons8-share-400.png";
        shareViewData.photo = photo;
        shareViewData.img = img;
        shareViewData.userName = res.data.teams.teamName;
        shareViewData.teamId = res.data.teams.teamId;
        shareViewData.teamsOwnerId = res.data.teams.teamsOwnerId;
        let shareData = [];
        shareData.push(shareViewData);
        (postViewData.shareduser = shareData),
          this.userData.push(postViewData);
        this.userData = this.removeDuplicates(this.userData, "postId");
        this.userData = this.sortData(this.userData);
      }
    }, err => {
      this.util.stopLoader();
    });
  }


  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  custom_sort(a, b) {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
  }
  sharepage(data) {
    let postEntityId;
    if (this.Commomdatass === "USER") {
      postEntityId = this.userId;
    } else if (this.Commomdatass === "COMMUNITY") {
      postEntityId = this.communityid;
    } else if (this.Commomdatass === "BUSINESS") {
      postEntityId = this.businessId;
    } else if (this.Commomdatass === "NETWORK") {
      postEntityId = this.networkId;
    } else if (this.Commomdatass === "TEAM") {
      postEntityId = this.teamId;
    }

    let postdatas = this.sharecmd;
    let datas = {
      postType: "SHARE",
      sourcePostId: data.postId,
      postContent: postdatas,
      postEntity: this.Commomdatass,
      postEntityId: postEntityId,
      postedBy: localStorage.getItem("userId"),
    };
    this.util.startLoader();
    this.api.create("post/create", datas).subscribe((res) => {
      this.showWelcomePost = false;
      this.selectedEntities = []
      this.util.stopLoader();

      res.edit = false
      // Keep the feed cursor as-is. This used to reset it to undefined to work around
      // localPushData nulling it, but that restarts paging at page 1 and the dedupe
      // filter in commonPost_getpostdatas then drops the whole batch, so scrolling
      // never advanced either. localPushData no longer touches the cursor.
      this.localPushData(res);


      this.commanddata = "";
      this.sharecmd = "";
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while processing your request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });
  }
  toTitleCase(str: string): string {
    return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  loadPreviousComments(post: any): void {
    this.indexforSearchafterKey.pop();
    for (let i = post.comments.length - 1; i >= 0; i--) {
      const po = post.comments[i];
      if (po.offset === post.c.offSet) {
        post.comments.splice(i, 1);
      } else {
        break;
      }
    }
    post.c.offSet -= 3;
  }


  indexforSearchafterKey = [];
  loadMoreComments(post: any): void {

    if (post.c === undefined || post.c == null) {
      post.c = {
        offSet: 0,
        pageCount: 3,
      };
    }
    post.c.offSet = post.c.offSet + post.c.pageCount;
    if (this.indexforSearchafterKey.length == 0) {
      this.previousSearchAfterKey = null;
    } else {
      let lastkey = this.indexforSearchafterKey[this.indexforSearchafterKey.length - 1];
      if (lastkey) {
        this.previousSearchAfterKey = lastkey.key;
        if (lastkey.postId != post.postId) {
          this.indexforSearchafterKey = [];
          this.previousSearchAfterKey = null;
        }
      }


    }

    const postData = {
      postId: post.postId,
      searchAfterKey: this.previousSearchAfterKey ? [this.previousSearchAfterKey] : null,
      limit: 3,
      isGlobalCommunityPost: false

    };

    if (post.isGlobalCommunityPost == true || post.isGlobalCommunityPost != null) {
      postData.isGlobalCommunityPost = true;
    }

    this.util.startLoader();
    this.api.create("post/comments/qu", postData).subscribe((res: any) => {
      this.util.stopLoader();
      if (res) {
        if (res.data && res.data.comments) {

          if (res.data.searchAfterKey && res.data.searchAfterKey.length > 0) {
            let data = {
              "key": res.data.searchAfterKey[0],
              "postId": post.postId
            }
            this.indexforSearchafterKey.push(data)
            this.previousSearchAfterKey = res.data.searchAfterKey[0];
          }
          const comments = res.data.comments
          comments.forEach((e) => {

            if (e.photo !== undefined && e.photo != null) {
              // Prevent double URL prepending
              if (!e.photo.startsWith('http://') && !e.photo.startsWith('https://')) {
                e.photo = AppSettings.photoUrl + e.photo;
              }
            } else {
              e.photo = null
            }
            e.offset = post.c.offSet;
            post.comments.push(e);
          });
        }
      } else {
        this.util.stopLoader();
      }
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while processing your request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });
  }


  showData(number, value) {
    if (number > 3) {
      this.cmdOffsetafterkey = false;
    }
  }

  redirectEntityFromShareModal(data) {
    this.closeSharePage();
    this.communityroute(data);
  }

  isBusinessSuperAdmin(): boolean {
    // return (localStorage.getItem('isSuperAdmin') == 'true' || localStorage.getItem('isAdmin') == 'true') ? true : false;
    return this.businessData.isSuperAdmin == 'true' || this.businessData.isAdmin == 'true' ? true : false;
  }

  showSharePrivacyMenu(): boolean {
    // The audience selector applies when the share goes out as the user's own
    // share: on USER pages, and on business pages for non-admins (whose shares
    // are retargeted to USER in sharePostPage()).
    return this.Commomdatass === 'USER' || (this.Commomdatass === 'BUSINESS' && !this.showPostTool());
  }

  communityroute(data) {



    if (data.postEntity === "COMMUNITY") {
      let datas: any = {};
      datas.communityId = data.postEntityId;
      data.communityId = data.communityId

      datas.userId = localStorage.getItem('userId')
      this.api.create("community/home", datas).subscribe(res => {
        if (res) {
          localStorage.setItem('communityId', res.data.communityhome.communityId)
          localStorage.setItem('isAdmin', res.data.isAdmin)
          localStorage.setItem('communityAdmin', res.data.isAdmin)
          localStorage.setItem('communityType', res.data.communityhome.communityType)
          localStorage.setItem('isSuperAdmin', res.data.isSuperAdmin)
          localStorage.setItem('communitySuperadmin', res.data.isSuperAdmin)
          localStorage.setItem('isJoined', res.data.isJoined)
          localStorage.setItem('screen', 'community')
          localStorage.setItem('adminviewflag', 'false')
          datas.communityId = res.data.communityhome.communityId;
          this.router.navigate(['community'], { queryParams: res.data.communityhome })
        }
      });


      // this.router.navigate(["community"], { queryParams: datas });
    } else if (data.postEntity === "NETWORK") {
      this.api.query("network/get/" + data.postEntityId).subscribe((res) => {
        if (res != undefined && res != null) {
          // Clicking the network name while already on networkPage/home is a
          // same-route navigation — force a fresh route so the feed reloads.
          localStorage.setItem('networkId', res.data.Network.networkId);
          navigateWithFreshRoute(this.router, ["networkPage/home"], {
            queryParams: { ...res.data.Network, menu: "home", master: "NETWORK" },
          });
        }
      }, err => {
        this.util.stopLoader();
      });
    } else if (data.postEntity === "TEAM") {
      this.api.query("teams/get/" + data.postEntityId).subscribe((res) => {
        if (res != undefined && res != null) {
          // Same-route navigation from teamPage/home — force a fresh route.
          localStorage.setItem('teamId', res.data.teams.teamId);
          navigateWithFreshRoute(this.router, ["teamPage/home"], {
            queryParams: { ...res.data.teams, menu: "home", master: "TEAM" },
          });
        }
      }, err => {
        this.util.stopLoader();
      });
    } else if (data.postEntity === "BUSINESS") {
      // Same route the business logo click takes (userprofile's BUSINESS branch).
      this.userprofile(data, data.postedBy);
    }
  }

  photoUrl: any = AppSettings.photoUrl;
  onProfilePhotoError(event, post: any, comments?:any) {

    if(comments && comments == 'communityprofileimageerror'){
      event.target.src = "assets/icon/Sumoface_final.png";
      return;
    }

    if (post.postEntity === "BUSINESS") {
      event.target.src = "assets/images/gallery/company.png";
    } else if (post.postEntity === "COMMUNITY") {
      event.target.src = "assets/icon/comm.png";
    } else {
    }
  }
  onTargetRateTyped(value, param) {
    this.typeTargetValue = value
  }
  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }
  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }

  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }

  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    class: 'modal-centered',
    // Without this, ngx-bootstrap appends the modal next to whatever DOM node
    // triggered it instead of document.body, so it can inherit the post feed's
    // scroll/overflow context and render misaligned or overlapping nearby post
    // content (e.g. a comment box) depending on where in the feed it was opened.
    container: 'body',
  };

  startAPost(postTemplate: TemplateRef<any>) {
    this.currentOrg = true;
    this.animState0 = 'middle'
    this.animState1 = 'right'
    this.animState = 'right'
    this.editPost = false
    this.checkedList = [];
    this.tempcheckedList = [];
    this.resetPrivacyEntities()
    this.postPrivacy = "Everyone";
    this.privacyValue = 'Everyone'
    this.modalRef = this.modalService.show(postTemplate, this.backdropConfig);
    this.postTypeForm.get('postType').setValue('Everyone')
    this.commonVariables.postFormflag = true;
    this.getCountries()
    this.getListValues('ENGAGEMENT_TYPE')
  }

  localPushData(response) {
    // A post addressed to several privacy entities becomes one post per entity on the
    // server, which can only return one of them at the top level. Add every one of them
    // instead of just that one, otherwise the rest stay missing until a page reload.
    // Oldest first, so the newest ends up on top after each unshift below.
    if (response && response.createdPosts && response.createdPosts.length > 1) {
      response.createdPosts.forEach(created => {
        created.edit = response.edit;
        created.userName = created.PostEntityName;
        this.localPushData(created);
      });
      return;
    }
    this.shareData = [];
    this.commentData = [];
    if (response !== undefined && response !== null) {
      // Do NOT touch this.afterKey here. `response` is a single created/edited/shared
      // post from post/create|post/update, not a page of feed results. PostModel
      // declares a searchAfterKey field that those endpoints never populate, so it
      // arrives as null and set the feed cursor to null. commonPost_getpostdatas then
      // hit its else branch and returned before issuing any request, so infinite
      // scroll died after every save until the component was recreated by a refresh.
      // The cursor from the last post/query page is still the right one to scroll on.
      // this.userbadges.profileStatus();
      let element = response;
      if (element.medias) {
        element.medias.forEach((e1) => {
          if (e1.url != null) {
            var path;
            path = AppSettings.photoUrl + e1.fileId;
            e1.url = "";
            e1.url = path;
          } else {

          }
        });
      }
      if (element.comments) {
        element.comments.forEach((e1: any) => {

          if (e1) {
            if (e1.photo && e1.photo != null) {
              // Prevent double URL prepending
              if (!e1.photo.startsWith('http://') && !e1.photo.startsWith('https://')) {
                e1.photo = AppSettings.photoUrl + e1.photo;
              }
            } else {
              e1.photo = null
            }
          }
        });
      }

      let indx;
      if (element.postContent == null) {
        element.postContent = null
      }

      var postData = {
        status: element.status,
        userId: element.userId,
        connected: element.connected,
        isWelcomePost: element.isWelcomePost,
        isPlatformPost: element.isPlatformPost,
        postId: element.postId,
        postType: element.postType,
        sourcePostId: element.postId,
        postContent: element.postContent,
        postEntity: element.postEntity,
        postEntityId: element.postEntityId,
        postedBy: element.postedBy,
        postedByType: element.postedByType,
        postedOn: element.postedOn,

        likesCount: element.likesCount,
        commentsCount: element.commentsCount,
        sharedCount: element.sharedCount,

        postPrivacy: element.postPrivacy,
        postPrivacyEntities: element.postPrivacyEntities,
        hashTags: element.hashTags,
        medias: element.medias,
        likes: element.likes,
        shares: element.shares,
        page: element.page,
        code: element.code,
        message: element.message,
        comments: element.comments,
        visible: false,

        userLikedStatus: element.userLikedStatus,
        postedByUserData: element.postedByUserData
      };

      if (element.edit) {
        // The server bumps postedOn to the edit time, so the edited post is now the newest
        // in the feed. Move it to the top instead of overwriting it in its old slot, which
        // left the card showing a new date in a stale position.
        indx = this.userData.findIndex(item => item.postId == element.postId);
        if (indx > -1) {
          // A SHARE post's embedded original (shareduser: author, text, image) is not
          // part of the update response; addSharedPostData() re-fetches it from
          // post/query/{sourcePostId} after the entity lookup below. Carry the block
          // over from the card being replaced so it never blinks out in the meantime.
          if (element.postType === "SHARE" && this.userData[indx].shareduser) {
            (postData as any).shareduser = this.userData[indx].shareduser;
          }
          this.userData.splice(indx, 1);
        }
        this.userData.unshift(postData);
      } else {
        // Add new post to the beginning of the array
        this.userData.unshift(postData);
      }

      // Drop the notification pin (?postId=) so movedatafirst() no longer holds the
      // notified post above the one just created/edited, then bring the top into view.
      this.postId = undefined;
      this.scrollFeedToTop();

      this.addPrivacyEntitiesToPost(element, postData);

      if (element.postEntity === "USER") {
        this.addUserDataToPost(element, postData, element.postEntityId);
      } else if (element.postEntity === "BUSINESS") {
        this.addBusinessDataToPost(
          element,
          postData,
          element.postEntityId,

        );
      } else if (element.postEntity === "COMMUNITY") {
        this.addCommunityDataToPost(
          element,
          postData,
          element.postEntityId,

        );
      } else if (element.postEntity === "NETWORK") {
        this.addNetworkToPost(element, postData, element.postEntityId);
      } else if (element.postEntity === "TEAM") {
        this.addTeamsToPost(element, postData, element.postEntityId);
      }
      this.contentLoaded = true;
      setTimeout(() => {
        this.util.stopLoader()
      }, 600);
    }
  }


  filetoView: any

  savetest() {
    // console.log(this.fileDragdrop.name);
  }


  onFileDropped(files: any) {
    console.log('Files dropped:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }

  fileBrowseHandler(files: FileList) {
    console.log('Files browsed:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }
  @ViewChild('fileDropRef') fileDropRef: ElementRef;
  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      console.log('No files to process');
      return;
    }

    const file = files[0]; // Get the first file
    console.log('Processing file:', file);

    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      return;
    }

    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/docx',
      'application/doc',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];

    console.log('File type:', file.type);

    // Check if file type is acceptable
    if (acceptableFormats.includes(file.type)) {
      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      console.log('File accepted:', this.fileDragdrop);
      this.resumeupload = file;

      // Reset previous parsing states
      this.parseSuccess = false;
      this.parseFailed = false;
      this.parsedResumeData = null;
      this.showParsedDetails = false;
      this.parseRetryCount = 0; // Reset retry count for new file

      // Start upload progress bar
      this.isUploading = true;
      this.uploadProgress = 0;

      console.log('🔍 About to trigger auto-parse resume...');
      console.log('Resume upload file:', this.resumeupload);
      console.log('File drag drop:', this.fileDragdrop);

      // Automatically trigger resume parsing
      this.autoParseResume();
      console.log('✅ Auto-parse resume triggered');
    } else {
      console.log('Invalid file format');
      this.fileDragdrop = null;
      this.resumeupload = null;
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }

  removeFiles() {
    this.fileDragdrop = null;
    this.resumeupload = null;
    this.parseSuccess = false;
    this.parseFailed = false;
    this.parsedResumeData = null;
    this.showParsedDetails = false;
    this.activeResumeTab = 'overview';
    if (this.fileDropRef && this.fileDropRef.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }
  }

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  buycredit(id) {
    this.submited = true;
    if (id != 'noval') {
      this.creditform.patchValue({ 'point': id });
    }
    if (this.creditform.valid) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
        buttonsStyling: false
      })

      swalWithBootstrapButtons.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.creditform.valid) {
            this.submited = false;
            let data: any = {};
            data.userId = localStorage.getItem('userId'),
              //data.totalPoints = this.creditform.value.point;
              this.util.startLoader();
            this.api.create("credits/buyCredits", data).subscribe(res => {
              this.util.stopLoader();
              this.creditform.reset();
              this.modalRef.hide()
              this.showmodel = false;

              if (res.code == "00000") {
                this.modalService.hide(1)
                this.modalService.hide(2)
                this.beingEdited = false
                Swal.fire({
                  icon: "success",
                  title: "Credit Added Successfully",
                  showDenyButton: false,
                  // confirmButtonText: `ok`,
                  timer: 2000,
                })
                this.creditform.reset();


              }
            }, err => {
              this.util.stopLoader();
            })
          } else if (this.creditform.invalid) {
            this.submited = true;

          }


        } else if (result.dismiss === Swal.DismissReason.cancel) {

          this.creditform.reset();

        }
      })


    }
  }


  onDownload() {
    const file: File = this.tempFile;
    this.downloadFile(new Blob([file]), file.name);
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }

  messagemodelflag = false;
  messageData: any
  closeMessage() {
    this.messagemodelflag = false;
  }

  updateSupportModule() {
    let module = new jobModuleConfig(this.openSupport);
    module.source = this;
    this.supportModal = module;
  }

  openSupport() {
    // this.closeModal();
    let data: any = {}
    data.userId = localStorage.getItem('userId');
    data.groupType = "SUPPORT";
    let url = "findContactsByRefererId";
    this.api.messagePageService('POST', url, data).subscribe(res => {

      var userData: any = {};
      userData.groupId = null;
      if (res.length != 0) {
        userData.groupId = null;
        if (res[0].groupId) {
          userData.groupId = res[0].groupId;
        }
      }
      this.messageData = [];
      this.messagemodelflag = true;
      this.messageData.onlySupport = "SUPPORT";
      this.messageData.groupType = "SUPPORT";
      this.messageData.messageType = "SUPPORT";
      this.messageData.userId = localStorage.getItem('userId');
      this.messageData.id = userData.groupId;
    });
  }

  // ============================================
  // RESUME PARSING METHODS - START
  // ============================================

  // Auto-parse resume with retry logic
  autoParseResume(isRetry: boolean = false) {
    console.log('🚀 autoParseResume called - isRetry:', isRetry);
    console.log('resumeupload:', this.resumeupload);
    console.log('fileDragdrop:', this.fileDragdrop);

    // Handle both File object (resumeupload) and custom object (fileDragdrop)
    let fileToProcess;
    if (this.fileDragdrop && this.fileDragdrop.file) {
      fileToProcess = this.fileDragdrop;
      console.log('Using fileDragdrop object');
    } else if (this.resumeupload) {
      // Wrap plain File object into expected format
      fileToProcess = {
        file: this.resumeupload,
        fileName: this.resumeupload.name,
        fileType: this.resumeupload.type
      };
      console.log('Using resumeupload (wrapped)');
    }

    console.log('fileToProcess:', fileToProcess);

    if (fileToProcess && fileToProcess.file) {
      console.log('autoParseResume - File details:', {
        name: fileToProcess.file.name,
        type: fileToProcess.file.type,
        size: fileToProcess.file.size
      });
    }

    if (!fileToProcess || !fileToProcess.file) {
      console.log('❌ No file to parse - fileToProcess:', fileToProcess);
      return;
    }

    // Show parsing status
    this.isParsing = true;
    this.parseSuccess = false;
    this.parseFailed = false;

    // Use the resume parser service - pass the actual File object
    console.log('Calling resumeParserService.parseResume with file:', fileToProcess.file);

    // Get candidateId, userId, and organisationId if available
    const candidateId = this.candidatePostForm?.get('candidateId')?.value || null;
    const userId = localStorage.getItem('userId') || null;
    const organisationId = this.currentOrganizationDetail?.organisationId || null;

    // Store the subscription so we can cancel it if needed
    this.resumeParseSubscription = this.resumeParserService.parseResume(fileToProcess.file, candidateId, userId, organisationId).subscribe(
      (response) => {
        this.isParsing = false;
        console.log('Resume parser response:', response);
        console.log('Response code:', response?.code);
        console.log('Response status:', response?.status);

        // Check for success
        const isSuccess = (response && (
          response.code === '00000' ||
          response.code === 200 ||
          response.status === 200 ||
          response.status === 'success'
        ));

        if (isSuccess && response.data) {
          this.parseSuccess = true;
          this.parseFailed = false;

          // Extract the actual resume data
          const resumeData = response.data?.resumeData || response.data;

          this.parsedResumeData = resumeData;
          console.log('Parsed resume data:', resumeData);

          // Show the tabbed interface
          this.showParsedDetails = true;
          this.activeResumeTab = 'overview';

          console.log('About to populate form with API response data:', resumeData);

          try {
            this.populateFormWithParsedData(resumeData);
            console.log('Form population completed successfully');

            // Show success message
            Swal.fire({
              icon: "success",
              title: "Resume parsed successfully!",
              text: "Form fields have been auto-filled. Review the data below.",
              showDenyButton: false,
              timer: 3000,
            });
          } catch (formPopulationError) {
            console.error('Error populating form:', formPopulationError);

            // Still consider parsing successful, but form population failed
            Swal.fire({
              icon: "warning",
              title: "Resume parsed successfully",
              text: "Resume was parsed but some form fields couldn't be auto-filled. You can fill them manually.",
              showDenyButton: false,
              timer: 5000,
            });
          }
        } else {
          this.handleParseErrorWithRetry('Failed to parse resume');
        }
      },
      (error) => {
        console.error('autoParseResume error caught:', error);
        this.handleParseErrorWithRetry(error?.message || error?.error?.message || 'Failed to parse resume');
      }
    );
  }

  // Handle parse error with automatic retry logic
  handleParseErrorWithRetry(errorMessage: string) {
    this.isParsing = false;
    this.parseRetryCount++;

    console.log(`Parse attempt ${this.parseRetryCount} failed:`, errorMessage);

    // If we haven't exceeded max retries, try again
    if (this.parseRetryCount < this.MAX_PARSE_RETRIES) {
      console.log(`Retrying parse automatically (${this.parseRetryCount}/${this.MAX_PARSE_RETRIES})...`);

      this.parseFailed = false;

      // Wait 2 seconds before retrying
      setTimeout(() => {
        this.autoParseResume(true);
      }, 2000);
    } else {
      // No more retries, show the parse button
      this.parseFailed = true;
      this.parseSuccess = false;
      console.log('Max retries reached, showing manual parse button');

      // Show final error message
      Swal.fire({
        icon: "error",
        title: "Resume parsing failed",
        text: `Failed after ${this.MAX_PARSE_RETRIES} automatic attempts. Please click 'Retry Parse Resume' button to try again manually.`,
        showConfirmButton: true
      });
    }
  }

  // Manual parse resume method
  parseResume() {
    // Reset retry count when user manually clicks parse button
    this.parseRetryCount = 0;
    console.log('Manual parse requested by user - resetting retry count');

    // Handle both File object (resumeupload) and custom object (fileDragdrop)
    let fileToProcess;
    if (this.fileDragdrop && this.fileDragdrop.file) {
      fileToProcess = this.fileDragdrop;
    } else if (this.resumeupload) {
      // Wrap plain File object into expected format
      fileToProcess = {
        file: this.resumeupload,
        fileName: this.resumeupload.name,
        fileType: this.resumeupload.type
      };
    }

    if (!fileToProcess || !fileToProcess.file) {
      Swal.fire({
        icon: "warning",
        title: "No file uploaded",
        text: "Please upload a resume file first",
        showDenyButton: false,
        timer: 3000,
      });
      return;
    }

    // Validate the resume file
    const validation = this.resumeParserService.validateResumeFile(fileToProcess);
    if (!validation.valid) {
      Swal.fire({
        icon: "warning",
        title: "Invalid file",
        text: validation.message,
        showDenyButton: false,
        timer: 3000,
      });
      return;
    }

    // Show parsing status
    this.isParsing = true;
    this.parseSuccess = false;
    this.parseFailed = false;

    // Get candidateId, userId, and organisationId if available
    const candidateId = this.candidatePostForm?.get('candidateId')?.value || null;
    const userId = localStorage.getItem('userId') || null;
    const organisationId = this.currentOrganizationDetail?.organisationId || null;

    // Use the resume parser service - pass the actual File object
    // Store the subscription so we can cancel it if needed
    this.resumeParseSubscription = this.resumeParserService.parseResume(fileToProcess.file, candidateId, userId, organisationId).subscribe(
      (response) => {
        this.isParsing = false;
        console.log('Resume parser response:', response);

        // Check for success
        const isSuccess = (response && (
          response.code === '00000' ||
          response.code === 200 ||
          response.status === 200 ||
          response.status === 'success'
        ));

        if (isSuccess && response.data) {
          this.parseSuccess = true;
          this.parseFailed = false;

          // Extract the actual resume data
          const resumeData = response.data?.resumeData || response.data;

          this.parsedResumeData = resumeData;
          console.log('Parsed resume data:', resumeData);

          // Show the tabbed interface
          this.showParsedDetails = true;
          this.activeResumeTab = 'overview';

          console.log('About to populate form with API response data:', resumeData);

          try {
            this.populateFormWithParsedData(resumeData);
            console.log('Form population completed successfully');

            Swal.fire({
              icon: "success",
              title: "Resume parsed successfully!",
              text: "Form fields have been auto-filled",
              showDenyButton: false,
              timer: 3000,
            });
          } catch (formPopulationError) {
            console.error('Error populating form after successful parse:', formPopulationError);
            this.parseSuccess = true;

            Swal.fire({
              icon: "warning",
              title: "Resume parsed successfully",
              text: "Resume data was extracted successfully, but some form fields may need manual review. Please check the form.",
              showConfirmButton: true
            });
          }
        } else {
          this.parseFailed = true;
          Swal.fire({
            icon: "error",
            title: "Failed to parse resume",
            text: response.message || "Please try again using the retry button",
            showDenyButton: false,
            timer: 3000,
          });
        }
      },
      (error) => {
        this.isParsing = false;
        this.parseFailed = true;
        console.error('Resume parsing error:', error);
        Swal.fire({
          icon: "error",
          title: "Error parsing resume",
          text: error.message || "Please try again later",
          showDenyButton: false,
          timer: 3000,
        });
      }
    );
  }

  // Populate form with parsed resume data using the mapper service (COPIED FROM LANGDING-PAGE-NAV-BAR)
  populateFormWithParsedData(data: any) {
    console.log('Populating form with data:', data);

    if (!data || !this.candidatePostForm) {
      console.error('No data or form not initialized');
      return;
    }

    try {
      // Log form state before mapping
      console.log('Form controls before mapping:', Object.keys(this.candidatePostForm.controls));
      console.log('Form values before mapping:', this.candidatePostForm.value);

      // Use the mapper service to populate the form first
      const options = {
        enhanceSummary: true,
        primarySkillsList: this.primarySkillsList,
        secondarySkillsList: this.secondarySkillsList
      };

      console.log('Mapping options:', options);
      this.resumeDataMapper.mapResumeDataToForm(data, this.candidatePostForm, options);

      // Log form state after mapping
      console.log('Form values after mapper service:', this.candidatePostForm.value);

      // Now override with direct mappings for the new API response structure
      this.directlyPopulateFormFields(data);

      // Update selected skills arrays for UI
      this.primarySkillsSelected = this.candidatePostForm.get('primarySkills')?.value || [];
      this.secondarySkillsSelected = this.candidatePostForm.get('secondarySkills')?.value || [];

      console.log('Primary skills selected:', this.primarySkillsSelected);
      console.log('Secondary skills selected:', this.secondarySkillsSelected);

      // Force form update
      this.candidatePostForm.markAllAsTouched();
      this.candidatePostForm.updateValueAndValidity();

      console.log('Final form values:', this.candidatePostForm.value);

      console.log('=== FINAL SKILL CHECK ===');
      console.log('primarySkills in form:', this.candidatePostForm.get('primarySkills')?.value);
      console.log('secondarySkills in form:', this.candidatePostForm.get('secondarySkills')?.value);
      console.log('primarySkillsSelected array:', this.primarySkillsSelected);
      console.log('secondarySkillsSelected array:', this.secondarySkillsSelected);
      console.log('primarySkillsList (available options):', this.primarySkillsList);
      console.log('secondarySkillsList (available options):', this.secondarySkillsList);

      // Clear localStorage to prevent 4-second delayed overwrite from onChangeCandidate()
      localStorage.removeItem(this.userid + "_landingPagecandidatePostForm");
      console.log('Cleared localStorage to prevent overwrite of resume data');

      // Force validation to show for empty required fields (e.g., state)
      setTimeout(() => {
        this.candidatePostForm.markAllAsTouched();
        this.candidatePostForm.updateValueAndValidity();
        console.log('Forced validation after resume parse');
      }, 150); // After all other setTimeouts complete

    } catch (error) {
      console.error('Error populating form:', error);
    }
  }

  // Direct form field population for the new API response structure (COPIED FROM LANGDING-PAGE-NAV-BAR)
  directlyPopulateFormFields(data: any) {
    console.log('Starting comprehensive form field population with data:', data);

    // Store the data for later use
    this.parsedResumeData = data;

    // 1. PERSONAL INFORMATION
    if (data.personal_info) {
      const personal = data.personal_info;
      console.log('Personal info found:', personal);

      // Names
      if (personal.name) {
        const names = personal.name.split(' ');
        const firstName = names[0];
        const lastName = names.slice(1).join(' ') || firstName;

        console.log('Setting names:', { firstName, lastName });
        this.candidatePostForm.patchValue({
          firstName: firstName,
          lastName: lastName
        });
      }

      // Contact Information
      if (this.userType == 'JOB_SEEKER') {
        // JOB_SEEKER: the candidate IS the logged-in user, so the email must always come
        // from the user account (this.primaryEmail), never from the parsed resume. The
        // email field is disabled for JOB_SEEKER, so patchEmail()/(input) never fires to
        // sync candidateEmailId — patch both explicitly here so it isn't left empty (resume
        // had no email) or overwritten with a different email from the resume. Mirrors the
        // manual/edit path (candidate-template.component.ts) and the form-init seed.
        this.candidatePostForm.patchValue({
          email: this.primaryEmail,
          candidateEmailId: this.primaryEmail
        });
      } else if (personal.email) {
        console.log('Setting email:', personal.email);
        this.candidatePostForm.patchValue({
          email: personal.email,
          candidateEmailId: personal.email
        });
      }

      if (personal.phone) {
        console.log('Setting phone:', personal.phone);
        this.candidatePostForm.patchValue({
          phone: personal.phone
        });
      }

      // Target Rate from parsed resume (only if found in resume)
      if (personal.targetRateFrom) {
        console.log('Setting target rate from:', personal.targetRateFrom);
        this.candidatePostForm.patchValue({
          targetRateFrom: personal.targetRateFrom
        });
      }
      if (personal.targetRateTo) {
        console.log('Setting target rate to:', personal.targetRateTo);
        this.candidatePostForm.patchValue({
          targetRateTo: personal.targetRateTo
        });
      }
      if (personal.payType) {
        console.log('Setting pay type:', personal.payType);
        this.candidatePostForm.patchValue({
          payType: this.normalizePayType(personal.payType)
        });
      }
    }

    // 2. PROFESSIONAL SUMMARY
    if (data.summary) {
      console.log('Setting summary:', data.summary);
      const cleanSummary = data.summary.replace(/\*\*(.*?)\*\*/g, '$1');
      this.candidatePostForm.patchValue({
        resumeSummary: cleanSummary
      });
    }

    // 3. JOB TITLE
    let jobTitle = null;
    if (data.job_title_match?.current_title_match?.current_title) {
      jobTitle = data.job_title_match.current_title_match.current_title;
    } else if (data.summary) {
      const summaryMatch = data.summary.match(/\*\*(.*?)\*\*/);
      if (summaryMatch) {
        jobTitle = summaryMatch[1];
      }
    }

    if (jobTitle) {
      console.log('Setting job title:', jobTitle);
      this.candidatePostForm.patchValue({
        jobTitle: jobTitle
      });
    }

    // 4. EXPERIENCE
    if (data.ranking_metrics?.total_experience_years) {
      console.log('Setting total experience:', data.ranking_metrics.total_experience_years);
      this.candidatePostForm.patchValue({
        totalExperience: data.ranking_metrics.total_experience_years
      });
    }

    // 5. SKILLS (Primary and Secondary)
    let allSkills = [];

    console.log('=== SKILL EXTRACTION DEBUG ===');
    console.log('Full data object:', data);
    console.log('skills.primary_skills:', data.skills?.primary_skills);
    console.log('skills.secondary_skills:', data.skills?.secondary_skills);
    console.log('skill_analysis:', data.skill_analysis);
    console.log('required_skills_matched:', data.skill_analysis?.required_skills_matched);
    console.log('additional_relevant_skills:', data.skill_analysis?.additional_relevant_skills);

    // PRIORITY 1: Use the new primary_skills and secondary_skills fields from OpenAI
    if (data.skills?.primary_skills && data.skills.primary_skills.length > 0) {
      console.log('Using primary_skills and secondary_skills from API:', data.skills);

      const primarySkills = data.skills.primary_skills || [];
      const secondarySkills = data.skills.secondary_skills || [];

      allSkills = [...primarySkills, ...secondarySkills];

      if (primarySkills.length > 0) {
        console.log('Setting primary skills from API:', primarySkills);
        this.candidatePostForm.patchValue({
          primarySkills: primarySkills
        });
        this.primarySkillsSelected = primarySkills;
        console.log('Primary skills in form after patch:', this.candidatePostForm.get('primarySkills')?.value);
      }

      if (secondarySkills.length > 0) {
        console.log('Setting secondary skills from API:', secondarySkills);
        this.candidatePostForm.patchValue({
          secondarySkills: secondarySkills
        });
        this.secondarySkillsSelected = secondarySkills;
        console.log('Secondary skills in form after patch:', this.candidatePostForm.get('secondarySkills')?.value);
      }
    }
    // PRIORITY 2: Fallback to skill_analysis (old logic)
    else if (data.skill_analysis?.required_skills_matched && data.skill_analysis.required_skills_matched.length > 0) {
      console.log('Processing skills from skill_analysis:', data.skill_analysis.required_skills_matched);

      const allMatchedSkills = data.skill_analysis.required_skills_matched
        .sort((a, b) => {
          const proficiencyOrder = { 'Expert': 3, 'Advanced': 2, 'Intermediate': 1 };
          const proficiencyDiff = proficiencyOrder[b.proficiency_level] - proficiencyOrder[a.proficiency_level];
          if (proficiencyDiff !== 0) return proficiencyDiff;
          return (b.years_of_experience || 0) - (a.years_of_experience || 0);
        });

      const allSkillNames = allMatchedSkills.map(skill => skill.skill);
      let additionalSkills = [];
      if (data.skill_analysis?.additional_relevant_skills && Array.isArray(data.skill_analysis.additional_relevant_skills)) {
        additionalSkills = data.skill_analysis.additional_relevant_skills;
      }

      const allUniqueSkills = [...new Set([...allSkillNames, ...additionalSkills])];
      const halfPoint = Math.ceil(allUniqueSkills.length / 2);
      const primarySkills = allUniqueSkills.slice(0, halfPoint);
      const finalSecondarySkills = allUniqueSkills.slice(halfPoint);

      allSkills = [...primarySkills, ...finalSecondarySkills];

      if (primarySkills.length > 0) {
        console.log('Setting primary skills:', primarySkills);
        this.candidatePostForm.patchValue({
          primarySkills: primarySkills
        });
        this.primarySkillsSelected = primarySkills;
      }

      if (finalSecondarySkills.length > 0) {
        console.log('Setting secondary skills:', finalSecondarySkills);
        this.candidatePostForm.patchValue({
          secondarySkills: finalSecondarySkills
        });
        this.secondarySkillsSelected = finalSecondarySkills;
      }
    }

    // Add skills to available lists
    if (allSkills.length > 0) {
      allSkills.forEach(skill => {
        if (!this.primarySkillsList.includes(skill)) {
          this.primarySkillsList.push(skill);
        }
        if (!this.secondarySkillsList.includes(skill)) {
          this.secondarySkillsList.push(skill);
        }
      });
    }

    // 6. WORK PREFERENCES - Only set isResumeAttached since resume was actually attached
    // REMOVED DEFAULTS: remoteWork, workFromHome, relocationRequired - let validation catch missing fields
    this.candidatePostForm.patchValue({
      isResumeAttached: true
    });

    // 7. LOCATION
    this.setLocationFromData(data);

    console.log('Completed comprehensive form field population');
  }

  // Helper method for location
  // Rule: If resume has ANY location data -> use resume location (clear work exp)
  //       If resume has NO location data -> keep work experience location
  setLocationFromData(data: any): void {
    try {
      const personal = data.personal_info;

      console.log('=== setLocationFromData called ===');
      console.log('personal_info:', personal);

      // Check if resume has ANY location data
      const resumeCity = personal?.city;
      const resumeState = personal?.state;
      const resumeCountry = personal?.country;
      const resumeZipCode = personal?.zipCode || personal?.zipcode;
      const resumeLocation = personal?.location; // location string like "City, State, Country"

      const hasResumeLocation = resumeCity || resumeState || resumeCountry || resumeZipCode || resumeLocation;

      // If resume has NO location data at all -> Keep work experience location (don't touch form)
      if (!hasResumeLocation) {
        console.log('Resume has NO location data - keeping work experience location');
        return;
      }

      // Resume HAS location data -> Clear work exp location and use resume location
      console.log('Resume has location data - clearing work exp and setting resume location');
      this.candidatePostForm.get('city')?.patchValue(null);
      this.candidatePostForm.get('state')?.patchValue(null);
      this.candidatePostForm.get('country')?.patchValue(null);
      this.candidatePostForm.get('zipCode')?.patchValue(null);

      // PRIORITY 1: Use structured address fields from AI parsing
      if (resumeCity || resumeState || resumeCountry || resumeZipCode) {
        // Set city
        if (resumeCity) {
          console.log('Setting city:', resumeCity);
          this.candidatePostForm.get('city')?.patchValue(resumeCity);
        }

        // Check if "state" is actually a country code (e.g., "IN" for India)
        // Note: "CO", "CA", "TX" etc. are US state codes, not country codes
        const countryCodesOnly = ['IN', 'AU', 'GB', 'UK'];
        const stateValue = resumeState?.toUpperCase?.();
        const isStateActuallyCountry = stateValue && countryCodesOnly.includes(stateValue) && !resumeCountry;

        if (isStateActuallyCountry) {
          // "state" is actually a country code - use it as country, leave state empty
          console.log('Detected state as country code:', stateValue);
          const countryCode = stateValue === 'UK' ? 'GB' : stateValue;
          this.candidatePostForm.get('country')?.patchValue(countryCode);
          this.countryChosen = countryCode;
        } else {
          // Set state normally
          if (resumeState) {
            console.log('Setting state:', resumeState);
            this.candidatePostForm.get('state')?.patchValue(resumeState);
          }
          // Set country
          if (resumeCountry) {
            const countryCode = this.mapCountryToCode(resumeCountry);
            console.log('Setting country:', resumeCountry, '-> mapped to:', countryCode);
            if (countryCode) {
              this.candidatePostForm.get('country')?.patchValue(countryCode);
              this.countryChosen = countryCode;
            } else if (resumeCountry.length === 2) {
              this.candidatePostForm.get('country')?.patchValue(resumeCountry.toUpperCase());
              this.countryChosen = resumeCountry.toUpperCase();
            }
          }
        }

        // Set zipCode
        if (resumeZipCode) {
          console.log('Setting zipCode:', resumeZipCode);
          this.candidatePostForm.get('zipCode')?.patchValue(resumeZipCode);
        }

        console.log('Location set from structured fields. Final values:', {
          city: this.candidatePostForm.get('city')?.value,
          state: this.candidatePostForm.get('state')?.value,
          country: this.candidatePostForm.get('country')?.value,
          zipCode: this.candidatePostForm.get('zipCode')?.value
        });
        return;
      }

      // PRIORITY 2: Parse from location string if available
      if (resumeLocation) {
        console.log('Parsing location string:', resumeLocation);
        const locationParts = resumeLocation.split(',').map((p: string) => p.trim());
        if (locationParts.length >= 1 && locationParts[0]) {
          this.candidatePostForm.get('city')?.patchValue(locationParts[0]);
        }
        if (locationParts.length >= 2 && locationParts[1]) {
          this.candidatePostForm.get('state')?.patchValue(locationParts[1]);
        }
        if (locationParts.length >= 3 && locationParts[2]) {
          const countryCode = this.mapCountryToCode(locationParts[2]);
          if (countryCode) {
            this.candidatePostForm.get('country')?.patchValue(countryCode);
            this.countryChosen = countryCode;
          }
        }
        console.log('Location parsed from string');
        return;
      }

    } catch (error) {
      console.error('Error in setLocationFromData:', error);
    }
  }

  // Helper method to map country names to country codes
  private mapCountryToCode(country: string): string {
    if (!country) return '';
    const countryLower = country.toLowerCase().trim();

    const mappings: { [key: string]: string[] } = {
      'US': ['usa', 'united states', 'america', 'u.s.', 'u.s.a.'],
      'IN': ['india'],
      'CA': ['canada'],
      'AU': ['australia'],
      'GB': ['uk', 'united kingdom', 'britain', 'england']
    };

    for (const [code, aliases] of Object.entries(mappings)) {
      if (aliases.some(alias => countryLower.includes(alias))) {
        return code;
      }
    }

    // If country string is already a code, return it
    if (country.length === 2) {
      return country.toUpperCase();
    }

    return ''; // Return empty, NOT default 'US'
  }

  /**
   * Normalize payType to match UI expected values (Title Case)
   * API may return lowercase values like "hourly", UI expects "Hourly"
   */
  private normalizePayType(payType: string): string {
    if (!payType) return null;
    const normalized = payType.toLowerCase();
    // Valid values: Hourly, Daily, Weekly, Monthly, Yearly
    if (normalized === 'hourly' || normalized === 'hr') return 'Hourly';
    if (normalized === 'daily') return 'Daily';
    if (normalized === 'weekly') return 'Weekly';
    if (normalized === 'monthly') return 'Monthly';
    if (normalized === 'yearly' || normalized === 'annual') return 'Yearly';
    return payType; // Return as-is if not recognized
  }

  // Save parsed resume data to backend
  saveParsedResumeDataToBackend(candidateId: string) {
    if (!this.parsedResumeData || !candidateId) {
      console.log('No parsed data or candidate ID available');
      return;
    }

    console.log('Saving parsed resume data for candidate:', candidateId);

    // Save Work Experience
    if (this.parsedResumeData.experience && this.parsedResumeData.experience.length > 0) {
      this.saveParsedWorkExperience(candidateId);
    }

    // Save Education
    if (this.parsedResumeData.education && this.parsedResumeData.education.length > 0) {
      this.saveParsedEducation(candidateId);
    }

    // Save Certifications
    if (this.parsedResumeData.certifications && this.parsedResumeData.certifications.length > 0) {
      this.saveParsedCertifications(candidateId);
    }
  }

  // Save parsed work experience
  saveParsedWorkExperience(candidateId: string) {
    const experiences = this.parsedResumeData.experience;

    experiences.forEach((exp, index) => {
      // Use mapper service to format the payload
      const payload = this.resumeDataMapper.formatWorkExperienceForBackend(exp, candidateId, index,this.countryList);

      console.log(`Saving work experience ${index + 1}:`, payload);

      this.api.updatePut('candidates/updateCandidateWorkExperience', payload).subscribe(
        (res) => {
          console.log(`Work experience ${index + 1} saved successfully:`, res);
        },
        (error) => {
          console.error(`Error saving work experience ${index + 1}:`, error);
        }
      );
    });
  }

  // Save parsed education
  saveParsedEducation(candidateId: string) {
    const educations = this.parsedResumeData.education;
    console.log('saveParsedEducation - All education data:', educations);
    console.log('saveParsedEducation - All experience data:', this.parsedResumeData.experience);

    // Get first job year from experience data
    let firstJobYear = null;
    if (this.parsedResumeData.experience && this.parsedResumeData.experience.length > 0) {
      let earliestYear = new Date().getFullYear();

      this.parsedResumeData.experience.forEach(exp => {
        console.log('Checking experience:', exp);
        if (exp.start_date) {
          console.log('Experience start_date:', exp.start_date);
          const yearMatch = exp.start_date.match(/\d{4}/);
          if (yearMatch) {
            const year = parseInt(yearMatch[0]);
            if (year < earliestYear) {
              earliestYear = year;
            }
          }
        }
      });

      if (earliestYear < new Date().getFullYear()) {
        firstJobYear = earliestYear;
        console.log('First job year found:', firstJobYear);
      }
    }

    educations.forEach((edu, index) => {
      // Use mapper service to format the payload
      const payload = this.resumeDataMapper.formatEducationForBackend(
        edu,
        candidateId,
        index,
        this.parsedResumeData.education,
        firstJobYear
      );

      console.log(`Saving education ${index + 1}:`, payload);

      this.api.updatePut('candidates/updateCandidateEducationalDetail', payload).subscribe(
        (res) => {
          console.log(`Education ${index + 1} saved successfully:`, res);
        },
        (error) => {
          console.error(`Error saving education ${index + 1}:`, error);
        }
      );
    });
  }

  // Save parsed certifications
  saveParsedCertifications(candidateId: string) {
    const certifications = this.parsedResumeData.certifications;

    certifications.forEach((cert) => {
      // Use mapper service to format the payload
      const payload = this.resumeDataMapper.formatCertificationForBackend(cert, candidateId);

      console.log('Saving certification:', payload);

      this.api.updatePut('candidates/updateCandidateCertifications', payload).subscribe(
        (res) => {
          console.log('Certification saved successfully:', res);
        },
        (error) => {
          console.error('Error saving certification:', error);
        }
      );
    });
  }

  // Clear parsed data
  clearParsedData() {
    this.parsedResumeData = null;
    this.showParsedDetails = false;
    this.parseSuccess = false;
    this.parseFailed = false;
    this.isParsing = false;
  }

  // Get total skills count
  getTotalSkillsCount(): number {
    if (!this.parsedResumeData?.skills) return 0;
    const skills = this.parsedResumeData.skills;
    let count = 0;
    if (skills.technical_skills) count += skills.technical_skills.length;
    if (skills.languages) count += skills.languages.length;
    if (skills.frameworks) count += skills.frameworks.length;
    if (skills.tools) count += skills.tools.length;
    if (skills.databases) count += skills.databases.length;
    if (skills.soft_skills) count += skills.soft_skills.length;
    return count;
  }

  // Calculate total experience
  calculateTotalExperience(experiences: any[]): number {
    if (!experiences || experiences.length === 0) return 0;

    let totalMonths = 0;
    experiences.forEach(exp => {
      if (exp.start_date) {
        const startYear = parseInt(exp.start_date.match(/\d{4}/)?.[0] || '0');
        const endYear = exp.end_date && !exp.end_date.toLowerCase().includes('present')
          ? parseInt(exp.end_date.match(/\d{4}/)?.[0] || new Date().getFullYear().toString())
          : new Date().getFullYear();

        if (startYear > 0) {
          totalMonths += (endYear - startYear) * 12;
        }
      }
    });

    return Math.floor(totalMonths / 12);
  }

  // ============================================
  // RESUME PARSING METHODS - END
  // ============================================

}




